import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  ActivityId: any;
  ClusterId: any;
  /** The `DateTime` scalar type represents a date and time. `DateTime` expects timestamps to be formatted in accordance with the [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) standard. */
  DateTime: any;
  ElementId: any;
  InviteCodeId: any;
  IpAddressId: any;
  Long: any;
  /** The `Seconds` scalar type represents a period of time represented as the total number of seconds in range [-922337203685, 922337203685]. */
  Seconds: any;
  TagId: any;
  UserId: any;
  UsernameId: any;
};



export type AcceptCollaborationInput = {
  code: Scalars['String'];
  userId?: Maybe<Scalars['UserId']>;
};

/** Activity details */
export type Activity = ActivityInterface & {
  __typename?: 'Activity';
  /** Activity identifier */
  id: Scalars['ActivityId'];
  /** Activity owner identifier */
  ownerId?: Maybe<Scalars['UserId']>;
  /** Is element ready to display */
  isRead: Scalars['Boolean'];
  /** Timestamp the activity was created */
  createdAt: Scalars['DateTime'];
};


export type ActivityInterface = {
  /** Activity identifier */
  id: Scalars['ActivityId'];
  /** Activity owner identifier */
  ownerId?: Maybe<Scalars['UserId']>;
  /** Is element ready to display */
  isRead: Scalars['Boolean'];
  /** Timestamp the activity was created */
  createdAt: Scalars['DateTime'];
};

/** List of activities */
export type ActivityList = {
  __typename?: 'ActivityList';
  items: Array<ActivityInterface>;
  meta: ListMetadata;
};

export type ActivityListFilters = {
  ownerId?: Maybe<Scalars['UserId']>;
};

export type ActivityMutationGroup = {
  __typename?: 'ActivityMutationGroup';
  markAllAsRead?: Maybe<MutationResponse>;
};


export type ActivityMutationGroupMarkAllAsReadArgs = {
  input: MarkAllAsReadInput;
};

export type AddBannedUsernamesInput = {
  usernames: Array<Scalars['String']>;
};

export type AddClusterToFeaturedInput = {
  clusterId: Scalars['ClusterId'];
};

export type AddElementToFeaturedInput = {
  elementId: Scalars['ElementId'];
};

export type AddElementToOnboardingInput = {
  elementId: Scalars['ElementId'];
};

export type AddElementsToClusterInput = {
  userId: Scalars['UserId'];
  elementIds: Array<Scalars['ElementId']>;
  clusterId: Scalars['ClusterId'];
};

export type AddMethodInput = {
  userId: Scalars['UserId'];
  sourceId: Scalars['String'];
};

export type AddPremiumUsernamesInput = {
  usernames: Array<Scalars['String']>;
};

export type AddTagInput = {
  tagName?: Maybe<Scalars['String']>;
  tagId?: Maybe<Scalars['TagId']>;
  elementId: Scalars['ElementId'];
  assignerId: Scalars['UserId'];
};

export type AdminDeleteClustersInput = {
  clusterIds: Array<Scalars['ClusterId']>;
};

export type AdminDeleteElementsInput = {
  elementIds: Array<Scalars['ElementId']>;
};

export type AdminMutationGroup = {
  __typename?: 'AdminMutationGroup';
  loginAsAdmin?: Maybe<AuthMutationResponse>;
  disallowIpAddress?: Maybe<IpAddress>;
  allowIpAddress?: Maybe<MutationResponse>;
  deleteElements?: Maybe<MutationResponse>;
  deleteClusters?: Maybe<MutationResponse>;
  deleteUser?: Maybe<MutationResponse>;
  setPremiumSubscription?: Maybe<User>;
  setAdminSubscriptionForUsersCreatedBeforeDate?: Maybe<MutationResponse>;
  grantAdminRole?: Maybe<MutationResponse>;
  banUser?: Maybe<MutationResponse>;
  unbanUser?: Maybe<MutationResponse>;
};


export type AdminMutationGroupLoginAsAdminArgs = {
  input: LoginAsAdminInput;
};


export type AdminMutationGroupDisallowIpAddressArgs = {
  input: DisallowIpAddressInput;
};


export type AdminMutationGroupAllowIpAddressArgs = {
  input: AllowIpAddressInput;
};


export type AdminMutationGroupDeleteElementsArgs = {
  input: AdminDeleteElementsInput;
};


export type AdminMutationGroupDeleteClustersArgs = {
  input: AdminDeleteClustersInput;
};


export type AdminMutationGroupDeleteUserArgs = {
  input: DeleteProfileInput;
};


export type AdminMutationGroupSetPremiumSubscriptionArgs = {
  input: SetPremiumSubscriptionInput;
};


export type AdminMutationGroupSetAdminSubscriptionForUsersCreatedBeforeDateArgs = {
  input: SetAdminSubscriptionForUsersCreatedBeforeDateInput;
};


export type AdminMutationGroupGrantAdminRoleArgs = {
  input: GrantAdminRoleInput;
};


export type AdminMutationGroupBanUserArgs = {
  input: BanUserInput;
};


export type AdminMutationGroupUnbanUserArgs = {
  input: UnbanUserInput;
};

export enum AdminRole {
  Unspecified = 'UNSPECIFIED',
  Admin = 'ADMIN'
}

export type AllowIpAddressInput = {
  id: Scalars['IpAddressId'];
};

/** Article element details */
export type ArticleElement = ElementInterface & {
  __typename?: 'ArticleElement';
  /** Element identifier */
  id: Scalars['ElementId'];
  /** Element owner identifier */
  ownerId?: Maybe<Scalars['UserId']>;
  /** Element url - original source of content */
  url?: Maybe<Scalars['String']>;
  /** Element text */
  text?: Maybe<Scalars['String']>;
  /** Is element process to retrieve article/image metadata information */
  isProcessed: Scalars['Boolean'];
  /** Type of element */
  type: ElementType;
  /** Element processing state */
  processingState: ElementProcessingState;
  /** Is element NSFW content */
  isNotSafeForWork?: Maybe<Scalars['Boolean']>;
  /** Element deeplink for sharing */
  shareUrl?: Maybe<Scalars['String']>;
  /** Number of reports to Element */
  reportsCounter: Scalars['Int'];
  /** Is element ready to display */
  isReady: Scalars['Boolean'];
  /** Is element url editable */
  isUrlEditable: Scalars['Boolean'];
  /** Timestamp of the last Element update */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Timestamp of the last Element update */
  createdAt?: Maybe<Scalars['DateTime']>;
  /**
   * Element video url
   * @deprecated Use video object instead
   */
  videoUrl?: Maybe<Scalars['String']>;
  /** Currently used only for Instagram or Twitter */
  video?: Maybe<Video>;
  /** Element image */
  image?: Maybe<Image>;
  /** @deprecated Use userTags and systemTags instead */
  tags?: Maybe<ElementTagList>;
  userTags: Array<Scalars['String']>;
  /** List of computer vision tags */
  computerVisionTags?: Maybe<Array<Scalars['String']>>;
  topConnections?: Maybe<ClusterList>;
  topUserConnections?: Maybe<UserPublicProfileList>;
  numberOfConnections: Scalars['Int'];
  isConnectedByUser: Scalars['Boolean'];
  /** Owner details */
  owner?: Maybe<UserPublicProfile>;
  hasConnectionWithCluster: Scalars['Boolean'];
  /** Color list */
  colors?: Maybe<Array<Scalars['String']>>;
  originalClusterId?: Maybe<Scalars['ClusterId']>;
  isFeatured: Scalars['Boolean'];
  isOnboarding: Scalars['Boolean'];
  oldestConnectionToPublicCluster?: Maybe<ElementConnection>;
  isSavedToLibrary: Scalars['Boolean'];
  /** Article title */
  articleTitle?: Maybe<Scalars['String']>;
  /** Article description */
  description?: Maybe<Scalars['String']>;
};


/** Article element details */
export type ArticleElementTagsArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Article element details */
export type ArticleElementUserTagsArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Article element details */
export type ArticleElementTopConnectionsArgs = {
  userId?: Maybe<Scalars['UserId']>;
  meta?: Maybe<ListMetadataInput>;
};


/** Article element details */
export type ArticleElementTopUserConnectionsArgs = {
  userId?: Maybe<Scalars['UserId']>;
  meta?: Maybe<ListMetadataInput>;
};


/** Article element details */
export type ArticleElementNumberOfConnectionsArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Article element details */
export type ArticleElementIsConnectedByUserArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Article element details */
export type ArticleElementHasConnectionWithClusterArgs = {
  clusterId?: Maybe<Scalars['ClusterId']>;
  input?: Maybe<ClusterGetInput>;
};


/** Article element details */
export type ArticleElementOriginalClusterIdArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Article element details */
export type ArticleElementIsSavedToLibraryArgs = {
  userId?: Maybe<Scalars['UserId']>;
};

export type AuthMutationGroup = {
  __typename?: 'AuthMutationGroup';
  register?: Maybe<AuthMutationResponse>;
  registerWithWaitlistSkip?: Maybe<AuthMutationResponse>;
  registerWithInviteCode?: Maybe<AuthMutationResponse>;
  login?: Maybe<AuthMutationResponse>;
  logout?: Maybe<MutationResponse>;
  requestPasswordReset?: Maybe<MutationResponse>;
  resetPassword?: Maybe<MutationResponse>;
  onboard?: Maybe<AuthMutationResponse>;
  changePassword?: Maybe<MutationResponse>;
  setPassword?: Maybe<MutationResponse>;
  refreshAccessToken?: Maybe<AuthMutationResponse>;
  startNewSession?: Maybe<AuthMutationResponse>;
  authenticateWithIdentityProvider?: Maybe<AuthMutationResponse>;
  authenticateWithIdentityProviderWithInviteCode?: Maybe<AuthMutationResponse>;
  loginWithIdentityProvider?: Maybe<AuthMutationResponse>;
  editProfilePhoto?: Maybe<User>;
  setIsSubscribedToNewsletter?: Maybe<User>;
  requestProfileDeletion?: Maybe<MutationResponse>;
  confirmProfileDeletion?: Maybe<MutationResponse>;
  editProfile?: Maybe<User>;
  editUsername?: Maybe<User>;
  setIsNotSafeForWorkAllowed?: Maybe<User>;
  confirmEmail?: Maybe<MutationResponse>;
};


export type AuthMutationGroupRegisterArgs = {
  input: RegisterInput;
};


export type AuthMutationGroupRegisterWithWaitlistSkipArgs = {
  input: RegisterWithWaitlistSkipInput;
};


export type AuthMutationGroupRegisterWithInviteCodeArgs = {
  input: RegisterWithInviteCodeInput;
};


export type AuthMutationGroupLoginArgs = {
  input: LoginInput;
};


export type AuthMutationGroupRequestPasswordResetArgs = {
  input: RequestPasswordResetInput;
};


export type AuthMutationGroupResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type AuthMutationGroupOnboardArgs = {
  input: OnboardInput;
};


export type AuthMutationGroupChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type AuthMutationGroupSetPasswordArgs = {
  input: SetPasswordInput;
};


export type AuthMutationGroupRefreshAccessTokenArgs = {
  input?: Maybe<RefreshAccessTokenInput>;
};


export type AuthMutationGroupAuthenticateWithIdentityProviderArgs = {
  input: AuthenticateWithIdentityProviderInput;
};


export type AuthMutationGroupAuthenticateWithIdentityProviderWithInviteCodeArgs = {
  input: AuthenticateWithIdentityProviderWithInviteCodeInput;
};


export type AuthMutationGroupLoginWithIdentityProviderArgs = {
  input: LoginWithIdentityProviderInput;
};


export type AuthMutationGroupEditProfilePhotoArgs = {
  input: EditProfilePhotoInput;
};


export type AuthMutationGroupSetIsSubscribedToNewsletterArgs = {
  input: SetIsSubscribedToNewsletterInput;
};


export type AuthMutationGroupRequestProfileDeletionArgs = {
  input: DeleteProfileInput;
};


export type AuthMutationGroupConfirmProfileDeletionArgs = {
  input: ConfirmDeletionInput;
};


export type AuthMutationGroupEditProfileArgs = {
  input: EditProfileInput;
};


export type AuthMutationGroupEditUsernameArgs = {
  input: EditUsernameInput;
};


export type AuthMutationGroupSetIsNotSafeForWorkAllowedArgs = {
  input: SetIsNotSafeForWorkAllowedInput;
};


export type AuthMutationGroupConfirmEmailArgs = {
  input: ConfirmEmailInput;
};

export type AuthMutationResponse = {
  __typename?: 'AuthMutationResponse';
  /** Access Token */
  accessToken: Scalars['String'];
  /** Refresh Token */
  refreshToken: Scalars['String'];
  user: User;
};

export type AuthenticateWithIdentityProviderInput = {
  identityProviderType: IdentityProviderType;
  platformType: PlatformType;
  token: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type AuthenticateWithIdentityProviderWithInviteCodeInput = {
  identityProviderType: IdentityProviderType;
  platformType: PlatformType;
  token: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  inviteCode?: Maybe<Scalars['String']>;
};

export type BanUserInput = {
  userId: Scalars['UserId'];
};

/** Banned username details */
export type BannedUsername = {
  __typename?: 'BannedUsername';
  /** Banned username identifier */
  id?: Maybe<Scalars['UsernameId']>;
  /** Banned username */
  username: Scalars['String'];
};

/** List of banned usernames */
export type BannedUsernameList = {
  __typename?: 'BannedUsernameList';
  items: Array<BannedUsername>;
  meta: ListMetadata;
};

export type BannedUsernamesListFiltersInput = {
  searchTerm?: Maybe<Scalars['String']>;
};

export type BlockOtherUserInput = {
  userId: Scalars['UserId'];
  userToBlockId: Scalars['UserId'];
};

export type CancelSubscriptionInput = {
  userId: Scalars['UserId'];
};

export type ChangeClusterVisibilityInput = {
  userId: Scalars['UserId'];
  clusterId: Scalars['ClusterId'];
  isVisible: Scalars['Boolean'];
};

export type ChangePasswordInput = {
  userId: Scalars['UserId'];
  password: Scalars['String'];
  newPassword: Scalars['String'];
};

/** Cluster details */
export type Cluster = {
  __typename?: 'Cluster';
  /** Cluster identifier */
  id: Scalars['ClusterId'];
  /** Cluster name */
  name: Scalars['String'];
  /** Timestamp of the last Cluster update */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Url to cluster's cover image */
  coverImageUrl?: Maybe<Scalars['String']>;
  /** Is cluster cover image NSFW content */
  isCoverImageNotSafeForWork: Scalars['Boolean'];
  /** Identifier of cluster's cover image */
  coverImageElementId?: Maybe<Scalars['ElementId']>;
  /** Hash of cluster's cover image */
  coverImageHash?: Maybe<Scalars['String']>;
  /** Is cluster private or publicly available */
  isPrivate: Scalars['Boolean'];
  /** Cluster owner identifier */
  ownerId: Scalars['UserId'];
  /** Cluster deeplink for sharing */
  shareUrl?: Maybe<Scalars['String']>;
  /** Cluster slug */
  slug: Scalars['String'];
  /** Cluster description */
  description?: Maybe<Scalars['String']>;
  /** Url of cluster's cover animated image converted to mp4 format */
  coverImageMp4Url?: Maybe<Scalars['String']>;
  numberOfElements: Scalars['Int'];
  /** Owner details */
  owner: UserPublicProfile;
  /** @deprecated Use newestElements or elements in root with provided clusterId filter */
  elements: ElementList;
  /** List of newest cluster collaborators */
  newestCollaborators: NewestCollaboratorList;
  /** List of cluster collaborators */
  collaborators: CollaboratorList;
  /** List of collaboration invites for not signed up users */
  collaborationInvites: CollaborationInviteList;
  /** List of cluster collaborators and invites */
  collaboratorsOrInvites: CollaboratorOrInviteList;
  hasConnections?: Maybe<Scalars['Boolean']>;
  isFollowed?: Maybe<Scalars['Boolean']>;
  isCollaborator?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  followersCount: Scalars['Int'];
  searchCollaborators: SearchCollaboratorList;
  followers: UserPublicProfileList;
  collaboratorsCount: Scalars['Int'];
  oldestCollaborator?: Maybe<Collaborator>;
  isFeatured: Scalars['Boolean'];
  /** List of newest elements in cluster */
  newestElements: Array<ElementInterface>;
  /** Cluster cover image */
  coverImage?: Maybe<Image>;
};


/** Cluster details */
export type ClusterElementsArgs = {
  meta?: Maybe<ListMetadataInput>;
};


/** Cluster details */
export type ClusterNewestCollaboratorsArgs = {
  numberOfCollaborators: Scalars['Int'];
};


/** Cluster details */
export type ClusterCollaboratorsArgs = {
  meta?: Maybe<ListMetadataInput>;
};


/** Cluster details */
export type ClusterCollaborationInvitesArgs = {
  meta?: Maybe<ListMetadataInput>;
};


/** Cluster details */
export type ClusterCollaboratorsOrInvitesArgs = {
  filters?: Maybe<CollaboratorOrInviteListFiltersInput>;
  meta?: Maybe<ListMetadataInput>;
};


/** Cluster details */
export type ClusterHasConnectionsArgs = {
  elementIds: Array<Scalars['ElementId']>;
};


/** Cluster details */
export type ClusterIsFollowedArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Cluster details */
export type ClusterIsCollaboratorArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Cluster details */
export type ClusterIsVisibleArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Cluster details */
export type ClusterSearchCollaboratorsArgs = {
  searchTerm?: Maybe<Scalars['String']>;
  meta?: Maybe<ListMetadataInput>;
};


/** Cluster details */
export type ClusterFollowersArgs = {
  meta?: Maybe<ListMetadataInput>;
};


/** Cluster details */
export type ClusterNewestElementsArgs = {
  numberOfElements: Scalars['Int'];
};

export type ClusterCard = {
  __typename?: 'ClusterCard';
  id: Scalars['ClusterId'];
  name: Scalars['String'];
  slug: Scalars['String'];
  url: Scalars['String'];
  isPrivate: Scalars['Boolean'];
  numberOfElements: Scalars['Int'];
  coverImage?: Maybe<CoverImage>;
};

/** Cluster Collaborate Activity details */
export type ClusterCollaborateActivity = ActivityInterface & {
  __typename?: 'ClusterCollaborateActivity';
  /** Activity identifier */
  id: Scalars['ActivityId'];
  /** Activity owner identifier */
  ownerId?: Maybe<Scalars['UserId']>;
  /** Is element ready to display */
  isRead: Scalars['Boolean'];
  /** Timestamp the activity was created */
  createdAt: Scalars['DateTime'];
  /** Number of connected elements */
  numberOfConnectedElements?: Maybe<Scalars['Long']>;
  /** Collaborator details */
  collaborator?: Maybe<UserPublicProfile>;
  /** Cluster details */
  cluster?: Maybe<Cluster>;
};

/** Cluster create activity details */
export type ClusterCreateActivity = ActivityInterface & {
  __typename?: 'ClusterCreateActivity';
  /** Activity identifier */
  id: Scalars['ActivityId'];
  /** Activity owner identifier */
  ownerId?: Maybe<Scalars['UserId']>;
  /** Is element ready to display */
  isRead: Scalars['Boolean'];
  /** Timestamp the activity was created */
  createdAt: Scalars['DateTime'];
  /** Creator details */
  creator?: Maybe<UserPublicProfile>;
  /** Cluster details */
  cluster?: Maybe<Cluster>;
};

/** Cluster Follow Activity details */
export type ClusterFollowActivity = ActivityInterface & {
  __typename?: 'ClusterFollowActivity';
  /** Activity identifier */
  id: Scalars['ActivityId'];
  /** Activity owner identifier */
  ownerId?: Maybe<Scalars['UserId']>;
  /** Is element ready to display */
  isRead: Scalars['Boolean'];
  /** Timestamp the activity was created */
  createdAt: Scalars['DateTime'];
  /** Number of cluster follows */
  numberOfFollows?: Maybe<Scalars['Long']>;
  /** Last Follower details */
  lastFollower?: Maybe<UserPublicProfile>;
  /** Cluster details */
  cluster?: Maybe<Cluster>;
};

export type ClusterGetInput = {
  slug: Scalars['String'];
  ownerUsername: Scalars['String'];
};


/** List of cluster ids */
export type ClusterIds = {
  __typename?: 'ClusterIds';
  ids: Array<Scalars['ClusterId']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** List of clusters */
export type ClusterList = {
  __typename?: 'ClusterList';
  items: Array<Cluster>;
  meta: ListMetadata;
};

export type ClusterListFilters = {
  ownerId?: Maybe<Scalars['UserId']>;
  isPrivate?: Maybe<Scalars['Boolean']>;
  followerId?: Maybe<Scalars['UserId']>;
  isFeatured?: Maybe<Scalars['Boolean']>;
  searchTerm?: Maybe<Scalars['String']>;
};

export type ClusterListSuggestedFilters = {
  userId?: Maybe<Scalars['UserId']>;
};

export type ClusterMutationGroup = {
  __typename?: 'ClusterMutationGroup';
  create?: Maybe<Cluster>;
  createDuringOnboarding?: Maybe<Cluster>;
  edit?: Maybe<Cluster>;
  addElementsToCluster?: Maybe<MutationResponse>;
  addElementsToClusterDuringOnboarding?: Maybe<MutationResponse>;
  followCluster?: Maybe<Cluster>;
  unfollowCluster?: Maybe<MutationResponse>;
  deleteCluster?: Maybe<MutationResponse>;
  inviteCollaborator?: Maybe<MutationResponse>;
  inviteCollaborators?: Maybe<MutationResponse>;
  revokeCollaboratorInvite?: Maybe<MutationResponse>;
  revokeCollaboratorInvites?: Maybe<MutationResponse>;
  acceptCollaboration?: Maybe<CollaborationInviteConfirmation>;
  declineCollaboration?: Maybe<MutationResponse>;
  deleteCollaborator?: Maybe<MutationResponse>;
  deleteCollaborators?: Maybe<MutationResponse>;
  leaveCollaboration?: Maybe<MutationResponse>;
  editFeatured?: Maybe<ClusterList>;
  addToFeatured?: Maybe<MutationResponse>;
  removeFromFeatured?: Maybe<MutationResponse>;
  followAllUserClusters?: Maybe<ClusterIds>;
  unfollowAllUserClusters?: Maybe<ClusterIds>;
  reorderElement: MutationResponse;
};


export type ClusterMutationGroupCreateArgs = {
  input: CreateClusterInput;
};


export type ClusterMutationGroupCreateDuringOnboardingArgs = {
  input: CreateClusterInput;
};


export type ClusterMutationGroupEditArgs = {
  input: EditClusterInput;
};


export type ClusterMutationGroupAddElementsToClusterArgs = {
  input: AddElementsToClusterInput;
};


export type ClusterMutationGroupAddElementsToClusterDuringOnboardingArgs = {
  input: AddElementsToClusterInput;
};


export type ClusterMutationGroupFollowClusterArgs = {
  input: FollowClusterInput;
};


export type ClusterMutationGroupUnfollowClusterArgs = {
  input: UnfollowClusterInput;
};


export type ClusterMutationGroupDeleteClusterArgs = {
  input: DeleteClusterInput;
};


export type ClusterMutationGroupInviteCollaboratorArgs = {
  input: InviteCollaboratorInput;
};


export type ClusterMutationGroupInviteCollaboratorsArgs = {
  input: InviteCollaboratorsInput;
};


export type ClusterMutationGroupRevokeCollaboratorInviteArgs = {
  input: RevokeCollaboratorInviteInput;
};


export type ClusterMutationGroupRevokeCollaboratorInvitesArgs = {
  input: RevokeCollaboratorInvitesInput;
};


export type ClusterMutationGroupAcceptCollaborationArgs = {
  input: AcceptCollaborationInput;
};


export type ClusterMutationGroupDeclineCollaborationArgs = {
  input: DeclineCollaborationInput;
};


export type ClusterMutationGroupDeleteCollaboratorArgs = {
  input: DeleteCollaboratorInput;
};


export type ClusterMutationGroupDeleteCollaboratorsArgs = {
  input: DeleteCollaboratorsInput;
};


export type ClusterMutationGroupLeaveCollaborationArgs = {
  input: LeaveCollaborationInput;
};


export type ClusterMutationGroupEditFeaturedArgs = {
  input: EditFeaturedClustersInput;
};


export type ClusterMutationGroupAddToFeaturedArgs = {
  input: AddClusterToFeaturedInput;
};


export type ClusterMutationGroupRemoveFromFeaturedArgs = {
  input: RemoveClusterFromFeaturedInput;
};


export type ClusterMutationGroupFollowAllUserClustersArgs = {
  input: FollowAllUserClustersInput;
};


export type ClusterMutationGroupUnfollowAllUserClustersArgs = {
  input: UnfollowAllUserClustersInput;
};


export type ClusterMutationGroupReorderElementArgs = {
  input: ReorderClusterElementInput;
};

export enum ClusterSortField {
  Unspecified = 'UNSPECIFIED',
  HasConnection = 'HAS_CONNECTION',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT',
  CreatedAt = 'CREATED_AT',
  ElementCount = 'ELEMENT_COUNT',
  FollowerCount = 'FOLLOWER_COUNT'
}

/** Clusters Followed By User Activity details */
export type ClustersFollowedByUserActivity = ActivityInterface & {
  __typename?: 'ClustersFollowedByUserActivity';
  /** Activity identifier */
  id: Scalars['ActivityId'];
  /** Activity owner identifier */
  ownerId?: Maybe<Scalars['UserId']>;
  /** Is element ready to display */
  isRead: Scalars['Boolean'];
  /** Timestamp the activity was created */
  createdAt: Scalars['DateTime'];
  /** Number of followed clusters */
  numberOfClusters?: Maybe<Scalars['Long']>;
  /** Follower details */
  follower?: Maybe<UserPublicProfile>;
};

/** Collaboration invite details */
export type CollaborationInvite = {
  __typename?: 'CollaborationInvite';
  /** Email used to invite collaborator */
  email: Scalars['String'];
};

/** Collaboration Invite Activity details */
export type CollaborationInviteActivity = ActivityInterface & {
  __typename?: 'CollaborationInviteActivity';
  /** Activity identifier */
  id: Scalars['ActivityId'];
  /** Activity owner identifier */
  ownerId?: Maybe<Scalars['UserId']>;
  /** Is element ready to display */
  isRead: Scalars['Boolean'];
  /** Timestamp the activity was created */
  createdAt: Scalars['DateTime'];
  /** Activity invite code */
  inviteCode?: Maybe<Scalars['String']>;
  /** Inviter details */
  inviter?: Maybe<UserPublicProfile>;
  /** Cluster details */
  cluster?: Maybe<Cluster>;
};

/** Collaboration invite confirmation details */
export type CollaborationInviteConfirmation = {
  __typename?: 'CollaborationInviteConfirmation';
  /** Cluster identifier */
  clusterId: Scalars['ClusterId'];
  /** Is user registered */
  isRegistered: Scalars['Boolean'];
  /** Cluster owner username */
  ownerUsername: Scalars['String'];
  /** Cluster slug */
  slug: Scalars['String'];
};

/** List of collaboration invites for not signed up users collaborators */
export type CollaborationInviteList = {
  __typename?: 'CollaborationInviteList';
  items: Array<CollaborationInvite>;
  meta: ListMetadata;
};

/** Collaborator details */
export type Collaborator = {
  __typename?: 'Collaborator';
  /** Collaborator unique identifier */
  userId: Scalars['UserId'];
  /** Is collaborator an owner */
  isOwner?: Maybe<Scalars['Boolean']>;
  /** Status of collaborator */
  status: CollaboratorStatus;
  /** Collaborator details */
  collaboratorPublicProfile?: Maybe<UserPublicProfile>;
};

/** List of users collaborators */
export type CollaboratorList = {
  __typename?: 'CollaboratorList';
  items: Array<Collaborator>;
  meta: ListMetadata;
};

export type CollaboratorOrCollaborationInvite = Collaborator | CollaborationInvite;

/** List of users collaborators */
export type CollaboratorOrInviteList = {
  __typename?: 'CollaboratorOrInviteList';
  items: Array<CollaboratorOrCollaborationInvite>;
  meta: ListMetadata;
};

export type CollaboratorOrInviteListFiltersInput = {
  status?: Maybe<CollaboratorStatus>;
};

export enum CollaboratorStatus {
  Unspecified = 'UNSPECIFIED',
  Invited = 'INVITED',
  Accepted = 'ACCEPTED'
}

export type ConfirmDeletionInput = {
  token: Scalars['String'];
};

export type ConfirmEmailInput = {
  token: Scalars['String'];
};

export type ConnectableCluster = {
  __typename?: 'ConnectableCluster';
  cluster: ClusterCard;
  hasConnections: Scalars['Boolean'];
};

export type ConnectableClusterList = {
  __typename?: 'ConnectableClusterList';
  items: Array<ConnectableCluster>;
  meta: ListMetadata;
};

export type ContactInput = {
  email: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  grantsPremium?: Maybe<Scalars['Boolean']>;
  grantsPremiumDays?: Maybe<Scalars['Int']>;
};

/** History of user's search activity in user's library */
export type ContextualSearchHistory = {
  __typename?: 'ContextualSearchHistory';
  ownerId: Scalars['UserId'];
  entries: Array<ContextualSearchHistoryEntry>;
};

export type ContextualSearchHistoryEntry = SearchTermContextualSearchHistoryEntry | VisitedClusterContextualSearchHistoryEntry;

export type ContextualSearchHistoryMutationGroup = {
  __typename?: 'ContextualSearchHistoryMutationGroup';
  rememberSearchTerm: MutationResponse;
  rememberVisitedCluster: MutationResponse;
  forgetAll: MutationResponse;
  forgetSearchTerm: MutationResponse;
  forgetVisitedCluster: MutationResponse;
};


export type ContextualSearchHistoryMutationGroupRememberSearchTermArgs = {
  input: RememberContextualSearchHistorySearchTermInput;
};


export type ContextualSearchHistoryMutationGroupRememberVisitedClusterArgs = {
  input: RememberContextualSearchHistoryVisitedClusterInput;
};


export type ContextualSearchHistoryMutationGroupForgetAllArgs = {
  input: ForgetAllContextualSearchHistoryInput;
};


export type ContextualSearchHistoryMutationGroupForgetSearchTermArgs = {
  input: ForgetContextualSearchHistorySearchTermInput;
};


export type ContextualSearchHistoryMutationGroupForgetVisitedClusterArgs = {
  input: ForgetContextualSearchHistoryVisitedClusterInput;
};

export enum CountryCode {
  Unspecified = 'UNSPECIFIED',
  Af = 'AF',
  Ax = 'AX',
  Al = 'AL',
  Dz = 'DZ',
  As = 'AS',
  Ad = 'AD',
  Ao = 'AO',
  Ai = 'AI',
  Aq = 'AQ',
  Ag = 'AG',
  Ar = 'AR',
  Am = 'AM',
  Aw = 'AW',
  Au = 'AU',
  At = 'AT',
  Az = 'AZ',
  Bs = 'BS',
  Bh = 'BH',
  Bd = 'BD',
  Bb = 'BB',
  By = 'BY',
  Be = 'BE',
  Bz = 'BZ',
  Bj = 'BJ',
  Bm = 'BM',
  Bt = 'BT',
  Bo = 'BO',
  Bq = 'BQ',
  Ba = 'BA',
  Bw = 'BW',
  Bv = 'BV',
  Br = 'BR',
  Io = 'IO',
  Bn = 'BN',
  Bg = 'BG',
  Bf = 'BF',
  Bi = 'BI',
  Cv = 'CV',
  Kh = 'KH',
  Cm = 'CM',
  Ca = 'CA',
  Ky = 'KY',
  Cf = 'CF',
  Td = 'TD',
  Cl = 'CL',
  Cn = 'CN',
  Cx = 'CX',
  Cc = 'CC',
  Co = 'CO',
  Km = 'KM',
  Cg = 'CG',
  Cd = 'CD',
  Ck = 'CK',
  Cr = 'CR',
  Ci = 'CI',
  Hr = 'HR',
  Cu = 'CU',
  Cw = 'CW',
  Cy = 'CY',
  Cz = 'CZ',
  Dk = 'DK',
  Dj = 'DJ',
  Dm = 'DM',
  Do = 'DO',
  Ec = 'EC',
  Eg = 'EG',
  Sv = 'SV',
  Gq = 'GQ',
  Er = 'ER',
  Ee = 'EE',
  Et = 'ET',
  Fk = 'FK',
  Fo = 'FO',
  Fj = 'FJ',
  Fi = 'FI',
  Fr = 'FR',
  Gf = 'GF',
  Pf = 'PF',
  Tf = 'TF',
  Ga = 'GA',
  Gm = 'GM',
  Ge = 'GE',
  De = 'DE',
  Gh = 'GH',
  Gi = 'GI',
  Gr = 'GR',
  Gl = 'GL',
  Gd = 'GD',
  Gp = 'GP',
  Gu = 'GU',
  Gt = 'GT',
  Gg = 'GG',
  Gn = 'GN',
  Gw = 'GW',
  Gy = 'GY',
  Ht = 'HT',
  Hm = 'HM',
  Va = 'VA',
  Hn = 'HN',
  Hk = 'HK',
  Hu = 'HU',
  Is = 'IS',
  In = 'IN',
  Id = 'ID',
  Ir = 'IR',
  Iq = 'IQ',
  Ie = 'IE',
  Im = 'IM',
  Il = 'IL',
  It = 'IT',
  Jm = 'JM',
  Jp = 'JP',
  Je = 'JE',
  Jo = 'JO',
  Kz = 'KZ',
  Ke = 'KE',
  Ki = 'KI',
  Kp = 'KP',
  Kr = 'KR',
  Kw = 'KW',
  Kg = 'KG',
  La = 'LA',
  Lv = 'LV',
  Lb = 'LB',
  Ls = 'LS',
  Lr = 'LR',
  Ly = 'LY',
  Li = 'LI',
  Lt = 'LT',
  Lu = 'LU',
  Mo = 'MO',
  Mk = 'MK',
  Mg = 'MG',
  Mw = 'MW',
  My = 'MY',
  Mv = 'MV',
  Ml = 'ML',
  Mt = 'MT',
  Mh = 'MH',
  Mq = 'MQ',
  Mr = 'MR',
  Mu = 'MU',
  Yt = 'YT',
  Mx = 'MX',
  Fm = 'FM',
  Md = 'MD',
  Mc = 'MC',
  Mn = 'MN',
  Me = 'ME',
  Ms = 'MS',
  Ma = 'MA',
  Mz = 'MZ',
  Mm = 'MM',
  Na = 'NA',
  Nr = 'NR',
  Np = 'NP',
  Nl = 'NL',
  Nc = 'NC',
  Nz = 'NZ',
  Ni = 'NI',
  Ne = 'NE',
  Ng = 'NG',
  Nu = 'NU',
  Nf = 'NF',
  Mp = 'MP',
  No = 'NO',
  Om = 'OM',
  Pk = 'PK',
  Pw = 'PW',
  Ps = 'PS',
  Pa = 'PA',
  Pg = 'PG',
  Py = 'PY',
  Pe = 'PE',
  Ph = 'PH',
  Pn = 'PN',
  Pl = 'PL',
  Pt = 'PT',
  Pr = 'PR',
  Qa = 'QA',
  Re = 'RE',
  Ro = 'RO',
  Ru = 'RU',
  Rw = 'RW',
  Bl = 'BL',
  Sh = 'SH',
  Kn = 'KN',
  Lc = 'LC',
  Mf = 'MF',
  Pm = 'PM',
  Vc = 'VC',
  Ws = 'WS',
  Sm = 'SM',
  St = 'ST',
  Sa = 'SA',
  Sn = 'SN',
  Rs = 'RS',
  Sc = 'SC',
  Sl = 'SL',
  Sg = 'SG',
  Sx = 'SX',
  Sk = 'SK',
  Si = 'SI',
  Sb = 'SB',
  So = 'SO',
  Za = 'ZA',
  Gs = 'GS',
  Ss = 'SS',
  Es = 'ES',
  Lk = 'LK',
  Sd = 'SD',
  Sr = 'SR',
  Sj = 'SJ',
  Sz = 'SZ',
  Se = 'SE',
  Ch = 'CH',
  Sy = 'SY',
  Tw = 'TW',
  Tj = 'TJ',
  Tz = 'TZ',
  Th = 'TH',
  Tl = 'TL',
  Tg = 'TG',
  Tk = 'TK',
  To = 'TO',
  Tt = 'TT',
  Tn = 'TN',
  Tr = 'TR',
  Tm = 'TM',
  Tc = 'TC',
  Tv = 'TV',
  Ug = 'UG',
  Ua = 'UA',
  Ae = 'AE',
  Gb = 'GB',
  Us = 'US',
  Um = 'UM',
  Uy = 'UY',
  Uz = 'UZ',
  Vu = 'VU',
  Ve = 'VE',
  Vn = 'VN',
  Vg = 'VG',
  Vi = 'VI',
  Wf = 'WF',
  Eh = 'EH',
  Ye = 'YE',
  Zm = 'ZM',
  Zw = 'ZW'
}

export type CoverImage = {
  __typename?: 'CoverImage';
  url: Scalars['String'];
  hash: Scalars['String'];
  isNotSafeForWork: Scalars['Boolean'];
};

export type CreateClusterInput = {
  userId: Scalars['UserId'];
  name: Scalars['String'];
  isPrivate: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
};

export type CreateElementInput = {
  userId: Scalars['UserId'];
  url?: Maybe<Scalars['String']>;
  sourceUrl?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  image?: Maybe<ImageInput>;
  videoS3ObjectKey?: Maybe<Scalars['String']>;
  clusterId?: Maybe<Scalars['ClusterId']>;
};

export type CreateInviteCodesInput = {
  contacts: Array<ContactInput>;
};

export type CreateInviteCodesWithoutEmailInput = {
  amount: Scalars['Int'];
};

export type CreateSubscriptionInput = {
  userId: Scalars['UserId'];
  priceId: Scalars['String'];
};

export type CreateTagInput = {
  tagName: Scalars['String'];
};

/** Credit card details */
export type CreditCard = {
  __typename?: 'CreditCard';
  /** Card identifier */
  id: Scalars['String'];
  /** Last four digits of credit card number */
  last4: Scalars['String'];
  /** Credit card expiry month */
  expiryMonth: Scalars['Int'];
  /** Credit card expiry year */
  expiryYear: Scalars['Int'];
  /** Is credit card default payment method */
  isDefault: Scalars['Boolean'];
  /** Credit card brand */
  brand: Scalars['String'];
};

export enum Currency {
  Unspecified = 'UNSPECIFIED',
  Aed = 'AED',
  Afn = 'AFN',
  All = 'ALL',
  Amd = 'AMD',
  Ang = 'ANG',
  Aoa = 'AOA',
  Ars = 'ARS',
  Aud = 'AUD',
  Awg = 'AWG',
  Azn = 'AZN',
  Bam = 'BAM',
  Bbd = 'BBD',
  Bdt = 'BDT',
  Bgn = 'BGN',
  Bif = 'BIF',
  Bmd = 'BMD',
  Bnd = 'BND',
  Bob = 'BOB',
  Brl = 'BRL',
  Bsd = 'BSD',
  Bwp = 'BWP',
  Bzd = 'BZD',
  Cad = 'CAD',
  Cdf = 'CDF',
  Chf = 'CHF',
  Clp = 'CLP',
  Cny = 'CNY',
  Cop = 'COP',
  Crc = 'CRC',
  Cve = 'CVE',
  Czk = 'CZK',
  Djf = 'DJF',
  Dkk = 'DKK',
  Dop = 'DOP',
  Dzd = 'DZD',
  Egp = 'EGP',
  Etb = 'ETB',
  Eur = 'EUR',
  Fjd = 'FJD',
  Fkp = 'FKP',
  Gbp = 'GBP',
  Gel = 'GEL',
  Gip = 'GIP',
  Gmd = 'GMD',
  Gnf = 'GNF',
  Gtq = 'GTQ',
  Gyd = 'GYD',
  Hkd = 'HKD',
  Hnl = 'HNL',
  Hrk = 'HRK',
  Htg = 'HTG',
  Huf = 'HUF',
  Idr = 'IDR',
  Ils = 'ILS',
  Inr = 'INR',
  Isk = 'ISK',
  Jmd = 'JMD',
  Jpy = 'JPY',
  Kes = 'KES',
  Kgs = 'KGS',
  Khr = 'KHR',
  Kmf = 'KMF',
  Krw = 'KRW',
  Kyd = 'KYD',
  Kzt = 'KZT',
  Lak = 'LAK',
  Lbp = 'LBP',
  Lkr = 'LKR',
  Lrd = 'LRD',
  Lsl = 'LSL',
  Mad = 'MAD',
  Mdl = 'MDL',
  Mga = 'MGA',
  Mkd = 'MKD',
  Mmk = 'MMK',
  Mnt = 'MNT',
  Mop = 'MOP',
  Mur = 'MUR',
  Mvr = 'MVR',
  Mwk = 'MWK',
  Mxn = 'MXN',
  Myr = 'MYR',
  Mzn = 'MZN',
  Nad = 'NAD',
  Ngn = 'NGN',
  Nio = 'NIO',
  Nok = 'NOK',
  Npr = 'NPR',
  Nzd = 'NZD',
  Pab = 'PAB',
  Pen = 'PEN',
  Pgk = 'PGK',
  Php = 'PHP',
  Pkr = 'PKR',
  Pln = 'PLN',
  Pyg = 'PYG',
  Qar = 'QAR',
  Ron = 'RON',
  Rsd = 'RSD',
  Rub = 'RUB',
  Rwf = 'RWF',
  Sar = 'SAR',
  Sbd = 'SBD',
  Scr = 'SCR',
  Sek = 'SEK',
  Sgd = 'SGD',
  Shp = 'SHP',
  Sll = 'SLL',
  Srd = 'SRD',
  Std = 'STD',
  Szl = 'SZL',
  Thb = 'THB',
  Tjs = 'TJS',
  Top = 'TOP',
  Try = 'TRY',
  Ttd = 'TTD',
  Twd = 'TWD',
  Tzs = 'TZS',
  Uah = 'UAH',
  Ugx = 'UGX',
  Usd = 'USD',
  Uyu = 'UYU',
  Uzs = 'UZS',
  Vnd = 'VND',
  Vuv = 'VUV',
  Wst = 'WST',
  Xaf = 'XAF',
  Xcd = 'XCD',
  Xof = 'XOF',
  Xpf = 'XPF',
  Yer = 'YER',
  Zar = 'ZAR',
  Zmw = 'ZMW'
}


export type DeclineCollaborationInput = {
  code: Scalars['String'];
};

export type DecreaseMaxUsageCountForUserInput = {
  amount: Scalars['Int'];
  userId: Scalars['UserId'];
};

export type DeleteClusterInput = {
  id: Scalars['ClusterId'];
  userId: Scalars['UserId'];
};

export type DeleteCollaboratorInput = {
  userId: Scalars['UserId'];
  clusterId: Scalars['ClusterId'];
};

export type DeleteCollaboratorsInput = {
  userIds: Array<Scalars['UserId']>;
  clusterId: Scalars['ClusterId'];
};

export type DeleteElementsInput = {
  userId: Scalars['UserId'];
  elementIds: Array<Scalars['ElementId']>;
};

export type DeleteInviteCodesInput = {
  ids: Array<Scalars['InviteCodeId']>;
};

export type DeleteMethodInput = {
  userId: Scalars['UserId'];
  cardId: Scalars['String'];
};

export type DeletePremiumUsernamesInput = {
  ids: Array<Scalars['UsernameId']>;
};

export type DeleteProfileInput = {
  userId: Scalars['UserId'];
};

export type DeregisterPushNotificationTokenInput = {
  userId: Scalars['UserId'];
  token: Scalars['String'];
};

export type DisallowIpAddressInput = {
  address: Scalars['String'];
};

export type DisconnectElementsFromClusterInput = {
  userId: Scalars['UserId'];
  clusterId: Scalars['ClusterId'];
  elementIds: Array<Scalars['ElementId']>;
};

export type EditClusterInput = {
  id: Scalars['ClusterId'];
  name: Scalars['String'];
  coverImageElementId?: Maybe<Scalars['ElementId']>;
  isPrivate: Scalars['Boolean'];
  coverImageCropRectX?: Maybe<Scalars['Int']>;
  coverImageCropRectY?: Maybe<Scalars['Int']>;
  coverImageCropWidth?: Maybe<Scalars['Int']>;
  coverImageCropHeight?: Maybe<Scalars['Int']>;
  coverImageUrl?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type EditElementTextInput = {
  elementId: Scalars['ElementId'];
  text: Scalars['String'];
};

export type EditElementUrlInput = {
  elementId: Scalars['ElementId'];
  url: Scalars['String'];
};

export type EditElementsConnectionsToClustersInput = {
  userId: Scalars['UserId'];
  elementIds: Array<Scalars['ElementId']>;
  clusterIdsToConnect: Array<Scalars['ClusterId']>;
  clusterIdsToDisconnect: Array<Scalars['ClusterId']>;
};

export type EditFeaturedClustersInput = {
  clusterIds: Array<Scalars['ClusterId']>;
};

export type EditFeaturedElementsInput = {
  elementIds: Array<Scalars['ElementId']>;
};

export type EditOnboardingElementsInput = {
  elementIds: Array<Scalars['ElementId']>;
};

export type EditPlatformSettingsInput = {
  privacyPolicy: Scalars['String'];
  privacyTerms: Scalars['String'];
  signUpElementId: Scalars['ElementId'];
  loginElementId: Scalars['ElementId'];
  adminEmail: Scalars['String'];
  defaultInviteCodeMaxUsageCount?: Maybe<Scalars['Int']>;
};

export type EditProfileInput = {
  userId: Scalars['UserId'];
  name: Scalars['String'];
  email: Scalars['String'];
  websiteUrl?: Maybe<Scalars['String']>;
};

export type EditProfilePhotoInput = {
  userId: Scalars['UserId'];
  avatarUrl: Scalars['String'];
};

export type EditUsernameInput = {
  userId: Scalars['UserId'];
  username: Scalars['String'];
};

/** Element details */
export type Element = ElementInterface & {
  __typename?: 'Element';
  /** Element identifier */
  id: Scalars['ElementId'];
  /** Element owner identifier */
  ownerId?: Maybe<Scalars['UserId']>;
  /** Element url - original source of content */
  url?: Maybe<Scalars['String']>;
  /** Element text */
  text?: Maybe<Scalars['String']>;
  /** Is element process to retrieve article/image metadata information */
  isProcessed: Scalars['Boolean'];
  /** Type of element */
  type: ElementType;
  /** Element processing state */
  processingState: ElementProcessingState;
  /** Is element NSFW content */
  isNotSafeForWork?: Maybe<Scalars['Boolean']>;
  /** Element deeplink for sharing */
  shareUrl?: Maybe<Scalars['String']>;
  /** Number of reports to Element */
  reportsCounter: Scalars['Int'];
  /** Is element ready to display */
  isReady: Scalars['Boolean'];
  /** Is element url editable */
  isUrlEditable: Scalars['Boolean'];
  /** Timestamp of the last Element update */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Timestamp of the last Element update */
  createdAt?: Maybe<Scalars['DateTime']>;
  /**
   * Element video url
   * @deprecated Use video object instead
   */
  videoUrl?: Maybe<Scalars['String']>;
  /** Currently used only for Instagram or Twitter */
  video?: Maybe<Video>;
  /** Element image */
  image?: Maybe<Image>;
  /** @deprecated Use userTags and systemTags instead */
  tags?: Maybe<ElementTagList>;
  userTags: Array<Scalars['String']>;
  /** List of computer vision tags */
  computerVisionTags?: Maybe<Array<Scalars['String']>>;
  topConnections?: Maybe<ClusterList>;
  topUserConnections?: Maybe<UserPublicProfileList>;
  numberOfConnections: Scalars['Int'];
  isConnectedByUser: Scalars['Boolean'];
  /** Owner details */
  owner?: Maybe<UserPublicProfile>;
  hasConnectionWithCluster: Scalars['Boolean'];
  /** Color list */
  colors?: Maybe<Array<Scalars['String']>>;
  originalClusterId?: Maybe<Scalars['ClusterId']>;
  isFeatured: Scalars['Boolean'];
  isOnboarding: Scalars['Boolean'];
  oldestConnectionToPublicCluster?: Maybe<ElementConnection>;
  isSavedToLibrary: Scalars['Boolean'];
};


/** Element details */
export type ElementTagsArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Element details */
export type ElementUserTagsArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Element details */
export type ElementTopConnectionsArgs = {
  userId?: Maybe<Scalars['UserId']>;
  meta?: Maybe<ListMetadataInput>;
};


/** Element details */
export type ElementTopUserConnectionsArgs = {
  userId?: Maybe<Scalars['UserId']>;
  meta?: Maybe<ListMetadataInput>;
};


/** Element details */
export type ElementNumberOfConnectionsArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Element details */
export type ElementIsConnectedByUserArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Element details */
export type ElementHasConnectionWithClusterArgs = {
  clusterId?: Maybe<Scalars['ClusterId']>;
  input?: Maybe<ClusterGetInput>;
};


/** Element details */
export type ElementOriginalClusterIdArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Element details */
export type ElementIsSavedToLibraryArgs = {
  userId?: Maybe<Scalars['UserId']>;
};

/** Element Connection details */
export type ElementConnection = {
  __typename?: 'ElementConnection';
  /** Cluster identifier */
  clusterId: Scalars['ClusterId'];
  /** Element identifier */
  elementId: Scalars['ElementId'];
  /** Collaborator details */
  collaborator?: Maybe<UserPublicProfile>;
  /** Cluster details */
  cluster: Cluster;
};

/** Element Connection Activity details */
export type ElementConnectionActivity = ActivityInterface & {
  __typename?: 'ElementConnectionActivity';
  /** Activity identifier */
  id: Scalars['ActivityId'];
  /** Activity owner identifier */
  ownerId?: Maybe<Scalars['UserId']>;
  /** Is element ready to display */
  isRead: Scalars['Boolean'];
  /** Timestamp the activity was created */
  createdAt: Scalars['DateTime'];
  /** Number of users that connected element */
  numberOfConnections?: Maybe<Scalars['Long']>;
  /** Last user that connected details */
  lastUserThatConnected?: Maybe<UserPublicProfile>;
  /** Element details */
  element?: Maybe<ElementInterface>;
};

/** List of element connection */
export type ElementConnectionList = {
  __typename?: 'ElementConnectionList';
  items: Array<ElementConnection>;
  meta: ListMetadata;
};

export enum ElementContentTypeFilter {
  Unspecified = 'UNSPECIFIED',
  Image = 'IMAGE',
  Video = 'VIDEO',
  Link = 'LINK',
  Tweet = 'TWEET',
  Note = 'NOTE'
}


export type ElementInterface = {
  /** Element identifier */
  id: Scalars['ElementId'];
  /** Element owner identifier */
  ownerId?: Maybe<Scalars['UserId']>;
  /** Element url - original source of content */
  url?: Maybe<Scalars['String']>;
  /** Element text */
  text?: Maybe<Scalars['String']>;
  /** Is element process to retrieve article/image metadata information */
  isProcessed: Scalars['Boolean'];
  /** Type of element - Quote element type is deprecated */
  type: ElementType;
  /** Element processing state */
  processingState: ElementProcessingState;
  /** Is element NSFW content */
  isNotSafeForWork?: Maybe<Scalars['Boolean']>;
  /** Element deeplink for sharing */
  shareUrl?: Maybe<Scalars['String']>;
  /** Number of reports to Element */
  reportsCounter: Scalars['Int'];
  /** Is element ready to display */
  isReady: Scalars['Boolean'];
  /** Is element url editable */
  isUrlEditable: Scalars['Boolean'];
  /** Timestamp of the last Element update */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Timestamp of the last Element update */
  createdAt?: Maybe<Scalars['DateTime']>;
  /**
   * Element video url
   * @deprecated Use video object instead
   */
  videoUrl?: Maybe<Scalars['String']>;
  video?: Maybe<Video>;
  /** Element image */
  image?: Maybe<Image>;
  tags?: Maybe<ElementTagList>;
  userTags: Array<Scalars['String']>;
  /** List of computer vision tags */
  computerVisionTags?: Maybe<Array<Scalars['String']>>;
  topConnections?: Maybe<ClusterList>;
  topUserConnections?: Maybe<UserPublicProfileList>;
  numberOfConnections?: Maybe<Scalars['Int']>;
  isConnectedByUser?: Maybe<Scalars['Boolean']>;
  owner?: Maybe<UserPublicProfile>;
  hasConnectionWithCluster: Scalars['Boolean'];
  /** Color list */
  colors?: Maybe<Array<Scalars['String']>>;
  originalClusterId?: Maybe<Scalars['ClusterId']>;
  isFeatured: Scalars['Boolean'];
  isOnboarding: Scalars['Boolean'];
  oldestConnectionToPublicCluster?: Maybe<ElementConnection>;
  isSavedToLibrary: Scalars['Boolean'];
};


export type ElementInterfaceTagsArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


export type ElementInterfaceUserTagsArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


export type ElementInterfaceTopConnectionsArgs = {
  userId?: Maybe<Scalars['UserId']>;
  meta?: Maybe<ListMetadataInput>;
};


export type ElementInterfaceTopUserConnectionsArgs = {
  userId?: Maybe<Scalars['UserId']>;
  meta?: Maybe<ListMetadataInput>;
};


export type ElementInterfaceNumberOfConnectionsArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


export type ElementInterfaceIsConnectedByUserArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


export type ElementInterfaceHasConnectionWithClusterArgs = {
  clusterId?: Maybe<Scalars['ClusterId']>;
  input?: Maybe<ClusterGetInput>;
};


export type ElementInterfaceOriginalClusterIdArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


export type ElementInterfaceIsSavedToLibraryArgs = {
  userId?: Maybe<Scalars['UserId']>;
};

/** List of elements */
export type ElementList = {
  __typename?: 'ElementList';
  items: Array<ElementInterface>;
  meta: ListMetadata;
};

export type ElementListFilters = {
  userId?: Maybe<Scalars['UserId']>;
  clusterId?: Maybe<Scalars['ClusterId']>;
  clusterGetInput?: Maybe<ClusterGetInput>;
  isFeatured?: Maybe<Scalars['Boolean']>;
  isUnsorted?: Maybe<Scalars['Boolean']>;
  hasImage?: Maybe<Scalars['Boolean']>;
  isReported?: Maybe<Scalars['Boolean']>;
  isPublic?: Maybe<Scalars['Boolean']>;
  isOnboarding?: Maybe<Scalars['Boolean']>;
  searchTerm?: Maybe<Scalars['String']>;
  contentType?: Maybe<ElementContentTypeFilter>;
  elementId?: Maybe<Scalars['ElementId']>;
};

export type ElementMutationGroup = {
  __typename?: 'ElementMutationGroup';
  addTag?: Maybe<ElementTag>;
  /** @deprecated Use removeUserTag or removeComputerVisionTag depending on your scenario */
  removeTag?: Maybe<MutationResponse>;
  addUserTag?: Maybe<MutationResponse>;
  removeUserTag?: Maybe<MutationResponse>;
  removeComputerVisionTag?: Maybe<MutationResponse>;
  create?: Maybe<ElementInterface>;
  deleteElements?: Maybe<MutationResponse>;
  disconnectElementsFromCluster?: Maybe<MutationResponse>;
  editElementsConnectionsToClusters?: Maybe<MutationResponse>;
  editFeatured?: Maybe<ElementList>;
  editOnboarding?: Maybe<ElementList>;
  editElementText?: Maybe<Element>;
  editElementUrl?: Maybe<ElementInterface>;
  report?: Maybe<Element>;
  resetReportsCounter?: Maybe<MutationResponse>;
  addToFeatured?: Maybe<MutationResponse>;
  removeFromFeatured?: Maybe<MutationResponse>;
  setCover: MutationResponse;
  enforceNotSafeForWork?: Maybe<MutationResponse>;
  addToOnboarding: MutationResponse;
  removeFromOnboarding: MutationResponse;
};


export type ElementMutationGroupAddTagArgs = {
  input: AddTagInput;
};


export type ElementMutationGroupRemoveTagArgs = {
  input: RemoveTagInput;
};


export type ElementMutationGroupAddUserTagArgs = {
  input: RemoveUserTagInput;
};


export type ElementMutationGroupRemoveUserTagArgs = {
  input: RemoveUserTagInput;
};


export type ElementMutationGroupRemoveComputerVisionTagArgs = {
  input: RemoveComputerVisionTagInput;
};


export type ElementMutationGroupCreateArgs = {
  input: CreateElementInput;
};


export type ElementMutationGroupDeleteElementsArgs = {
  input: DeleteElementsInput;
};


export type ElementMutationGroupDisconnectElementsFromClusterArgs = {
  input: DisconnectElementsFromClusterInput;
};


export type ElementMutationGroupEditElementsConnectionsToClustersArgs = {
  input: EditElementsConnectionsToClustersInput;
};


export type ElementMutationGroupEditFeaturedArgs = {
  input: EditFeaturedElementsInput;
};


export type ElementMutationGroupEditOnboardingArgs = {
  input: EditOnboardingElementsInput;
};


export type ElementMutationGroupEditElementTextArgs = {
  input: EditElementTextInput;
};


export type ElementMutationGroupEditElementUrlArgs = {
  input: EditElementUrlInput;
};


export type ElementMutationGroupReportArgs = {
  input: ReportElementInput;
};


export type ElementMutationGroupResetReportsCounterArgs = {
  input: ResetElementReportsCounterInput;
};


export type ElementMutationGroupAddToFeaturedArgs = {
  input: AddElementToFeaturedInput;
};


export type ElementMutationGroupRemoveFromFeaturedArgs = {
  input: RemoveElementFromFeaturedInput;
};


export type ElementMutationGroupSetCoverArgs = {
  input: SetCoverInput;
};


export type ElementMutationGroupEnforceNotSafeForWorkArgs = {
  input: EnforceElementNotSafeForWorkInput;
};


export type ElementMutationGroupAddToOnboardingArgs = {
  input: AddElementToOnboardingInput;
};


export type ElementMutationGroupRemoveFromOnboardingArgs = {
  input: RemoveElementFromOnboardingInput;
};

export enum ElementProcessingState {
  Unspecified = 'UNSPECIFIED',
  InProgress = 'IN_PROGRESS',
  Staled = 'STALED',
  Processed = 'PROCESSED',
  Failed = 'FAILED',
  Started = 'STARTED',
  Finished = 'FINISHED'
}

export type ElementSortDefinitionInput = {
  sortField: ElementSortField;
  sortDirection: SortDirection;
};

export enum ElementSortField {
  Unspecified = 'UNSPECIFIED',
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT',
  ReportsCounter = 'REPORTS_COUNTER'
}

/** ElementTag details */
export type ElementTag = {
  __typename?: 'ElementTag';
  /** Tag */
  tag?: Maybe<Tag>;
  /** User that assigned tag */
  assignerId: Scalars['UserId'];
  /** Id of element tag is assigned to */
  elementId: Scalars['ElementId'];
  /** Is tag added by element processing */
  isSystemAssigned: Scalars['Boolean'];
  /** Can tag be deleted */
  canBeDeleted: Scalars['Boolean'];
};

/** List of element tags */
export type ElementTagList = {
  __typename?: 'ElementTagList';
  items: Array<ElementTag>;
  meta: ListMetadata;
};

export enum ElementType {
  Unspecified = 'UNSPECIFIED',
  Website = 'WEBSITE',
  Instagram = 'INSTAGRAM',
  Youtube = 'YOUTUBE',
  Spotify = 'SPOTIFY',
  Twitter = 'TWITTER',
  Article = 'ARTICLE',
  Text = 'TEXT',
  Product = 'PRODUCT',
  Upload = 'UPLOAD',
  FromUrl = 'FROM_URL',
  Quote = 'QUOTE',
  Movie = 'MOVIE',
  Pinterest = 'PINTEREST',
  ShortText = 'SHORT_TEXT',
  TikTok = 'TIK_TOK',
  Video = 'VIDEO'
}

export type EnforceElementNotSafeForWorkInput = {
  elementId: Scalars['ElementId'];
  isNotSafeForWork: Scalars['Boolean'];
};

export type FeedAdditionalItemsListFilters = {
  clusterId: Scalars['ClusterId'];
  collaboratorId: Scalars['UserId'];
  elementId: Scalars['ElementId'];
};

/** Feed of followed elements */
export type FeedItem = {
  __typename?: 'FeedItem';
  /** Cluster identifier */
  clusterId: Scalars['ClusterId'];
  /** Element identifier */
  elementId: Scalars['ElementId'];
  /** Elements count in feed item */
  elementsCounter: Scalars['Long'];
  /** Timestamp the element was added to the cluster */
  createdAt: Scalars['DateTime'];
  /** Collaborator details */
  collaborator?: Maybe<UserPublicProfile>;
  /** Cluster details */
  cluster?: Maybe<Cluster>;
  /** Element details */
  element?: Maybe<ElementInterface>;
};

/** List of followed elements */
export type FeedItemList = {
  __typename?: 'FeedItemList';
  items: Array<FeedItem>;
  meta: ListMetadata;
};

export type FeedItemListFilters = {
  userId: Scalars['UserId'];
};

export type FeedMutationGroup = {
  __typename?: 'FeedMutationGroup';
  setShowOwnedConnectionsInFeed?: Maybe<MutationResponse>;
};


export type FeedMutationGroupSetShowOwnedConnectionsInFeedArgs = {
  input: SetShowOwnedConnectionsInFeedInput;
};

export type FollowAllUserClustersInput = {
  userId: Scalars['UserId'];
  ownerId: Scalars['UserId'];
};

export type FollowClusterInput = {
  userId: Scalars['UserId'];
  clusterId: Scalars['ClusterId'];
};

export type ForgetAllContextualSearchHistoryInput = {
  ownerId: Scalars['UserId'];
};

export type ForgetAllGlobalSearchHistoryInput = {
  ownerId: Scalars['UserId'];
};

export type ForgetContextualSearchHistorySearchTermInput = {
  ownerId: Scalars['UserId'];
  searchTerm: Scalars['String'];
};

export type ForgetContextualSearchHistoryVisitedClusterInput = {
  ownerId: Scalars['UserId'];
  clusterId: Scalars['ClusterId'];
};

export type ForgetGlobalSearchHistorySearchTermInput = {
  ownerId: Scalars['UserId'];
  searchTerm: Scalars['String'];
};

export type ForgetGlobalSearchHistoryVisitedClusterInput = {
  ownerId: Scalars['UserId'];
  clusterId: Scalars['ClusterId'];
};

export type ForgetGlobalSearchHistoryVisitedUserInput = {
  ownerId: Scalars['UserId'];
  userId: Scalars['UserId'];
};

export type GenerateInviteCodesWithoutEmailInput = {
  amount: Scalars['Int'];
};

/** History of user's search activity in global search */
export type GlobalSearchHistory = {
  __typename?: 'GlobalSearchHistory';
  ownerId: Scalars['UserId'];
  entries: Array<GlobalSearchHistoryEntry>;
};

export type GlobalSearchHistoryEntry = SearchTermGlobalSearchHistoryEntry | VisitedClusterGlobalSearchHistoryEntry | VisitedUserGlobalSearchHistoryEntry;

export type GlobalSearchHistoryMutationGroup = {
  __typename?: 'GlobalSearchHistoryMutationGroup';
  rememberSearchTerm: MutationResponse;
  rememberVisitedCluster: MutationResponse;
  rememberVisitedUser: MutationResponse;
  forgetAll: MutationResponse;
  forgetSearchTerm: MutationResponse;
  forgetVisitedCluster: MutationResponse;
  forgetVisitedUser: MutationResponse;
};


export type GlobalSearchHistoryMutationGroupRememberSearchTermArgs = {
  input: RememberGlobalSearchHistorySearchTermInput;
};


export type GlobalSearchHistoryMutationGroupRememberVisitedClusterArgs = {
  input: RememberGlobalSearchHistoryVisitedClusterInput;
};


export type GlobalSearchHistoryMutationGroupRememberVisitedUserArgs = {
  input: RememberGlobalSearchHistoryVisitedUserInput;
};


export type GlobalSearchHistoryMutationGroupForgetAllArgs = {
  input: ForgetAllGlobalSearchHistoryInput;
};


export type GlobalSearchHistoryMutationGroupForgetSearchTermArgs = {
  input: ForgetGlobalSearchHistorySearchTermInput;
};


export type GlobalSearchHistoryMutationGroupForgetVisitedClusterArgs = {
  input: ForgetGlobalSearchHistoryVisitedClusterInput;
};


export type GlobalSearchHistoryMutationGroupForgetVisitedUserArgs = {
  input: ForgetGlobalSearchHistoryVisitedUserInput;
};

export type GrantAdminRoleInput = {
  userId: Scalars['UserId'];
};

export enum IdentityProviderType {
  Unspecified = 'UNSPECIFIED',
  Apple = 'APPLE',
  Google = 'GOOGLE'
}

export type Image = {
  __typename?: 'Image';
  /** Image url */
  url?: Maybe<Scalars['String']>;
  /** Image height */
  height?: Maybe<Scalars['Int']>;
  /** Image width */
  width?: Maybe<Scalars['Int']>;
  /** Image hash */
  hash?: Maybe<Scalars['String']>;
  /** Url of animated image converted to mp4 */
  mp4Url?: Maybe<Scalars['String']>;
  /** Url to thumbnail of an animated image */
  mp4ThumbnailUrl?: Maybe<Scalars['String']>;
  aspectRatio?: Maybe<Scalars['Float']>;
  scaledImages: Array<Maybe<Image>>;
  parametrizedImageUrls: Array<Scalars['String']>;
};


export type ImageScaledImagesArgs = {
  widths: Array<Scalars['Int']>;
};


export type ImageParametrizedImageUrlsArgs = {
  parameters: Array<ImageParametersInput>;
};

export type ImageInput = {
  url: Scalars['String'];
  width: Scalars['Int'];
  height: Scalars['Int'];
};

export type ImageParametersInput = {
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  minWidth?: Maybe<Scalars['Int']>;
  minHeight?: Maybe<Scalars['Int']>;
  maxWidth?: Maybe<Scalars['Int']>;
  maxHeight?: Maybe<Scalars['Int']>;
  fit?: Maybe<Scalars['String']>;
  auto?: Maybe<Scalars['String']>;
  crop?: Maybe<Scalars['String']>;
};

export type ImportMutationGroup = {
  __typename?: 'ImportMutationGroup';
  request?: Maybe<MutationResponse>;
  requestFromUrls?: Maybe<MutationResponse>;
};


export type ImportMutationGroupRequestArgs = {
  input: ImportRequestInputType;
};


export type ImportMutationGroupRequestFromUrlsArgs = {
  input: ImportRequestFromUrlsInputType;
};

export type ImportRequestFromUrlsInputType = {
  userId: Scalars['UserId'];
  sourceUrls: Array<Scalars['String']>;
  clusterId?: Maybe<Scalars['ClusterId']>;
};

export type ImportRequestInputType = {
  userId: Scalars['UserId'];
  sourceUrl: Scalars['String'];
  clusterId?: Maybe<Scalars['ClusterId']>;
};

export type IncreaseMaxUsageCountForUserInput = {
  amount: Scalars['Int'];
  userId: Scalars['UserId'];
};

export type IncreaseMaxUsageCountForUsersInput = {
  userIds: Array<Scalars['UserId']>;
  amount: Scalars['Int'];
};

export type IncreaseMaxUsageCountForUsersWithZeroInvitesLeftInput = {
  amount: Scalars['Int'];
};

export type IncreaseMaxUsageCountInput = {
  amount: Scalars['Int'];
};

export type IncrementElementsTabViewsCounterInput = {
  userId: Scalars['UserId'];
};

export enum InstagramContentAccessibility {
  Unspecified = 'UNSPECIFIED',
  Public = 'PUBLIC',
  Private = 'PRIVATE',
  Restricted = 'RESTRICTED'
}

/** Instagram element details */
export type InstagramElement = ElementInterface & {
  __typename?: 'InstagramElement';
  /** Element identifier */
  id: Scalars['ElementId'];
  /** Element owner identifier */
  ownerId?: Maybe<Scalars['UserId']>;
  /** Element url - original source of content */
  url?: Maybe<Scalars['String']>;
  /** Element text */
  text?: Maybe<Scalars['String']>;
  /** Is element process to retrieve article/image metadata information */
  isProcessed: Scalars['Boolean'];
  /** Type of element */
  type: ElementType;
  /** Element processing state */
  processingState: ElementProcessingState;
  /** Is element NSFW content */
  isNotSafeForWork?: Maybe<Scalars['Boolean']>;
  /** Element deeplink for sharing */
  shareUrl?: Maybe<Scalars['String']>;
  /** Number of reports to Element */
  reportsCounter: Scalars['Int'];
  /** Is element ready to display */
  isReady: Scalars['Boolean'];
  /** Is element url editable */
  isUrlEditable: Scalars['Boolean'];
  /** Timestamp of the last Element update */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Timestamp of the last Element update */
  createdAt?: Maybe<Scalars['DateTime']>;
  /**
   * Element video url
   * @deprecated Use video object instead
   */
  videoUrl?: Maybe<Scalars['String']>;
  /** Currently used only for Instagram or Twitter */
  video?: Maybe<Video>;
  /** Element image */
  image?: Maybe<Image>;
  /** @deprecated Use userTags and systemTags instead */
  tags?: Maybe<ElementTagList>;
  userTags: Array<Scalars['String']>;
  /** List of computer vision tags */
  computerVisionTags?: Maybe<Array<Scalars['String']>>;
  topConnections?: Maybe<ClusterList>;
  topUserConnections?: Maybe<UserPublicProfileList>;
  numberOfConnections: Scalars['Int'];
  isConnectedByUser: Scalars['Boolean'];
  /** Owner details */
  owner?: Maybe<UserPublicProfile>;
  hasConnectionWithCluster: Scalars['Boolean'];
  /** Color list */
  colors?: Maybe<Array<Scalars['String']>>;
  originalClusterId?: Maybe<Scalars['ClusterId']>;
  isFeatured: Scalars['Boolean'];
  isOnboarding: Scalars['Boolean'];
  oldestConnectionToPublicCluster?: Maybe<ElementConnection>;
  isSavedToLibrary: Scalars['Boolean'];
  /** Instagram post author name */
  authorName: Scalars['String'];
  /** Instagram post author full name */
  authorFullName?: Maybe<Scalars['String']>;
  /** Instagram post author profile picture url */
  authorProfilePictureUrl?: Maybe<Scalars['String']>;
  /** Instagram post caption */
  caption?: Maybe<Scalars['String']>;
  /** Instagram content accessibility */
  contentAccessibility: InstagramContentAccessibility;
  /** Instagram media */
  media?: Maybe<Array<Maybe<InstagramMedia>>>;
  /** Is Instagram reel */
  isReel: Scalars['Boolean'];
  /** Is Instagram carousel */
  isCarousel: Scalars['Boolean'];
  mux?: Maybe<Mux>;
};


/** Instagram element details */
export type InstagramElementTagsArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Instagram element details */
export type InstagramElementUserTagsArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Instagram element details */
export type InstagramElementTopConnectionsArgs = {
  userId?: Maybe<Scalars['UserId']>;
  meta?: Maybe<ListMetadataInput>;
};


/** Instagram element details */
export type InstagramElementTopUserConnectionsArgs = {
  userId?: Maybe<Scalars['UserId']>;
  meta?: Maybe<ListMetadataInput>;
};


/** Instagram element details */
export type InstagramElementNumberOfConnectionsArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Instagram element details */
export type InstagramElementIsConnectedByUserArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Instagram element details */
export type InstagramElementHasConnectionWithClusterArgs = {
  clusterId?: Maybe<Scalars['ClusterId']>;
  input?: Maybe<ClusterGetInput>;
};


/** Instagram element details */
export type InstagramElementOriginalClusterIdArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Instagram element details */
export type InstagramElementIsSavedToLibraryArgs = {
  userId?: Maybe<Scalars['UserId']>;
};

export type InstagramMedia = {
  __typename?: 'InstagramMedia';
  image?: Maybe<Image>;
  /**
   * Video url
   * @deprecated Use video object instead
   */
  videoUrl?: Maybe<Scalars['String']>;
  video?: Maybe<Video>;
  mux?: Maybe<Mux>;
  /** Media id */
  mediaId: Scalars['String'];
};

/** Invite Code */
export type InviteCode = {
  __typename?: 'InviteCode';
  /** Invite Code identifier */
  id: Scalars['InviteCodeId'];
  /** Email */
  email?: Maybe<Scalars['String']>;
  /** Value */
  value: Scalars['String'];
  /** Name */
  name?: Maybe<Scalars['String']>;
  /** Status */
  status?: Maybe<InviteCodeStatus>;
  /** GrantsPremium */
  grantsPremium: Scalars['Boolean'];
  /** UsageCount */
  usageCount?: Maybe<Scalars['Int']>;
  /** MaxUsageCount */
  maxUsageCount?: Maybe<Scalars['Int']>;
  /** InviterId */
  inviterId?: Maybe<Scalars['Long']>;
  /** Timestamp the invite code was created */
  createdAt: Scalars['DateTime'];
};

export type InviteCodeGenerateWithoutEmailResponse = {
  __typename?: 'InviteCodeGenerateWithoutEmailResponse';
  /** Created invite codes */
  inviteCodes: Array<Maybe<Scalars['String']>>;
};


/** List of invite codes */
export type InviteCodeList = {
  __typename?: 'InviteCodeList';
  items: Array<InviteCode>;
  meta: ListMetadata;
};

export type InviteCodeListFilters = {
  status?: Maybe<InviteCodeStatus>;
  searchTerm?: Maybe<Scalars['String']>;
  hasEmail?: Maybe<Scalars['Boolean']>;
};

export type InviteCodeMutationGroup = {
  __typename?: 'InviteCodeMutationGroup';
  create?: Maybe<MutationResponse>;
  createWithoutEmail?: Maybe<MutationResponse>;
  generateWithoutEmail?: Maybe<InviteCodeGenerateWithoutEmailResponse>;
  resend?: Maybe<MutationResponse>;
  delete?: Maybe<MutationResponse>;
  resendAll?: Maybe<MutationResponse>;
  /** Asynchronous */
  increaseMaxUsageCount?: Maybe<MutationResponse>;
  increaseMaxUsageCountForUsers?: Maybe<MutationResponse>;
  increaseMaxUsageCountForUsersWithZeroInvitesLeft?: Maybe<MutationResponse>;
  increaseMaxUsageCountForUser?: Maybe<MutationResponse>;
  decreaseMaxUsageCountForUser?: Maybe<MutationResponse>;
};


export type InviteCodeMutationGroupCreateArgs = {
  input: CreateInviteCodesInput;
};


export type InviteCodeMutationGroupCreateWithoutEmailArgs = {
  input: CreateInviteCodesWithoutEmailInput;
};


export type InviteCodeMutationGroupGenerateWithoutEmailArgs = {
  input: GenerateInviteCodesWithoutEmailInput;
};


export type InviteCodeMutationGroupResendArgs = {
  input: ResendInviteCodesEmailInput;
};


export type InviteCodeMutationGroupDeleteArgs = {
  input: DeleteInviteCodesInput;
};


export type InviteCodeMutationGroupIncreaseMaxUsageCountArgs = {
  input: IncreaseMaxUsageCountInput;
};


export type InviteCodeMutationGroupIncreaseMaxUsageCountForUsersArgs = {
  input: IncreaseMaxUsageCountForUsersInput;
};


export type InviteCodeMutationGroupIncreaseMaxUsageCountForUsersWithZeroInvitesLeftArgs = {
  input: IncreaseMaxUsageCountForUsersWithZeroInvitesLeftInput;
};


export type InviteCodeMutationGroupIncreaseMaxUsageCountForUserArgs = {
  input: IncreaseMaxUsageCountForUserInput;
};


export type InviteCodeMutationGroupDecreaseMaxUsageCountForUserArgs = {
  input: DecreaseMaxUsageCountForUserInput;
};

export type InviteCodeQueryGroup = {
  __typename?: 'InviteCodeQueryGroup';
  isValid?: Maybe<Scalars['Boolean']>;
};


export type InviteCodeQueryGroupIsValidArgs = {
  inviteCode?: Maybe<Scalars['String']>;
};

export type InviteCodeSortDefinitionInput = {
  sortField: InviteCodeSortField;
  sortDirection: SortDirection;
};

export enum InviteCodeSortField {
  Unspecified = 'UNSPECIFIED',
  Email = 'EMAIL',
  Status = 'STATUS',
  Id = 'ID',
  CreatedAt = 'CREATED_AT'
}

export enum InviteCodeStatus {
  Unspecified = 'UNSPECIFIED',
  Pending = 'PENDING',
  Accepted = 'ACCEPTED'
}

export type InviteCollaboratorInput = {
  email?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['UserId']>;
  clusterId: Scalars['ClusterId'];
};

export type InviteCollaboratorsInput = {
  inviteDataList?: Maybe<Array<Maybe<InviteDataInput>>>;
  clusterId: Scalars['ClusterId'];
};

export type InviteDataInput = {
  userId?: Maybe<Scalars['UserId']>;
  email?: Maybe<Scalars['String']>;
};

/** Invoice details */
export type Invoice = {
  __typename?: 'Invoice';
  /** Invoice identifier */
  id: Scalars['String'];
  /** Date of invoice creation */
  cratedAt?: Maybe<Scalars['DateTime']>;
  /** Price of subscription plan */
  amount?: Maybe<Money>;
};

/** List of invoices */
export type InvoiceList = {
  __typename?: 'InvoiceList';
  items: Array<Invoice>;
  meta: ListMetadata;
};

/** IP address details */
export type IpAddress = {
  __typename?: 'IpAddress';
  /** Id of IP address */
  id: Scalars['IpAddressId'];
  /** Ip address */
  address: Scalars['String'];
};


/** List IP addresses */
export type IpAddressList = {
  __typename?: 'IpAddressList';
  items: Array<IpAddress>;
  meta: ListMetadata;
};

export type JoinManyWaitlistInput = {
  emails: Array<Scalars['String']>;
};

export type JoinWaitlistInput = {
  email: Scalars['String'];
};

export type LeaveCollaborationInput = {
  userId: Scalars['UserId'];
  clusterId: Scalars['ClusterId'];
};

export type LibraryMutationGroup = {
  __typename?: 'LibraryMutationGroup';
  saveElements: MutationResponse;
};


export type LibraryMutationGroupSaveElementsArgs = {
  input: SaveLibraryElementsInput;
};

export type ListMetadata = {
  __typename?: 'ListMetadata';
  pageSize: Scalars['Int'];
  pageCursor?: Maybe<Scalars['String']>;
  nextPageCursor?: Maybe<Scalars['String']>;
  count: Scalars['Int'];
};

export type ListMetadataInput = {
  pageSize?: Maybe<Scalars['Int']>;
  pageCursor?: Maybe<Scalars['String']>;
};

export type LoginAsAdminInput = {
  identifier: Scalars['String'];
  password: Scalars['String'];
};

export type LoginInput = {
  identifier: Scalars['String'];
  password: Scalars['String'];
};

export type LoginWithIdentityProviderInput = {
  identityProviderType: IdentityProviderType;
  platformType: PlatformType;
  token: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};


export type MarkAllAsReadInput = {
  ownerId: Scalars['UserId'];
};

export type Money = {
  __typename?: 'Money';
  /** Currency of the value */
  currency: Currency;
  /** Amount of money */
  value: Scalars['String'];
};

/** Movie element details */
export type MovieElement = ElementInterface & {
  __typename?: 'MovieElement';
  /** Element identifier */
  id: Scalars['ElementId'];
  /** Element owner identifier */
  ownerId?: Maybe<Scalars['UserId']>;
  /** Element url - original source of content */
  url?: Maybe<Scalars['String']>;
  /** Element text */
  text?: Maybe<Scalars['String']>;
  /** Is element process to retrieve article/image metadata information */
  isProcessed: Scalars['Boolean'];
  /** Type of element */
  type: ElementType;
  /** Element processing state */
  processingState: ElementProcessingState;
  /** Is element NSFW content */
  isNotSafeForWork?: Maybe<Scalars['Boolean']>;
  /** Element deeplink for sharing */
  shareUrl?: Maybe<Scalars['String']>;
  /** Number of reports to Element */
  reportsCounter: Scalars['Int'];
  /** Is element ready to display */
  isReady: Scalars['Boolean'];
  /** Is element url editable */
  isUrlEditable: Scalars['Boolean'];
  /** Timestamp of the last Element update */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Timestamp of the last Element update */
  createdAt?: Maybe<Scalars['DateTime']>;
  /**
   * Element video url
   * @deprecated Use video object instead
   */
  videoUrl?: Maybe<Scalars['String']>;
  /** Currently used only for Instagram or Twitter */
  video?: Maybe<Video>;
  /** Element image */
  image?: Maybe<Image>;
  /** @deprecated Use userTags and systemTags instead */
  tags?: Maybe<ElementTagList>;
  userTags: Array<Scalars['String']>;
  /** List of computer vision tags */
  computerVisionTags?: Maybe<Array<Scalars['String']>>;
  topConnections?: Maybe<ClusterList>;
  topUserConnections?: Maybe<UserPublicProfileList>;
  numberOfConnections: Scalars['Int'];
  isConnectedByUser: Scalars['Boolean'];
  /** Owner details */
  owner?: Maybe<UserPublicProfile>;
  hasConnectionWithCluster: Scalars['Boolean'];
  /** Color list */
  colors?: Maybe<Array<Scalars['String']>>;
  originalClusterId?: Maybe<Scalars['ClusterId']>;
  isFeatured: Scalars['Boolean'];
  isOnboarding: Scalars['Boolean'];
  oldestConnectionToPublicCluster?: Maybe<ElementConnection>;
  isSavedToLibrary: Scalars['Boolean'];
  /** Movie title */
  movieTitle?: Maybe<Scalars['String']>;
  /** Movie year */
  movieYear?: Maybe<Scalars['String']>;
  /** Movie rating */
  movieRating?: Maybe<Scalars['String']>;
};


/** Movie element details */
export type MovieElementTagsArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Movie element details */
export type MovieElementUserTagsArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Movie element details */
export type MovieElementTopConnectionsArgs = {
  userId?: Maybe<Scalars['UserId']>;
  meta?: Maybe<ListMetadataInput>;
};


/** Movie element details */
export type MovieElementTopUserConnectionsArgs = {
  userId?: Maybe<Scalars['UserId']>;
  meta?: Maybe<ListMetadataInput>;
};


/** Movie element details */
export type MovieElementNumberOfConnectionsArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Movie element details */
export type MovieElementIsConnectedByUserArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Movie element details */
export type MovieElementHasConnectionWithClusterArgs = {
  clusterId?: Maybe<Scalars['ClusterId']>;
  input?: Maybe<ClusterGetInput>;
};


/** Movie element details */
export type MovieElementOriginalClusterIdArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Movie element details */
export type MovieElementIsSavedToLibraryArgs = {
  userId?: Maybe<Scalars['UserId']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  auth?: Maybe<AuthMutationGroup>;
  inviteCode?: Maybe<InviteCodeMutationGroup>;
  cluster?: Maybe<ClusterMutationGroup>;
  element?: Maybe<ElementMutationGroup>;
  userProfile?: Maybe<UserProfileMutationGroup>;
  tag?: Maybe<TagMutationGroup>;
  payment?: Maybe<PaymentMutationGroup>;
  subscription?: Maybe<SubscriptionMutationGroup>;
  admin?: Maybe<AdminMutationGroup>;
  platformSettings?: Maybe<PlatformSettingsMutationGroup>;
  username?: Maybe<UsernameMutationGroup>;
  activity?: Maybe<ActivityMutationGroup>;
  feed?: Maybe<FeedMutationGroup>;
  user?: Maybe<UserMutationGroup>;
  waitlist?: Maybe<WaitlistMutationGroup>;
  import?: Maybe<ImportMutationGroup>;
  contextualSearchHistory?: Maybe<ContextualSearchHistoryMutationGroup>;
  globalSearchHistory?: Maybe<GlobalSearchHistoryMutationGroup>;
  library?: Maybe<LibraryMutationGroup>;
  pushNotificationToken?: Maybe<PushNotificationTokenMutationGroup>;
};

export type MutationResponse = {
  __typename?: 'MutationResponse';
  success: Scalars['Boolean'];
};

export type Mux = {
  __typename?: 'Mux';
  playbackUrl: Scalars['String'];
  /** URL to MP4. Statics renditions may not be available as soon as playback id. Attach ?download=filename query string to enforce file download */
  mp4Url?: Maybe<Scalars['String']>;
  /** URL to image in PNG format. */
  thumbnailImageUrl: Scalars['String'];
  /** URL to Storyboard in VTT format. Docs: https://docs.mux.com/guides/video/create-timeline-hover-previews#webvtt-compatible-video-players */
  storyboardUrl: Scalars['String'];
};


export type MuxMp4UrlArgs = {
  quality: MuxMp4Quality;
};

export enum MuxMp4Quality {
  Low = 'LOW',
  Medium = 'MEDIUM',
  High = 'HIGH'
}

/** List of newest users collaborators */
export type NewestCollaboratorList = {
  __typename?: 'NewestCollaboratorList';
  collaborators: Array<Collaborator>;
  totalCollaboratorsCount: Scalars['Int'];
};

export type OnboardInput = {
  userId: Scalars['UserId'];
  username: Scalars['String'];
};

export type OrderClustersInput = {
  userId: Scalars['UserId'];
  clusterIds: Array<Scalars['ClusterId']>;
};

/** List of payment methods */
export type PaymentMethodList = {
  __typename?: 'PaymentMethodList';
  items: Array<CreditCard>;
  meta: ListMetadata;
};

export type PaymentMutationGroup = {
  __typename?: 'PaymentMutationGroup';
  addMethod?: Maybe<CreditCard>;
  deleteMethod?: Maybe<MutationResponse>;
  setDefaultMethod?: Maybe<MutationResponse>;
  retryFailedPayments?: Maybe<MutationResponse>;
};


export type PaymentMutationGroupAddMethodArgs = {
  input: AddMethodInput;
};


export type PaymentMutationGroupDeleteMethodArgs = {
  input: DeleteMethodInput;
};


export type PaymentMutationGroupSetDefaultMethodArgs = {
  input: SetDefaultMethodInput;
};


export type PaymentMutationGroupRetryFailedPaymentsArgs = {
  input: RetryFailedPaymentsInput;
};

/** Personal Invite Code */
export type PersonalInviteCode = {
  __typename?: 'PersonalInviteCode';
  /** UserId */
  userId: Scalars['UserId'];
  /** CreatedAt */
  createdAt: Scalars['DateTime'];
  /** UpdatedAt */
  updatedAt: Scalars['DateTime'];
  /** InviteCode */
  inviteCode: Scalars['String'];
  /** Username */
  username?: Maybe<Scalars['String']>;
  /** InvitesLeft */
  invitesLeft: Scalars['Long'];
  /** InvitesUsed */
  invitesUsed: Scalars['Long'];
};

/** List of personal invite codes */
export type PersonalInviteCodeList = {
  __typename?: 'PersonalInviteCodeList';
  items: Array<PersonalInviteCode>;
  meta: ListMetadata;
};

export type PersonalInviteCodeListFilters = {
  hasZeroInvitesLeft?: Maybe<Scalars['Boolean']>;
  searchTerm?: Maybe<Scalars['String']>;
};

/** Personal Invite Code Redeemed Invitee Activity details */
export type PersonalInviteCodeRedeemedInviteeActivity = ActivityInterface & {
  __typename?: 'PersonalInviteCodeRedeemedInviteeActivity';
  /** Activity identifier */
  id: Scalars['ActivityId'];
  /** Activity owner identifier */
  ownerId?: Maybe<Scalars['UserId']>;
  /** Is element ready to display */
  isRead: Scalars['Boolean'];
  /** Timestamp the activity was created */
  createdAt: Scalars['DateTime'];
  /** Inviter details */
  inviter?: Maybe<UserPublicProfile>;
  /** Invitee details */
  invitee?: Maybe<UserPublicProfile>;
};

/** Personal Invite Code Redeemed Inviter Activity details */
export type PersonalInviteCodeRedeemedInviterActivity = ActivityInterface & {
  __typename?: 'PersonalInviteCodeRedeemedInviterActivity';
  /** Activity identifier */
  id: Scalars['ActivityId'];
  /** Activity owner identifier */
  ownerId?: Maybe<Scalars['UserId']>;
  /** Is element ready to display */
  isRead: Scalars['Boolean'];
  /** Timestamp the activity was created */
  createdAt: Scalars['DateTime'];
  /** Inviter details */
  inviter?: Maybe<UserPublicProfile>;
  /** Invitee details */
  invitee?: Maybe<UserPublicProfile>;
};

export type PersonalInviteCodeSortDefinitionInput = {
  sortField: PersonalInviteCodeSortField;
  sortDirection: SortDirection;
};

export enum PersonalInviteCodeSortField {
  Unspecified = 'UNSPECIFIED',
  InviteCode = 'INVITE_CODE',
  Username = 'USERNAME',
  InvitesLeft = 'INVITES_LEFT',
  InvitesUsed = 'INVITES_USED',
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT'
}

/** Pinterest element details */
export type PinterestElement = ElementInterface & {
  __typename?: 'PinterestElement';
  /** Element identifier */
  id: Scalars['ElementId'];
  /** Element owner identifier */
  ownerId?: Maybe<Scalars['UserId']>;
  /** Element url - original source of content */
  url?: Maybe<Scalars['String']>;
  /** Element text */
  text?: Maybe<Scalars['String']>;
  /** Is element process to retrieve article/image metadata information */
  isProcessed: Scalars['Boolean'];
  /** Type of element */
  type: ElementType;
  /** Element processing state */
  processingState: ElementProcessingState;
  /** Is element NSFW content */
  isNotSafeForWork?: Maybe<Scalars['Boolean']>;
  /** Element deeplink for sharing */
  shareUrl?: Maybe<Scalars['String']>;
  /** Number of reports to Element */
  reportsCounter: Scalars['Int'];
  /** Is element ready to display */
  isReady: Scalars['Boolean'];
  /** Is element url editable */
  isUrlEditable: Scalars['Boolean'];
  /** Timestamp of the last Element update */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Timestamp of the last Element update */
  createdAt?: Maybe<Scalars['DateTime']>;
  /**
   * Element video url
   * @deprecated Use video object instead
   */
  videoUrl?: Maybe<Scalars['String']>;
  /** Currently used only for Instagram or Twitter */
  video?: Maybe<Video>;
  /** Element image */
  image?: Maybe<Image>;
  /** @deprecated Use userTags and systemTags instead */
  tags?: Maybe<ElementTagList>;
  userTags: Array<Scalars['String']>;
  /** List of computer vision tags */
  computerVisionTags?: Maybe<Array<Scalars['String']>>;
  topConnections?: Maybe<ClusterList>;
  topUserConnections?: Maybe<UserPublicProfileList>;
  numberOfConnections: Scalars['Int'];
  isConnectedByUser: Scalars['Boolean'];
  /** Owner details */
  owner?: Maybe<UserPublicProfile>;
  hasConnectionWithCluster: Scalars['Boolean'];
  /** Color list */
  colors?: Maybe<Array<Scalars['String']>>;
  originalClusterId?: Maybe<Scalars['ClusterId']>;
  isFeatured: Scalars['Boolean'];
  isOnboarding: Scalars['Boolean'];
  oldestConnectionToPublicCluster?: Maybe<ElementConnection>;
  isSavedToLibrary: Scalars['Boolean'];
  /** Author name */
  authorName?: Maybe<Scalars['String']>;
  /** Author username */
  authorUsername?: Maybe<Scalars['String']>;
  /** Author profile image url */
  authorProfileImageUrl?: Maybe<Scalars['String']>;
};


/** Pinterest element details */
export type PinterestElementTagsArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Pinterest element details */
export type PinterestElementUserTagsArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Pinterest element details */
export type PinterestElementTopConnectionsArgs = {
  userId?: Maybe<Scalars['UserId']>;
  meta?: Maybe<ListMetadataInput>;
};


/** Pinterest element details */
export type PinterestElementTopUserConnectionsArgs = {
  userId?: Maybe<Scalars['UserId']>;
  meta?: Maybe<ListMetadataInput>;
};


/** Pinterest element details */
export type PinterestElementNumberOfConnectionsArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Pinterest element details */
export type PinterestElementIsConnectedByUserArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Pinterest element details */
export type PinterestElementHasConnectionWithClusterArgs = {
  clusterId?: Maybe<Scalars['ClusterId']>;
  input?: Maybe<ClusterGetInput>;
};


/** Pinterest element details */
export type PinterestElementOriginalClusterIdArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Pinterest element details */
export type PinterestElementIsSavedToLibraryArgs = {
  userId?: Maybe<Scalars['UserId']>;
};

/** Platform settings details */
export type PlatformSettings = {
  __typename?: 'PlatformSettings';
  /** Platform privacy policy */
  privacyPolicy: Scalars['String'];
  /** Platform privacy terms */
  privacyTerms: Scalars['String'];
  /** Sign up element id */
  signUpElementId: Scalars['Long'];
  /** Login element id */
  loginElementId: Scalars['Long'];
  /** Admin email address */
  adminEmail: Scalars['String'];
  /** Default invite code max usage count */
  defaultInviteCodeMaxUsageCount?: Maybe<Scalars['Int']>;
  maxNumberOfElementsForFreeUser: Scalars['Int'];
};

export type PlatformSettingsMutationGroup = {
  __typename?: 'PlatformSettingsMutationGroup';
  edit?: Maybe<PlatformSettings>;
};


export type PlatformSettingsMutationGroupEditArgs = {
  input: EditPlatformSettingsInput;
};

export enum PlatformType {
  Unspecified = 'UNSPECIFIED',
  Web = 'WEB',
  Ios = 'IOS'
}

/** Premium username details */
export type PremiumUsername = {
  __typename?: 'PremiumUsername';
  /** Premium username identifier */
  id?: Maybe<Scalars['UsernameId']>;
  /** Premium username */
  username: Scalars['String'];
};

/** List of premium usernames */
export type PremiumUsernameList = {
  __typename?: 'PremiumUsernameList';
  items: Array<PremiumUsername>;
  meta: ListMetadata;
};

export type PremiumUsernamesListFiltersInput = {
  searchTerm?: Maybe<Scalars['String']>;
};

/** Product element details */
export type ProductElement = ElementInterface & {
  __typename?: 'ProductElement';
  /** Element identifier */
  id: Scalars['ElementId'];
  /** Element owner identifier */
  ownerId?: Maybe<Scalars['UserId']>;
  /** Element url - original source of content */
  url?: Maybe<Scalars['String']>;
  /** Element text */
  text?: Maybe<Scalars['String']>;
  /** Is element process to retrieve article/image metadata information */
  isProcessed: Scalars['Boolean'];
  /** Type of element */
  type: ElementType;
  /** Element processing state */
  processingState: ElementProcessingState;
  /** Is element NSFW content */
  isNotSafeForWork?: Maybe<Scalars['Boolean']>;
  /** Element deeplink for sharing */
  shareUrl?: Maybe<Scalars['String']>;
  /** Number of reports to Element */
  reportsCounter: Scalars['Int'];
  /** Is element ready to display */
  isReady: Scalars['Boolean'];
  /** Is element url editable */
  isUrlEditable: Scalars['Boolean'];
  /** Timestamp of the last Element update */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Timestamp of the last Element update */
  createdAt?: Maybe<Scalars['DateTime']>;
  /**
   * Element video url
   * @deprecated Use video object instead
   */
  videoUrl?: Maybe<Scalars['String']>;
  /** Currently used only for Instagram or Twitter */
  video?: Maybe<Video>;
  /** Element image */
  image?: Maybe<Image>;
  /** @deprecated Use userTags and systemTags instead */
  tags?: Maybe<ElementTagList>;
  userTags: Array<Scalars['String']>;
  /** List of computer vision tags */
  computerVisionTags?: Maybe<Array<Scalars['String']>>;
  topConnections?: Maybe<ClusterList>;
  topUserConnections?: Maybe<UserPublicProfileList>;
  numberOfConnections: Scalars['Int'];
  isConnectedByUser: Scalars['Boolean'];
  /** Owner details */
  owner?: Maybe<UserPublicProfile>;
  hasConnectionWithCluster: Scalars['Boolean'];
  /** Color list */
  colors?: Maybe<Array<Scalars['String']>>;
  originalClusterId?: Maybe<Scalars['ClusterId']>;
  isFeatured: Scalars['Boolean'];
  isOnboarding: Scalars['Boolean'];
  oldestConnectionToPublicCluster?: Maybe<ElementConnection>;
  isSavedToLibrary: Scalars['Boolean'];
  /** Product title */
  productTitle?: Maybe<Scalars['String']>;
  /** Product description */
  productDescription?: Maybe<Scalars['String']>;
  /** Product price */
  price?: Maybe<Money>;
};


/** Product element details */
export type ProductElementTagsArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Product element details */
export type ProductElementUserTagsArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Product element details */
export type ProductElementTopConnectionsArgs = {
  userId?: Maybe<Scalars['UserId']>;
  meta?: Maybe<ListMetadataInput>;
};


/** Product element details */
export type ProductElementTopUserConnectionsArgs = {
  userId?: Maybe<Scalars['UserId']>;
  meta?: Maybe<ListMetadataInput>;
};


/** Product element details */
export type ProductElementNumberOfConnectionsArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Product element details */
export type ProductElementIsConnectedByUserArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Product element details */
export type ProductElementHasConnectionWithClusterArgs = {
  clusterId?: Maybe<Scalars['ClusterId']>;
  input?: Maybe<ClusterGetInput>;
};


/** Product element details */
export type ProductElementOriginalClusterIdArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Product element details */
export type ProductElementIsSavedToLibraryArgs = {
  userId?: Maybe<Scalars['UserId']>;
};

/** Push notification token */
export type PushNotificationToken = {
  __typename?: 'PushNotificationToken';
  value: Scalars['String'];
  /** Timestamp of the push notification token creation */
  createdAt: Scalars['DateTime'];
};

/** PushNotificationTokenList */
export type PushNotificationTokenList = {
  __typename?: 'PushNotificationTokenList';
  items: Array<PushNotificationToken>;
};

export type PushNotificationTokenMutationGroup = {
  __typename?: 'PushNotificationTokenMutationGroup';
  register: MutationResponse;
  deregister: MutationResponse;
};


export type PushNotificationTokenMutationGroupRegisterArgs = {
  input: RegisterPushNotificationTokenInput;
};


export type PushNotificationTokenMutationGroupDeregisterArgs = {
  input: DeregisterPushNotificationTokenInput;
};

export type Query = {
  __typename?: 'Query';
  minimalAppVersion: Scalars['String'];
  me: User;
  user: UserPublicProfile;
  fullUser: User;
  users: UserList;
  username: Username;
  clusters: ClusterList;
  cluster: Cluster;
  onboardingCluster?: Maybe<Cluster>;
  elements: ElementList;
  element: ElementInterface;
  s3UploadUrl: Scalars['String'];
  s3PostPolicyForMp4Upload: S3PostPolicy;
  s3PostPolicyForImageUpload: S3PostPolicy;
  feedItemList: FeedItemList;
  inviteCodeList: InviteCodeList;
  personalInviteCodeList: PersonalInviteCodeList;
  waitlist: Waitlist;
  feedAdditionalItemsList: FeedItemList;
  search?: Maybe<SearchResult>;
  tag?: Maybe<Tag>;
  recentlyEditedCluster?: Maybe<Cluster>;
  subscriptionPlans?: Maybe<SubscriptionPlanList>;
  platformSettings?: Maybe<PlatformSettings>;
  listDisallowedIpAddresses?: Maybe<IpAddressList>;
  listPremiumUsernames: PremiumUsernameList;
  listBannedUsernames: BannedUsernameList;
  clusterSuggestions: ClusterList;
  elementConnections: ElementConnectionList;
  activities: ActivityList;
  activity: ActivityInterface;
  inviteCode?: Maybe<InviteCodeQueryGroup>;
  /** Returns invite code when it is valid to be used. Returns error otherwise. */
  validInviteCode: ValidInviteCode;
  personalInviteCode: InviteCode;
  sitemap: Sitemap;
  contextualSearchHistory: ContextualSearchHistory;
  globalSearchHistory: GlobalSearchHistory;
  latestElements: ElementList;
  /** Informs whether all the provided elements are visible in the user library */
  areSavedToLibrary: Scalars['Boolean'];
  /** Returns all the clusters that user can connect elements to / disconnect elements from */
  connectableClusters: ConnectableClusterList;
  /** Informs whether email was already used to create an account in Cosmos */
  isEmailTaken: Scalars['Boolean'];
  /** Push notification tokens registered by user */
  pushNotificationTokens: PushNotificationTokenList;
  similarElements: SearchElementList;
};


export type QueryUserArgs = {
  id?: Maybe<Scalars['UserId']>;
  passwordResetToken?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};


export type QueryFullUserArgs = {
  id?: Maybe<Scalars['UserId']>;
};


export type QueryUsersArgs = {
  meta?: Maybe<ListMetadataInput>;
  filters?: Maybe<UserListFiltersInput>;
  sortDefinitions?: Maybe<Array<UserSortDefinitionInput>>;
};


export type QueryUsernameArgs = {
  username: Scalars['String'];
};


export type QueryClustersArgs = {
  filters?: Maybe<ClusterListFilters>;
  meta?: Maybe<ListMetadataInput>;
  sortDefinitions?: Maybe<Array<SortDefinitionInput>>;
};


export type QueryClusterArgs = {
  input?: Maybe<ClusterGetInput>;
  id?: Maybe<Scalars['ClusterId']>;
};


export type QueryOnboardingClusterArgs = {
  id?: Maybe<Scalars['UserId']>;
};


export type QueryElementsArgs = {
  meta?: Maybe<ListMetadataInput>;
  filters?: Maybe<ElementListFilters>;
  sortDefinitions?: Maybe<Array<ElementSortDefinitionInput>>;
};


export type QueryElementArgs = {
  id: Scalars['ElementId'];
};


export type QueryFeedItemListArgs = {
  filters?: Maybe<FeedItemListFilters>;
  meta?: Maybe<ListMetadataInput>;
};


export type QueryInviteCodeListArgs = {
  sortDefinitions?: Maybe<Array<InviteCodeSortDefinitionInput>>;
  filters?: Maybe<InviteCodeListFilters>;
  meta?: Maybe<ListMetadataInput>;
};


export type QueryPersonalInviteCodeListArgs = {
  sortDefinitions?: Maybe<Array<PersonalInviteCodeSortDefinitionInput>>;
  filters?: Maybe<PersonalInviteCodeListFilters>;
  meta?: Maybe<ListMetadataInput>;
};


export type QueryWaitlistArgs = {
  sortDefinitions?: Maybe<Array<WaitlistSortDefinitionInput>>;
  filters?: Maybe<WaitlistFilters>;
  meta?: Maybe<ListMetadataInput>;
};


export type QueryFeedAdditionalItemsListArgs = {
  filters?: Maybe<FeedAdditionalItemsListFilters>;
  meta?: Maybe<ListMetadataInput>;
};


export type QuerySearchArgs = {
  searchTerm: Scalars['String'];
};


export type QueryTagArgs = {
  id: Scalars['TagId'];
};


export type QueryRecentlyEditedClusterArgs = {
  userId: Scalars['UserId'];
};


export type QueryListDisallowedIpAddressesArgs = {
  meta?: Maybe<ListMetadataInput>;
};


export type QueryListPremiumUsernamesArgs = {
  filters?: Maybe<PremiumUsernamesListFiltersInput>;
  meta?: Maybe<ListMetadataInput>;
};


export type QueryListBannedUsernamesArgs = {
  filters?: Maybe<BannedUsernamesListFiltersInput>;
  meta?: Maybe<ListMetadataInput>;
};


export type QueryClusterSuggestionsArgs = {
  filters?: Maybe<ClusterListSuggestedFilters>;
  meta?: Maybe<ListMetadataInput>;
};


export type QueryElementConnectionsArgs = {
  meta?: Maybe<ListMetadataInput>;
};


export type QueryActivitiesArgs = {
  meta?: Maybe<ListMetadataInput>;
  filters?: Maybe<ActivityListFilters>;
};


export type QueryActivityArgs = {
  id: Scalars['ActivityId'];
};


export type QueryValidInviteCodeArgs = {
  code: Scalars['String'];
};


export type QueryPersonalInviteCodeArgs = {
  userId?: Maybe<Scalars['UserId']>;
  inviteCode?: Maybe<Scalars['String']>;
};


export type QueryContextualSearchHistoryArgs = {
  ownerId: Scalars['UserId'];
};


export type QueryGlobalSearchHistoryArgs = {
  ownerId: Scalars['UserId'];
};


export type QueryLatestElementsArgs = {
  meta?: Maybe<ListMetadataInput>;
};


export type QueryAreSavedToLibraryArgs = {
  userId: Scalars['UserId'];
  elementIds: Array<Scalars['ElementId']>;
};


export type QueryConnectableClustersArgs = {
  userId: Scalars['UserId'];
  elementIds: Array<Scalars['ElementId']>;
  searchTerm?: Maybe<Scalars['String']>;
  meta?: Maybe<ListMetadataInput>;
};


export type QueryIsEmailTakenArgs = {
  email: Scalars['String'];
};


export type QueryPushNotificationTokensArgs = {
  userId: Scalars['UserId'];
};


export type QuerySimilarElementsArgs = {
  elementIds: Array<Scalars['ElementId']>;
  meta?: Maybe<ListMetadataInput>;
};

export type RefreshAccessTokenInput = {
  refreshToken?: Maybe<Scalars['String']>;
};

export type RegisterInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type RegisterPushNotificationTokenInput = {
  userId: Scalars['UserId'];
  token: Scalars['String'];
};

export type RegisterWithInviteCodeInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  inviteCode: Scalars['String'];
};

export type RegisterWithWaitlistSkipInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type RememberContextualSearchHistorySearchTermInput = {
  ownerId: Scalars['UserId'];
  searchTerm: Scalars['String'];
};

export type RememberContextualSearchHistoryVisitedClusterInput = {
  ownerId: Scalars['UserId'];
  clusterId: Scalars['ClusterId'];
};

export type RememberGlobalSearchHistorySearchTermInput = {
  ownerId: Scalars['UserId'];
  searchTerm: Scalars['String'];
};

export type RememberGlobalSearchHistoryVisitedClusterInput = {
  ownerId: Scalars['UserId'];
  clusterId: Scalars['ClusterId'];
};

export type RememberGlobalSearchHistoryVisitedUserInput = {
  ownerId: Scalars['UserId'];
  userId: Scalars['UserId'];
};

export type RemoveClusterFromFeaturedInput = {
  clusterId: Scalars['ClusterId'];
};

export type RemoveComputerVisionTagInput = {
  elementId: Scalars['ElementId'];
  tagName: Scalars['String'];
};

export type RemoveElementFromFeaturedInput = {
  elementId: Scalars['ElementId'];
};

export type RemoveElementFromOnboardingInput = {
  elementId: Scalars['ElementId'];
};

export type RemoveTagInput = {
  elementId: Scalars['ElementId'];
  tagId: Scalars['TagId'];
};

export type RemoveUserTagInput = {
  elementId: Scalars['ElementId'];
  userId: Scalars['UserId'];
  tagName: Scalars['String'];
};

export type ReorderClusterElementInput = {
  clusterId: Scalars['ClusterId'];
  elementId: Scalars['ElementId'];
  /** Element after which passed element will be inserted. If null the element will be inserted at the beginning of the list. */
  insertAfterElementId?: Maybe<Scalars['ElementId']>;
};

export type ReportElementInput = {
  id: Scalars['ElementId'];
};

export type ReportUserInput = {
  id: Scalars['UserId'];
};

export type RequestPasswordResetInput = {
  username?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type ResendInviteCodesEmailInput = {
  ids: Array<Scalars['InviteCodeId']>;
};

export type ResetElementReportsCounterInput = {
  id: Scalars['ElementId'];
};

export type ResetPasswordInput = {
  token?: Maybe<Scalars['String']>;
  newPassword?: Maybe<Scalars['String']>;
};

export type ResetUserReportsCounterInput = {
  id: Scalars['UserId'];
};

export type ResubscribeSubscriptionInput = {
  userId: Scalars['UserId'];
};

export type RetryFailedPaymentsInput = {
  userId: Scalars['UserId'];
};

export type RevokeCollaboratorInviteInput = {
  userId?: Maybe<Scalars['UserId']>;
  email?: Maybe<Scalars['String']>;
  clusterId: Scalars['ClusterId'];
};

export type RevokeCollaboratorInvitesInput = {
  inviteDataList?: Maybe<Array<Maybe<InviteDataInput>>>;
  clusterId: Scalars['ClusterId'];
};

/** S3 post policy details */
export type S3PostPolicy = {
  __typename?: 'S3PostPolicy';
  /** Signature */
  signature: Scalars['String'];
  /** Policy string */
  policyString: Scalars['String'];
  /** Upload key */
  uploadKey: Scalars['String'];
  /** Access key id */
  accessKeyId: Scalars['String'];
  /** Policy string in base64 */
  policyBase64String: Scalars['String'];
};

export type SaveLibraryElementsInput = {
  userId: Scalars['UserId'];
  elementIds: Array<Scalars['ElementId']>;
};

/** Cluster details */
export type SearchCluster = {
  __typename?: 'SearchCluster';
  /** Cluster identifier */
  id: Scalars['ClusterId'];
  /** Cluster name */
  name: Scalars['String'];
  /** Cluster owner name */
  ownerName: Scalars['String'];
  /** Cluster owner avatar url */
  ownerAvatarUrl?: Maybe<Scalars['String']>;
  /** Hash of cluster's cover image */
  coverImageHash?: Maybe<Scalars['String']>;
  /** Url of cluster's cover animated image converted to mp4 format */
  coverImageMp4Url?: Maybe<Scalars['String']>;
  /** Cluster slug */
  slug: Scalars['String'];
  /** Cluster privacy info */
  isPrivate: Scalars['Boolean'];
  /** Number of elements in cluster */
  elementsCount: Scalars['Int'];
  /** Avatar url of the oldest collaborator */
  oldestCollaboratorAvatarUrl?: Maybe<Scalars['String']>;
  /** Username of the oldest collaborator */
  oldestCollaboratorUsername?: Maybe<Scalars['String']>;
  /** Number of collaborators */
  collaboratorsCount: Scalars['Int'];
  /** Is cluster owner premium user */
  isOwnerPremium: Scalars['Boolean'];
  /** Is cluster cover image NSFW content */
  isCoverImageNotSafeForWork: Scalars['Boolean'];
  /** Identifier of the cluster owner */
  ownerId: Scalars['UserId'];
  /** Url to cluster's cover image */
  coverImageUrl?: Maybe<Scalars['String']>;
  isFollowed?: Maybe<Scalars['Boolean']>;
  elements?: Maybe<Array<Maybe<SearchClusterElement>>>;
  isCollaborator?: Maybe<Scalars['Boolean']>;
  isPubliclyVisible?: Maybe<Scalars['Boolean']>;
  isFeatured: Scalars['Boolean'];
  /** Cluster cover image */
  coverImage?: Maybe<Image>;
};


/** Cluster details */
export type SearchClusterIsFollowedArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Cluster details */
export type SearchClusterIsCollaboratorArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Cluster details */
export type SearchClusterIsPubliclyVisibleArgs = {
  userId?: Maybe<Scalars['UserId']>;
};

export type SearchClusterElement = {
  __typename?: 'SearchClusterElement';
  /** Element identifier */
  id: Scalars['ElementId'];
  /** Is element NSFW content */
  isNotSafeForWork: Scalars['Boolean'];
  /** Element image */
  image?: Maybe<Image>;
};

export type SearchClusterFilters = {
  userId?: Maybe<Scalars['UserId']>;
  isPrivate?: Maybe<Scalars['Boolean']>;
  isPubliclyVisible?: Maybe<Scalars['Boolean']>;
};

/** List of clusters */
export type SearchClusterList = {
  __typename?: 'SearchClusterList';
  items: Array<SearchCluster>;
  meta: ListMetadata;
};

export enum SearchClusterSortField {
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT'
}

export type SearchClustersSortDefinitionInput = {
  sortField: SearchClusterSortField;
  sortDirection: SortDirection;
};

export type SearchCollaborator = {
  __typename?: 'SearchCollaborator';
  /** Information about collaboration of user */
  collaborator?: Maybe<Collaborator>;
  /** Information about User */
  user?: Maybe<UserPublicProfile>;
};

/** List of search collaborators */
export type SearchCollaboratorList = {
  __typename?: 'SearchCollaboratorList';
  items: Array<SearchCollaborator>;
  meta: ListMetadata;
};

/** Element details */
export type SearchElement = {
  __typename?: 'SearchElement';
  /** Element identifier */
  id: Scalars['ElementId'];
  /** Element owner identifier */
  ownerId?: Maybe<Scalars['UserId']>;
  /**
   * Element owner name
   * @deprecated Field will no longer be maintained
   */
  ownerName?: Maybe<Scalars['String']>;
  /** Element url - original source of content */
  url?: Maybe<Scalars['String']>;
  /** Element text */
  text?: Maybe<Scalars['String']>;
  /** Type of element */
  type: ElementType;
  /** Is element NSFW content */
  isNotSafeForWork?: Maybe<Scalars['Boolean']>;
  /**
   * Number of connections to element
   * @deprecated Use NumberOfConnections from ElementGraphType instead
   */
  numberOfConnections?: Maybe<Scalars['Int']>;
  /** Article Element title */
  articleTitle?: Maybe<Scalars['String']>;
  /** Article Element description */
  articleDescription?: Maybe<Scalars['String']>;
  /** Tweet author username */
  twitterAuthorUsername?: Maybe<Scalars['String']>;
  /** Tweet author name */
  twitterAuthorName?: Maybe<Scalars['String']>;
  /** Twitter media */
  twitterMedia?: Maybe<Array<Maybe<TwitterMedia>>>;
  /** Is Twitter carousel */
  isTwitterCarousel?: Maybe<Scalars['Boolean']>;
  /** Youtube author name */
  youtubeAuthorName?: Maybe<Scalars['String']>;
  /** Instagram author name */
  instagramAuthorName?: Maybe<Scalars['String']>;
  /** Instagram author full name */
  instagramAuthorFullName?: Maybe<Scalars['String']>;
  /** Instagram content accessibility */
  instagramContentAccessibility: InstagramContentAccessibility;
  /** Is Instagram carousel */
  isInstagramCarousel?: Maybe<Scalars['Boolean']>;
  /** Pinterest author username */
  pinterestAuthorUsername?: Maybe<Scalars['String']>;
  /** Pinterest author name */
  pinterestAuthorName?: Maybe<Scalars['String']>;
  /** TikTok author name */
  tikTokAuthorName?: Maybe<Scalars['String']>;
  /** Product title */
  productTitle?: Maybe<Scalars['String']>;
  /** Product description */
  productDescription?: Maybe<Scalars['String']>;
  rawVideo?: Maybe<Video>;
  mux?: Maybe<Mux>;
  /** Is element found by premium search */
  isFoundByPremiumSearch?: Maybe<Scalars['Boolean']>;
  /** Element image */
  image?: Maybe<Image>;
  /**
   * Element video url
   * @deprecated Use video object instead
   */
  videoUrl?: Maybe<Scalars['String']>;
  /** Currently used only for instagram and twitter */
  video?: Maybe<Video>;
  /** @deprecated Use isSavedToLibrary instead */
  isConnectedByUser?: Maybe<Scalars['Boolean']>;
  hasConnectionWithCluster: Scalars['Boolean'];
  isFeatured: Scalars['Boolean'];
  isOnboarding: Scalars['Boolean'];
  isSavedToLibrary: Scalars['Boolean'];
};


/** Element details */
export type SearchElementIsConnectedByUserArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Element details */
export type SearchElementHasConnectionWithClusterArgs = {
  clusterId?: Maybe<Scalars['ClusterId']>;
  input?: Maybe<ClusterGetInput>;
};


/** Element details */
export type SearchElementIsSavedToLibraryArgs = {
  userId?: Maybe<Scalars['UserId']>;
};

export type SearchElementFilters = {
  userId?: Maybe<Scalars['UserId']>;
  clusterId?: Maybe<Scalars['ClusterId']>;
  type?: Maybe<ElementType>;
  clusterGetInput?: Maybe<ClusterGetInput>;
  isUnsorted?: Maybe<Scalars['Boolean']>;
};

/** List of elements */
export type SearchElementList = {
  __typename?: 'SearchElementList';
  items: Array<SearchElement>;
  meta: ListMetadata;
};

export type SearchResult = {
  __typename?: 'SearchResult';
  clusters?: Maybe<SearchClusterList>;
  elements?: Maybe<SearchElementList>;
  users?: Maybe<SearchUserList>;
};


export type SearchResultClustersArgs = {
  meta?: Maybe<ListMetadataInput>;
  filters?: Maybe<SearchClusterFilters>;
  sortDefinitions?: Maybe<Array<SearchClustersSortDefinitionInput>>;
};


export type SearchResultElementsArgs = {
  meta?: Maybe<ListMetadataInput>;
  filters?: Maybe<SearchElementFilters>;
};


export type SearchResultUsersArgs = {
  meta?: Maybe<ListMetadataInput>;
};

export type SearchTermContextualSearchHistoryEntry = {
  __typename?: 'SearchTermContextualSearchHistoryEntry';
  searchTerm: Scalars['String'];
};

export type SearchTermGlobalSearchHistoryEntry = {
  __typename?: 'SearchTermGlobalSearchHistoryEntry';
  searchTerm: Scalars['String'];
};

/** User details */
export type SearchUser = {
  __typename?: 'SearchUser';
  /** User unique identifier */
  id: Scalars['UserId'];
  /** Unique username */
  username?: Maybe<Scalars['String']>;
  /** URL of user avatar */
  avatarUrl?: Maybe<Scalars['String']>;
  /** Hash of user avatar */
  avatarHash?: Maybe<Scalars['String']>;
  /** Name of the user */
  name: Scalars['String'];
  /** First name of the user */
  firstName?: Maybe<Scalars['String']>;
  /** Last name of the user */
  lastName?: Maybe<Scalars['String']>;
  /** Premium status of user */
  isPremium: Scalars['Boolean'];
  /** Profile clusters of user */
  profileClusters?: Maybe<Array<SearchCluster>>;
};

/** List of users */
export type SearchUserList = {
  __typename?: 'SearchUserList';
  items: Array<SearchUser>;
  meta: ListMetadata;
};


export type SetAdminSubscriptionForUsersCreatedBeforeDateInput = {
  /** The required date format: YYYY-MM-DD'T'HH:MM:SS'Z' (Example: "1999-12-31T00:00:00Z") */
  usersCreatedBeforeDate: Scalars['DateTime'];
  /** The required date format: YYYY-MM-DD'T'HH:MM:SS'Z' (Example: "1999-12-31T00:00:00Z") */
  subscriptionExpirationDate: Scalars['DateTime'];
};

export type SetCoverInput = {
  elementId: Scalars['ElementId'];
  mediaId: Scalars['String'];
};

export type SetDefaultHomeTabInput = {
  userId: Scalars['UserId'];
  defaultHomeTab: UserHomeTab;
};

export type SetDefaultMethodInput = {
  userId: Scalars['UserId'];
  cardId: Scalars['String'];
};

export type SetHasCompletedExtensionTutorialInput = {
  userId: Scalars['UserId'];
};

export type SetIsNotSafeForWorkAllowedInput = {
  userId: Scalars['UserId'];
  isNotSafeForWorkAllowed: Scalars['Boolean'];
};

export type SetIsSubscribedToNewsletterInput = {
  userId: Scalars['UserId'];
  isSubscribedToNewsletter: Scalars['Boolean'];
};

export type SetPasswordInput = {
  userId: Scalars['UserId'];
  password: Scalars['String'];
};

export type SetPremiumSubscriptionInput = {
  userId: Scalars['UserId'];
  /** The required date format: YYYY-MM-DD'T'HH:MM:SS'Z' (Example: "1999-12-31T00:00:00Z") */
  subscriptionExpirationDate: Scalars['DateTime'];
};

export type SetProfileFiltersInput = {
  userId: Scalars['UserId'];
  defaultProfileTab: UserProfileTab;
  clustersProfileTabFilter: UserClustersProfileTabFilter;
  elementsProfileTabFilter: UserElementsProfileTabFilter;
};

export type SetShowOwnedConnectionsInFeedInput = {
  userId: Scalars['UserId'];
  showOwnedConnectionsInFeed: Scalars['Boolean'];
};

export type Sitemap = {
  __typename?: 'Sitemap';
  /** Cluster list for sitemap */
  clusters: ClusterList;
  /** Element list for sitemap */
  elements: ElementList;
  /** User list for sitemap */
  users: UserPublicProfileList;
};


export type SitemapClustersArgs = {
  meta?: Maybe<ListMetadataInput>;
};


export type SitemapElementsArgs = {
  meta?: Maybe<ListMetadataInput>;
};


export type SitemapUsersArgs = {
  meta?: Maybe<ListMetadataInput>;
};

export type SortDefinitionInput = {
  sortField: ClusterSortField;
  sortDirection: SortDirection;
  value?: Maybe<Scalars['String']>;
};

export enum SortDirection {
  Unspecified = 'UNSPECIFIED',
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Spotify element details */
export type SpotifyElement = ElementInterface & {
  __typename?: 'SpotifyElement';
  /** Element identifier */
  id: Scalars['ElementId'];
  /** Element owner identifier */
  ownerId?: Maybe<Scalars['UserId']>;
  /** Element url - original source of content */
  url?: Maybe<Scalars['String']>;
  /** Element text */
  text?: Maybe<Scalars['String']>;
  /** Is element process to retrieve article/image metadata information */
  isProcessed: Scalars['Boolean'];
  /** Type of element */
  type: ElementType;
  /** Element processing state */
  processingState: ElementProcessingState;
  /** Is element NSFW content */
  isNotSafeForWork?: Maybe<Scalars['Boolean']>;
  /** Element deeplink for sharing */
  shareUrl?: Maybe<Scalars['String']>;
  /** Number of reports to Element */
  reportsCounter: Scalars['Int'];
  /** Is element ready to display */
  isReady: Scalars['Boolean'];
  /** Is element url editable */
  isUrlEditable: Scalars['Boolean'];
  /** Timestamp of the last Element update */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Timestamp of the last Element update */
  createdAt?: Maybe<Scalars['DateTime']>;
  /**
   * Element video url
   * @deprecated Use video object instead
   */
  videoUrl?: Maybe<Scalars['String']>;
  /** Currently used only for Instagram or Twitter */
  video?: Maybe<Video>;
  /** Element image */
  image?: Maybe<Image>;
  /** @deprecated Use userTags and systemTags instead */
  tags?: Maybe<ElementTagList>;
  userTags: Array<Scalars['String']>;
  /** List of computer vision tags */
  computerVisionTags?: Maybe<Array<Scalars['String']>>;
  topConnections?: Maybe<ClusterList>;
  topUserConnections?: Maybe<UserPublicProfileList>;
  numberOfConnections: Scalars['Int'];
  isConnectedByUser: Scalars['Boolean'];
  /** Owner details */
  owner?: Maybe<UserPublicProfile>;
  hasConnectionWithCluster: Scalars['Boolean'];
  /** Color list */
  colors?: Maybe<Array<Scalars['String']>>;
  originalClusterId?: Maybe<Scalars['ClusterId']>;
  isFeatured: Scalars['Boolean'];
  isOnboarding: Scalars['Boolean'];
  oldestConnectionToPublicCluster?: Maybe<ElementConnection>;
  isSavedToLibrary: Scalars['Boolean'];
  /** Spotify content html */
  html: Scalars['String'];
  /** Spotify content title */
  title: Scalars['String'];
};


/** Spotify element details */
export type SpotifyElementTagsArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Spotify element details */
export type SpotifyElementUserTagsArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Spotify element details */
export type SpotifyElementTopConnectionsArgs = {
  userId?: Maybe<Scalars['UserId']>;
  meta?: Maybe<ListMetadataInput>;
};


/** Spotify element details */
export type SpotifyElementTopUserConnectionsArgs = {
  userId?: Maybe<Scalars['UserId']>;
  meta?: Maybe<ListMetadataInput>;
};


/** Spotify element details */
export type SpotifyElementNumberOfConnectionsArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Spotify element details */
export type SpotifyElementIsConnectedByUserArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Spotify element details */
export type SpotifyElementHasConnectionWithClusterArgs = {
  clusterId?: Maybe<Scalars['ClusterId']>;
  input?: Maybe<ClusterGetInput>;
};


/** Spotify element details */
export type SpotifyElementOriginalClusterIdArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Spotify element details */
export type SpotifyElementIsSavedToLibraryArgs = {
  userId?: Maybe<Scalars['UserId']>;
};

export type SubmitJoinFollowUpAnswerInput = {
  email: Scalars['String'];
  howHeardAboutUsAnswer: Scalars['String'];
};

/** Subscription details */
export type Subscription = {
  __typename?: 'Subscription';
  /** Subscription identifier */
  id: Scalars['String'];
  /** Source of subscription */
  source: SubscriptionSource;
  /** Status of subscription */
  status: SubscriptionStatus;
  /** Premium subscription valid to */
  subscriptionValidTo?: Maybe<Scalars['DateTime']>;
  /** Subscription plan */
  plan?: Maybe<SubscriptionPlan>;
  /** Subscription plan of the next subscription */
  nextSubscriptionPlan?: Maybe<SubscriptionPlan>;
};

export type SubscriptionMutationGroup = {
  __typename?: 'SubscriptionMutationGroup';
  create?: Maybe<Subscription>;
  cancel?: Maybe<MutationResponse>;
  resubscribe?: Maybe<MutationResponse>;
  update?: Maybe<MutationResponse>;
};


export type SubscriptionMutationGroupCreateArgs = {
  input: CreateSubscriptionInput;
};


export type SubscriptionMutationGroupCancelArgs = {
  input: CancelSubscriptionInput;
};


export type SubscriptionMutationGroupResubscribeArgs = {
  input: ResubscribeSubscriptionInput;
};


export type SubscriptionMutationGroupUpdateArgs = {
  input: UpdateSubscriptionInput;
};

export type SubscriptionPlan = {
  __typename?: 'SubscriptionPlan';
  /** Id of Stripe's Price object */
  priceId: Scalars['String'];
  /** Price of subscription plan */
  price?: Maybe<Money>;
  /** Recurring payment interval eg. month, year */
  interval: Scalars['String'];
  /** Interval count, after which payments occur */
  intervalCount: Scalars['Int'];
};

/** List of subscription plans */
export type SubscriptionPlanList = {
  __typename?: 'SubscriptionPlanList';
  items: Array<SubscriptionPlan>;
  meta: ListMetadata;
};

export enum SubscriptionSource {
  Unspecified = 'UNSPECIFIED',
  Web = 'WEB',
  Ios = 'IOS'
}

export enum SubscriptionStatus {
  Unspecified = 'UNSPECIFIED',
  Cancelled = 'CANCELLED',
  Unpaid = 'UNPAID',
  Active = 'ACTIVE',
  PaymentFailed = 'PAYMENT_FAILED'
}

/** Tag details */
export type Tag = {
  __typename?: 'Tag';
  /** Tag identifier */
  id: Scalars['TagId'];
  /** Tag name */
  name: Scalars['String'];
};


export type TagMutationGroup = {
  __typename?: 'TagMutationGroup';
  /** @deprecated Use element.addUserTag instead */
  create?: Maybe<Tag>;
};


export type TagMutationGroupCreateArgs = {
  input: CreateTagInput;
};

export type Thumbnail = {
  __typename?: 'Thumbnail';
  hash: Scalars['String'];
};

/** TikTok element details */
export type TikTokElement = ElementInterface & {
  __typename?: 'TikTokElement';
  /** Element identifier */
  id: Scalars['ElementId'];
  /** Element owner identifier */
  ownerId?: Maybe<Scalars['UserId']>;
  /** Element url - original source of content */
  url?: Maybe<Scalars['String']>;
  /** Element text */
  text?: Maybe<Scalars['String']>;
  /** Is element process to retrieve article/image metadata information */
  isProcessed: Scalars['Boolean'];
  /** Type of element */
  type: ElementType;
  /** Element processing state */
  processingState: ElementProcessingState;
  /** Is element NSFW content */
  isNotSafeForWork?: Maybe<Scalars['Boolean']>;
  /** Element deeplink for sharing */
  shareUrl?: Maybe<Scalars['String']>;
  /** Number of reports to Element */
  reportsCounter: Scalars['Int'];
  /** Is element ready to display */
  isReady: Scalars['Boolean'];
  /** Is element url editable */
  isUrlEditable: Scalars['Boolean'];
  /** Timestamp of the last Element update */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Timestamp of the last Element update */
  createdAt?: Maybe<Scalars['DateTime']>;
  /**
   * Element video url
   * @deprecated Use video object instead
   */
  videoUrl?: Maybe<Scalars['String']>;
  /** Currently used only for Instagram or Twitter */
  video?: Maybe<Video>;
  /** Element image */
  image?: Maybe<Image>;
  /** @deprecated Use userTags and systemTags instead */
  tags?: Maybe<ElementTagList>;
  userTags: Array<Scalars['String']>;
  /** List of computer vision tags */
  computerVisionTags?: Maybe<Array<Scalars['String']>>;
  topConnections?: Maybe<ClusterList>;
  topUserConnections?: Maybe<UserPublicProfileList>;
  numberOfConnections: Scalars['Int'];
  isConnectedByUser: Scalars['Boolean'];
  /** Owner details */
  owner?: Maybe<UserPublicProfile>;
  hasConnectionWithCluster: Scalars['Boolean'];
  /** Color list */
  colors?: Maybe<Array<Scalars['String']>>;
  originalClusterId?: Maybe<Scalars['ClusterId']>;
  isFeatured: Scalars['Boolean'];
  isOnboarding: Scalars['Boolean'];
  oldestConnectionToPublicCluster?: Maybe<ElementConnection>;
  isSavedToLibrary: Scalars['Boolean'];
  /** TikTok content html */
  html: Scalars['String'];
  /** TikTok content author name */
  authorName?: Maybe<Scalars['String']>;
};


/** TikTok element details */
export type TikTokElementTagsArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** TikTok element details */
export type TikTokElementUserTagsArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** TikTok element details */
export type TikTokElementTopConnectionsArgs = {
  userId?: Maybe<Scalars['UserId']>;
  meta?: Maybe<ListMetadataInput>;
};


/** TikTok element details */
export type TikTokElementTopUserConnectionsArgs = {
  userId?: Maybe<Scalars['UserId']>;
  meta?: Maybe<ListMetadataInput>;
};


/** TikTok element details */
export type TikTokElementNumberOfConnectionsArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** TikTok element details */
export type TikTokElementIsConnectedByUserArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** TikTok element details */
export type TikTokElementHasConnectionWithClusterArgs = {
  clusterId?: Maybe<Scalars['ClusterId']>;
  input?: Maybe<ClusterGetInput>;
};


/** TikTok element details */
export type TikTokElementOriginalClusterIdArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** TikTok element details */
export type TikTokElementIsSavedToLibraryArgs = {
  userId?: Maybe<Scalars['UserId']>;
};

/** Twitter element details */
export type TwitterElement = ElementInterface & {
  __typename?: 'TwitterElement';
  /** Element identifier */
  id: Scalars['ElementId'];
  /** Element owner identifier */
  ownerId?: Maybe<Scalars['UserId']>;
  /** Element url - original source of content */
  url?: Maybe<Scalars['String']>;
  /** Element text */
  text?: Maybe<Scalars['String']>;
  /** Is element process to retrieve article/image metadata information */
  isProcessed: Scalars['Boolean'];
  /** Type of element */
  type: ElementType;
  /** Element processing state */
  processingState: ElementProcessingState;
  /** Is element NSFW content */
  isNotSafeForWork?: Maybe<Scalars['Boolean']>;
  /** Element deeplink for sharing */
  shareUrl?: Maybe<Scalars['String']>;
  /** Number of reports to Element */
  reportsCounter: Scalars['Int'];
  /** Is element ready to display */
  isReady: Scalars['Boolean'];
  /** Is element url editable */
  isUrlEditable: Scalars['Boolean'];
  /** Timestamp of the last Element update */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Timestamp of the last Element update */
  createdAt?: Maybe<Scalars['DateTime']>;
  /**
   * Element video url
   * @deprecated Use video object instead
   */
  videoUrl?: Maybe<Scalars['String']>;
  /** Currently used only for Instagram or Twitter */
  video?: Maybe<Video>;
  /** Element image */
  image?: Maybe<Image>;
  /** @deprecated Use userTags and systemTags instead */
  tags?: Maybe<ElementTagList>;
  userTags: Array<Scalars['String']>;
  /** List of computer vision tags */
  computerVisionTags?: Maybe<Array<Scalars['String']>>;
  topConnections?: Maybe<ClusterList>;
  topUserConnections?: Maybe<UserPublicProfileList>;
  numberOfConnections: Scalars['Int'];
  isConnectedByUser: Scalars['Boolean'];
  /** Owner details */
  owner?: Maybe<UserPublicProfile>;
  hasConnectionWithCluster: Scalars['Boolean'];
  /** Color list */
  colors?: Maybe<Array<Scalars['String']>>;
  originalClusterId?: Maybe<Scalars['ClusterId']>;
  isFeatured: Scalars['Boolean'];
  isOnboarding: Scalars['Boolean'];
  oldestConnectionToPublicCluster?: Maybe<ElementConnection>;
  isSavedToLibrary: Scalars['Boolean'];
  /** Twitter content html */
  html?: Maybe<Scalars['String']>;
  /** Author's name */
  authorName: Scalars['String'];
  /** Author's username */
  authorUsername?: Maybe<Scalars['String']>;
  /** Author's profile image url */
  authorProfileImageUrl?: Maybe<Scalars['String']>;
  /**
   * Author's profile url
   * @deprecated Field will no longer be provided in API
   */
  authorUrl?: Maybe<Scalars['String']>;
  /**
   * Creation time of the Tweet
   * @deprecated Field will no longer be provided in API
   */
  postedOn?: Maybe<Scalars['DateTime']>;
  /**
   * Twitter images
   * @deprecated Use media field instead
   */
  images?: Maybe<Array<Maybe<Image>>>;
  /** Twitter media */
  media?: Maybe<Array<Maybe<TwitterMedia>>>;
  /** Is Twitter carousel */
  isCarousel: Scalars['Boolean'];
  mux?: Maybe<Mux>;
};


/** Twitter element details */
export type TwitterElementTagsArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Twitter element details */
export type TwitterElementUserTagsArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Twitter element details */
export type TwitterElementTopConnectionsArgs = {
  userId?: Maybe<Scalars['UserId']>;
  meta?: Maybe<ListMetadataInput>;
};


/** Twitter element details */
export type TwitterElementTopUserConnectionsArgs = {
  userId?: Maybe<Scalars['UserId']>;
  meta?: Maybe<ListMetadataInput>;
};


/** Twitter element details */
export type TwitterElementNumberOfConnectionsArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Twitter element details */
export type TwitterElementIsConnectedByUserArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Twitter element details */
export type TwitterElementHasConnectionWithClusterArgs = {
  clusterId?: Maybe<Scalars['ClusterId']>;
  input?: Maybe<ClusterGetInput>;
};


/** Twitter element details */
export type TwitterElementOriginalClusterIdArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Twitter element details */
export type TwitterElementIsSavedToLibraryArgs = {
  userId?: Maybe<Scalars['UserId']>;
};

export type TwitterMedia = {
  __typename?: 'TwitterMedia';
  image?: Maybe<Image>;
  video?: Maybe<Video>;
  mux?: Maybe<Mux>;
  /** Media id */
  mediaId: Scalars['String'];
};

export type UnbanUserInput = {
  userId: Scalars['UserId'];
};

export type UnblockOtherUserInput = {
  userId: Scalars['UserId'];
  userToUnblockId: Scalars['UserId'];
};

export type UnfollowAllUserClustersInput = {
  userId: Scalars['UserId'];
  ownerId: Scalars['UserId'];
};

export type UnfollowClusterInput = {
  userId: Scalars['UserId'];
  clusterId: Scalars['ClusterId'];
};

export type UpdateSubscriptionInput = {
  userId: Scalars['UserId'];
  priceId: Scalars['String'];
};

export type UpdateUserProfileInput = {
  userId: Scalars['UserId'];
  firstName: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  countryCode?: Maybe<CountryCode>;
  /** The required date format: YYYY-MM-DD'T'HH:MM:SS'Z' (Example: "2001-9-11T00:00:00Z") */
  birthday?: Maybe<Scalars['DateTime']>;
  websiteUrl?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
};

/** User details */
export type User = {
  __typename?: 'User';
  /** User unique identifier */
  id: Scalars['UserId'];
  /** Unique username */
  username?: Maybe<Scalars['String']>;
  /** E-mail address */
  email: Scalars['String'];
  /** Full Name */
  name?: Maybe<Scalars['String']>;
  /** Is e-mail confirmed */
  emailConfirmed: Scalars['Boolean'];
  /** URL of user avatar */
  avatarUrl?: Maybe<Scalars['String']>;
  /** Hash of user avatar */
  avatarHash?: Maybe<Scalars['String']>;
  /** Is user premium */
  isPremium: Scalars['Boolean'];
  /** Is user allowed to see NSFW content */
  isNotSafeForWorkAllowed: Scalars['Boolean'];
  /** Is user subscribed to Cosmos Newsletter */
  isSubscribedToNewsletter: Scalars['Boolean'];
  /** User deeplink for sharing */
  shareUrl?: Maybe<Scalars['String']>;
  /** Number of reports to user */
  reportsCounter: Scalars['Int'];
  /** Informs weather user has completed onboarding process */
  hasCompletedOnboarding: Scalars['Boolean'];
  /** Informs weather user has completed extension tutorial on iOS */
  hasCompletedExtensionTutorial: Scalars['Boolean'];
  /** User website url */
  websiteUrl?: Maybe<Scalars['String']>;
  /** User admin role */
  adminRole: AdminRole;
  /** Elements tab views counter */
  elementsTabViewsCounter: Scalars['Long'];
  /** Default profile tab */
  defaultProfileTab: UserProfileTab;
  /** Clusters profile tab filter */
  clustersProfileTabFilter: UserClustersProfileTabFilter;
  /** Elements profile tab filter */
  elementsProfileTabFilter: UserElementsProfileTabFilter;
  /** Informs weather user has skipped the waitlist */
  hasSkippedWaitlist: Scalars['Boolean'];
  /** Informs weather user has paid for waitlist skip */
  hasPaidForWaitlistSkip: Scalars['Boolean'];
  /** Default home tab */
  defaultHomeTab: UserHomeTab;
  /** First Name */
  firstName?: Maybe<Scalars['String']>;
  /** Last Name */
  lastName?: Maybe<Scalars['String']>;
  /** User bio */
  bio?: Maybe<Scalars['String']>;
  /** User country name */
  countryCode?: Maybe<CountryCode>;
  paymentMethods?: Maybe<PaymentMethodList>;
  invoices?: Maybe<InvoiceList>;
  subscription?: Maybe<Subscription>;
  recentlyEditedCluster?: Maybe<Cluster>;
  hasPassword?: Maybe<Scalars['Boolean']>;
  /** @deprecated Field is no longer maintained on the server. Always returns true. */
  hasNeverAddedContent?: Maybe<Scalars['Boolean']>;
  hasAnyUnreadActivities: Scalars['Boolean'];
  numberOfFollowedClusters: Scalars['Int'];
  showOwnedConnectionsInFeed: Scalars['Boolean'];
  /** User statistics */
  statistics: UserStatistics;
  /** Timestamp of the user creation */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Birthday of the user */
  birthday?: Maybe<Scalars['DateTime']>;
};


/** User details */
export type UserInvoicesArgs = {
  meta?: Maybe<ListMetadataInput>;
};

export enum UserClustersProfileTabFilter {
  Unspecified = 'UNSPECIFIED',
  RecentActivity = 'RECENT_ACTIVITY',
  AToZ = 'A_TO_Z',
  Private = 'PRIVATE',
  PublicView = 'PUBLIC_VIEW'
}

export enum UserElementsProfileTabFilter {
  Unspecified = 'UNSPECIFIED',
  AllElements = 'ALL_ELEMENTS',
  NotConnected = 'NOT_CONNECTED'
}

export enum UserHomeTab {
  Unspecified = 'UNSPECIFIED',
  Featured = 'FEATURED',
  Following = 'FOLLOWING',
  Everyone = 'EVERYONE'
}


/** List of users */
export type UserList = {
  __typename?: 'UserList';
  items: Array<User>;
  meta: ListMetadata;
};

export type UserListFiltersInput = {
  isPremium?: Maybe<Scalars['Boolean']>;
  isOnboarded?: Maybe<Scalars['Boolean']>;
  isReported?: Maybe<Scalars['Boolean']>;
  searchTerm?: Maybe<Scalars['String']>;
  hasIdentityProvider?: Maybe<IdentityProviderType>;
};

export type UserMutationGroup = {
  __typename?: 'UserMutationGroup';
  setHasCompletedExtensionTutorial?: Maybe<User>;
  blockOtherUser?: Maybe<MutationResponse>;
  unblockOtherUser?: Maybe<MutationResponse>;
  incrementElementsTabViewsCounter?: Maybe<MutationResponse>;
  setProfileFilters?: Maybe<MutationResponse>;
  updateProfile?: Maybe<MutationResponse>;
  setDefaultHomeTab: MutationResponse;
};


export type UserMutationGroupSetHasCompletedExtensionTutorialArgs = {
  input: SetHasCompletedExtensionTutorialInput;
};


export type UserMutationGroupBlockOtherUserArgs = {
  input: BlockOtherUserInput;
};


export type UserMutationGroupUnblockOtherUserArgs = {
  input: UnblockOtherUserInput;
};


export type UserMutationGroupIncrementElementsTabViewsCounterArgs = {
  input: IncrementElementsTabViewsCounterInput;
};


export type UserMutationGroupSetProfileFiltersArgs = {
  input: SetProfileFiltersInput;
};


export type UserMutationGroupUpdateProfileArgs = {
  input: UpdateUserProfileInput;
};


export type UserMutationGroupSetDefaultHomeTabArgs = {
  input: SetDefaultHomeTabInput;
};

export type UserProfileMutationGroup = {
  __typename?: 'UserProfileMutationGroup';
  changeClusterVisibility?: Maybe<MutationResponse>;
  editClustersOrder: ClusterList;
  reportUser?: Maybe<User>;
  resetReportsCounter?: Maybe<MutationResponse>;
};


export type UserProfileMutationGroupChangeClusterVisibilityArgs = {
  input: ChangeClusterVisibilityInput;
};


export type UserProfileMutationGroupEditClustersOrderArgs = {
  input: OrderClustersInput;
};


export type UserProfileMutationGroupReportUserArgs = {
  input: ReportUserInput;
};


export type UserProfileMutationGroupResetReportsCounterArgs = {
  input: ResetUserReportsCounterInput;
};

export enum UserProfileTab {
  Unspecified = 'UNSPECIFIED',
  Clusters = 'CLUSTERS',
  Elements = 'ELEMENTS'
}

/** User public profile details */
export type UserPublicProfile = {
  __typename?: 'UserPublicProfile';
  /** User unique identifier */
  id: Scalars['UserId'];
  /** Unique username */
  username?: Maybe<Scalars['String']>;
  /** Full Name */
  name?: Maybe<Scalars['String']>;
  /** URL of user avatar */
  avatarUrl?: Maybe<Scalars['String']>;
  /** Is user premium */
  isPremium: Scalars['Boolean'];
  /** User deeplink for sharing */
  shareUrl?: Maybe<Scalars['String']>;
  /** User website url */
  websiteUrl?: Maybe<Scalars['String']>;
  /** First Name */
  firstName?: Maybe<Scalars['String']>;
  /** Last Name */
  lastName?: Maybe<Scalars['String']>;
  /** User bio */
  bio?: Maybe<Scalars['String']>;
  /** Timestamp of the last User update */
  updatedAt?: Maybe<Scalars['DateTime']>;
  numberOfFollowedClusters: Scalars['Int'];
  isBlockedByUser: Scalars['Boolean'];
  areAllClustersFollowed: Scalars['Boolean'];
};


/** User public profile details */
export type UserPublicProfileIsBlockedByUserArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** User public profile details */
export type UserPublicProfileAreAllClustersFollowedArgs = {
  userId?: Maybe<Scalars['UserId']>;
};

/** List of user public profiles */
export type UserPublicProfileList = {
  __typename?: 'UserPublicProfileList';
  items: Array<UserPublicProfile>;
  meta: ListMetadata;
};

export type UserSortDefinitionInput = {
  sortField: UserSortField;
  sortDirection: SortDirection;
};

export enum UserSortField {
  Unspecified = 'UNSPECIFIED',
  CreatedAt = 'CREATED_AT',
  Username = 'USERNAME',
  UpdatedAt = 'UPDATED_AT',
  ReportsCounter = 'REPORTS_COUNTER'
}

/** User statistics */
export type UserStatistics = {
  __typename?: 'UserStatistics';
  /** Number of clusters */
  numberOfClusters: Scalars['Int'];
  /** Number of elements */
  numberOfElements: Scalars['Int'];
  /** Number of connections */
  numberOfConnections: Scalars['Int'];
  /** Number of followers */
  numberOfFollowers: Scalars['Int'];
  /** Number of following */
  numberOfFollowing: Scalars['Int'];
};

/** Username details */
export type Username = {
  __typename?: 'Username';
  /** Username */
  username: Scalars['String'];
  /** Is username premium */
  isPremium: Scalars['Boolean'];
  /** Is username available */
  isAvailable: Scalars['Boolean'];
  /** Is username valid */
  isValid: Scalars['Boolean'];
};


export type UsernameMutationGroup = {
  __typename?: 'UsernameMutationGroup';
  addPremiumUsernames: PremiumUsernameList;
  deletePremiumUsernames?: Maybe<MutationResponse>;
  addBannedUsernames?: Maybe<MutationResponse>;
  deleteBannedUsernames?: Maybe<MutationResponse>;
};


export type UsernameMutationGroupAddPremiumUsernamesArgs = {
  input: AddPremiumUsernamesInput;
};


export type UsernameMutationGroupDeletePremiumUsernamesArgs = {
  input: DeletePremiumUsernamesInput;
};


export type UsernameMutationGroupAddBannedUsernamesArgs = {
  input: AddBannedUsernamesInput;
};


export type UsernameMutationGroupDeleteBannedUsernamesArgs = {
  input: DeletePremiumUsernamesInput;
};

export type ValidInviteCode = {
  __typename?: 'ValidInviteCode';
  code: Scalars['String'];
  hasUsages?: Maybe<Scalars['Boolean']>;
  /** Returns null when invite code was created and sent by admin */
  inviter?: Maybe<UserPublicProfile>;
};

export type Video = {
  __typename?: 'Video';
  url: Scalars['String'];
  thumbnail?: Maybe<Thumbnail>;
  width: Scalars['Int'];
  height: Scalars['Int'];
  /** Duration of video */
  duration?: Maybe<Scalars['Seconds']>;
  /** Is video stored on Cosmos servers */
  isStored: Scalars['Boolean'];
};

/** Video element details */
export type VideoElement = ElementInterface & {
  __typename?: 'VideoElement';
  /** Element identifier */
  id: Scalars['ElementId'];
  /** Element owner identifier */
  ownerId?: Maybe<Scalars['UserId']>;
  /** Element url - original source of content */
  url?: Maybe<Scalars['String']>;
  /** Element text */
  text?: Maybe<Scalars['String']>;
  /** Is element process to retrieve article/image metadata information */
  isProcessed: Scalars['Boolean'];
  /** Type of element */
  type: ElementType;
  /** Element processing state */
  processingState: ElementProcessingState;
  /** Is element NSFW content */
  isNotSafeForWork?: Maybe<Scalars['Boolean']>;
  /** Element deeplink for sharing */
  shareUrl?: Maybe<Scalars['String']>;
  /** Number of reports to Element */
  reportsCounter: Scalars['Int'];
  /** Is element ready to display */
  isReady: Scalars['Boolean'];
  /** Is element url editable */
  isUrlEditable: Scalars['Boolean'];
  /** Timestamp of the last Element update */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Timestamp of the last Element update */
  createdAt?: Maybe<Scalars['DateTime']>;
  /**
   * Element video url
   * @deprecated Use video object instead
   */
  videoUrl?: Maybe<Scalars['String']>;
  /** Currently used only for Instagram or Twitter */
  video?: Maybe<Video>;
  /** Element image */
  image?: Maybe<Image>;
  /** @deprecated Use userTags and systemTags instead */
  tags?: Maybe<ElementTagList>;
  userTags: Array<Scalars['String']>;
  /** List of computer vision tags */
  computerVisionTags?: Maybe<Array<Scalars['String']>>;
  topConnections?: Maybe<ClusterList>;
  topUserConnections?: Maybe<UserPublicProfileList>;
  numberOfConnections: Scalars['Int'];
  isConnectedByUser: Scalars['Boolean'];
  /** Owner details */
  owner?: Maybe<UserPublicProfile>;
  hasConnectionWithCluster: Scalars['Boolean'];
  /** Color list */
  colors?: Maybe<Array<Scalars['String']>>;
  originalClusterId?: Maybe<Scalars['ClusterId']>;
  isFeatured: Scalars['Boolean'];
  isOnboarding: Scalars['Boolean'];
  oldestConnectionToPublicCluster?: Maybe<ElementConnection>;
  isSavedToLibrary: Scalars['Boolean'];
  rawVideo: Video;
  mux: Mux;
};


/** Video element details */
export type VideoElementTagsArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Video element details */
export type VideoElementUserTagsArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Video element details */
export type VideoElementTopConnectionsArgs = {
  userId?: Maybe<Scalars['UserId']>;
  meta?: Maybe<ListMetadataInput>;
};


/** Video element details */
export type VideoElementTopUserConnectionsArgs = {
  userId?: Maybe<Scalars['UserId']>;
  meta?: Maybe<ListMetadataInput>;
};


/** Video element details */
export type VideoElementNumberOfConnectionsArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Video element details */
export type VideoElementIsConnectedByUserArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Video element details */
export type VideoElementHasConnectionWithClusterArgs = {
  clusterId?: Maybe<Scalars['ClusterId']>;
  input?: Maybe<ClusterGetInput>;
};


/** Video element details */
export type VideoElementOriginalClusterIdArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Video element details */
export type VideoElementIsSavedToLibraryArgs = {
  userId?: Maybe<Scalars['UserId']>;
};

export type VisitedClusterContextualSearchHistoryEntry = {
  __typename?: 'VisitedClusterContextualSearchHistoryEntry';
  clusterId: Scalars['ClusterId'];
  /** Cluster details */
  cluster: Cluster;
};

export type VisitedClusterGlobalSearchHistoryEntry = {
  __typename?: 'VisitedClusterGlobalSearchHistoryEntry';
  clusterId: Scalars['ClusterId'];
  /** Cluster details */
  cluster: Cluster;
};

export type VisitedUserGlobalSearchHistoryEntry = {
  __typename?: 'VisitedUserGlobalSearchHistoryEntry';
  userId: Scalars['UserId'];
  /** User details */
  user: UserPublicProfile;
};

/** Waitlist */
export type Waitlist = {
  __typename?: 'Waitlist';
  items: Array<WaitlistItem>;
  meta: ListMetadata;
};

export type WaitlistFilters = {
  status?: Maybe<WaitlistItemStatus>;
  searchTerm?: Maybe<Scalars['String']>;
};

/** Waitlist item */
export type WaitlistItem = {
  __typename?: 'WaitlistItem';
  /** Email */
  email: Scalars['String'];
  /** How heard about us answer */
  howHeardAboutUsAnswer?: Maybe<Scalars['String']>;
  /** Status */
  waitlistItemStatus?: Maybe<WaitlistItemStatus>;
  /** Timestamp of the waitlist item creation */
  createdAt: Scalars['DateTime'];
  /** Invite code details */
  inviteCode?: Maybe<InviteCode>;
};

export enum WaitlistItemStatus {
  Unspecified = 'UNSPECIFIED',
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  NotInvited = 'NOT_INVITED'
}

export type WaitlistMutationGroup = {
  __typename?: 'WaitlistMutationGroup';
  join: MutationResponse;
  joinMany: MutationResponse;
  submitJoinFollowUpAnswer: MutationResponse;
};


export type WaitlistMutationGroupJoinArgs = {
  input: JoinWaitlistInput;
};


export type WaitlistMutationGroupJoinManyArgs = {
  input: JoinManyWaitlistInput;
};


export type WaitlistMutationGroupSubmitJoinFollowUpAnswerArgs = {
  input: SubmitJoinFollowUpAnswerInput;
};

export type WaitlistSortDefinitionInput = {
  sortField: WaitlistSortField;
  sortDirection: SortDirection;
};

export enum WaitlistSortField {
  Unspecified = 'UNSPECIFIED',
  Email = 'EMAIL',
  Status = 'STATUS',
  CreatedAt = 'CREATED_AT'
}

/** Youtube element details */
export type YoutubeElement = ElementInterface & {
  __typename?: 'YoutubeElement';
  /** Element identifier */
  id: Scalars['ElementId'];
  /** Element owner identifier */
  ownerId?: Maybe<Scalars['UserId']>;
  /** Element url - original source of content */
  url?: Maybe<Scalars['String']>;
  /** Element text */
  text?: Maybe<Scalars['String']>;
  /** Is element process to retrieve article/image metadata information */
  isProcessed: Scalars['Boolean'];
  /** Type of element */
  type: ElementType;
  /** Element processing state */
  processingState: ElementProcessingState;
  /** Is element NSFW content */
  isNotSafeForWork?: Maybe<Scalars['Boolean']>;
  /** Element deeplink for sharing */
  shareUrl?: Maybe<Scalars['String']>;
  /** Number of reports to Element */
  reportsCounter: Scalars['Int'];
  /** Is element ready to display */
  isReady: Scalars['Boolean'];
  /** Is element url editable */
  isUrlEditable: Scalars['Boolean'];
  /** Timestamp of the last Element update */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Timestamp of the last Element update */
  createdAt?: Maybe<Scalars['DateTime']>;
  /**
   * Element video url
   * @deprecated Use video object instead
   */
  videoUrl?: Maybe<Scalars['String']>;
  /** Currently used only for Instagram or Twitter */
  video?: Maybe<Video>;
  /** Element image */
  image?: Maybe<Image>;
  /** @deprecated Use userTags and systemTags instead */
  tags?: Maybe<ElementTagList>;
  userTags: Array<Scalars['String']>;
  /** List of computer vision tags */
  computerVisionTags?: Maybe<Array<Scalars['String']>>;
  topConnections?: Maybe<ClusterList>;
  topUserConnections?: Maybe<UserPublicProfileList>;
  numberOfConnections: Scalars['Int'];
  isConnectedByUser: Scalars['Boolean'];
  /** Owner details */
  owner?: Maybe<UserPublicProfile>;
  hasConnectionWithCluster: Scalars['Boolean'];
  /** Color list */
  colors?: Maybe<Array<Scalars['String']>>;
  originalClusterId?: Maybe<Scalars['ClusterId']>;
  isFeatured: Scalars['Boolean'];
  isOnboarding: Scalars['Boolean'];
  oldestConnectionToPublicCluster?: Maybe<ElementConnection>;
  isSavedToLibrary: Scalars['Boolean'];
  /** Youtube content html */
  html: Scalars['String'];
  /** Youtube content title */
  title: Scalars['String'];
  /** Youtube content author name */
  authorName: Scalars['String'];
  /** Youtube content author url */
  authorUrl: Scalars['String'];
};


/** Youtube element details */
export type YoutubeElementTagsArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Youtube element details */
export type YoutubeElementUserTagsArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Youtube element details */
export type YoutubeElementTopConnectionsArgs = {
  userId?: Maybe<Scalars['UserId']>;
  meta?: Maybe<ListMetadataInput>;
};


/** Youtube element details */
export type YoutubeElementTopUserConnectionsArgs = {
  userId?: Maybe<Scalars['UserId']>;
  meta?: Maybe<ListMetadataInput>;
};


/** Youtube element details */
export type YoutubeElementNumberOfConnectionsArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Youtube element details */
export type YoutubeElementIsConnectedByUserArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Youtube element details */
export type YoutubeElementHasConnectionWithClusterArgs = {
  clusterId?: Maybe<Scalars['ClusterId']>;
  input?: Maybe<ClusterGetInput>;
};


/** Youtube element details */
export type YoutubeElementOriginalClusterIdArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


/** Youtube element details */
export type YoutubeElementIsSavedToLibraryArgs = {
  userId?: Maybe<Scalars['UserId']>;
};

export type RefreshTokenMutationVariables = Exact<{
  input: RefreshAccessTokenInput;
}>;


export type RefreshTokenMutation = (
  { __typename?: 'Mutation' }
  & { auth?: Maybe<(
    { __typename?: 'AuthMutationGroup' }
    & { refreshAccessToken?: Maybe<(
      { __typename?: 'AuthMutationResponse' }
      & Pick<AuthMutationResponse, 'accessToken' | 'refreshToken'>
      & { user: (
        { __typename?: 'User' }
        & Pick<User, 'id'>
      ) }
    )> }
  )> }
);

export type GetStatisticsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStatisticsQuery = (
  { __typename?: 'Query' }
  & { elementsTotal: (
    { __typename?: 'ElementList' }
    & { meta: (
      { __typename?: 'ListMetadata' }
      & Pick<ListMetadata, 'count'>
    ) }
  ), elementsPublic: (
    { __typename?: 'ElementList' }
    & { meta: (
      { __typename?: 'ListMetadata' }
      & Pick<ListMetadata, 'count'>
    ) }
  ), elementsPrivate: (
    { __typename?: 'ElementList' }
    & { meta: (
      { __typename?: 'ListMetadata' }
      & Pick<ListMetadata, 'count'>
    ) }
  ), clusters: (
    { __typename?: 'ClusterList' }
    & { meta: (
      { __typename?: 'ListMetadata' }
      & Pick<ListMetadata, 'count'>
    ) }
  ), users: (
    { __typename?: 'UserList' }
    & { meta: (
      { __typename?: 'ListMetadata' }
      & Pick<ListMetadata, 'count'>
    ) }
  ), elementConnections: (
    { __typename?: 'ElementConnectionList' }
    & { meta: (
      { __typename?: 'ListMetadata' }
      & Pick<ListMetadata, 'count'>
    ) }
  ) }
);

type FeaturedElement_ArticleElement_Fragment = (
  { __typename?: 'ArticleElement' }
  & Pick<ArticleElement, 'id'>
  & ElementPreview_ArticleElement_Fragment
);

type FeaturedElement_Element_Fragment = (
  { __typename?: 'Element' }
  & Pick<Element, 'id'>
  & ElementPreview_Element_Fragment
);

type FeaturedElement_InstagramElement_Fragment = (
  { __typename?: 'InstagramElement' }
  & Pick<InstagramElement, 'id'>
  & ElementPreview_InstagramElement_Fragment
);

type FeaturedElement_MovieElement_Fragment = (
  { __typename?: 'MovieElement' }
  & Pick<MovieElement, 'id'>
  & ElementPreview_MovieElement_Fragment
);

type FeaturedElement_PinterestElement_Fragment = (
  { __typename?: 'PinterestElement' }
  & Pick<PinterestElement, 'id'>
  & ElementPreview_PinterestElement_Fragment
);

type FeaturedElement_ProductElement_Fragment = (
  { __typename?: 'ProductElement' }
  & Pick<ProductElement, 'id'>
  & ElementPreview_ProductElement_Fragment
);

type FeaturedElement_SpotifyElement_Fragment = (
  { __typename?: 'SpotifyElement' }
  & Pick<SpotifyElement, 'id'>
  & ElementPreview_SpotifyElement_Fragment
);

type FeaturedElement_TikTokElement_Fragment = (
  { __typename?: 'TikTokElement' }
  & Pick<TikTokElement, 'id'>
  & ElementPreview_TikTokElement_Fragment
);

type FeaturedElement_TwitterElement_Fragment = (
  { __typename?: 'TwitterElement' }
  & Pick<TwitterElement, 'id'>
  & ElementPreview_TwitterElement_Fragment
);

type FeaturedElement_VideoElement_Fragment = (
  { __typename?: 'VideoElement' }
  & Pick<VideoElement, 'id'>
  & ElementPreview_VideoElement_Fragment
);

type FeaturedElement_YoutubeElement_Fragment = (
  { __typename?: 'YoutubeElement' }
  & Pick<YoutubeElement, 'id'>
  & ElementPreview_YoutubeElement_Fragment
);

export type FeaturedElementFragment = FeaturedElement_ArticleElement_Fragment | FeaturedElement_Element_Fragment | FeaturedElement_InstagramElement_Fragment | FeaturedElement_MovieElement_Fragment | FeaturedElement_PinterestElement_Fragment | FeaturedElement_ProductElement_Fragment | FeaturedElement_SpotifyElement_Fragment | FeaturedElement_TikTokElement_Fragment | FeaturedElement_TwitterElement_Fragment | FeaturedElement_VideoElement_Fragment | FeaturedElement_YoutubeElement_Fragment;

export type FeaturedElementsQueryVariables = Exact<{
  meta?: Maybe<ListMetadataInput>;
}>;


export type FeaturedElementsQuery = (
  { __typename?: 'Query' }
  & { elements: (
    { __typename?: 'ElementList' }
    & { meta: (
      { __typename?: 'ListMetadata' }
      & Pick<ListMetadata, 'nextPageCursor'>
    ), items: Array<(
      { __typename?: 'ArticleElement' }
      & FeaturedElement_ArticleElement_Fragment
    ) | (
      { __typename?: 'Element' }
      & FeaturedElement_Element_Fragment
    ) | (
      { __typename?: 'InstagramElement' }
      & FeaturedElement_InstagramElement_Fragment
    ) | (
      { __typename?: 'MovieElement' }
      & FeaturedElement_MovieElement_Fragment
    ) | (
      { __typename?: 'PinterestElement' }
      & FeaturedElement_PinterestElement_Fragment
    ) | (
      { __typename?: 'ProductElement' }
      & FeaturedElement_ProductElement_Fragment
    ) | (
      { __typename?: 'SpotifyElement' }
      & FeaturedElement_SpotifyElement_Fragment
    ) | (
      { __typename?: 'TikTokElement' }
      & FeaturedElement_TikTokElement_Fragment
    ) | (
      { __typename?: 'TwitterElement' }
      & FeaturedElement_TwitterElement_Fragment
    ) | (
      { __typename?: 'VideoElement' }
      & FeaturedElement_VideoElement_Fragment
    ) | (
      { __typename?: 'YoutubeElement' }
      & FeaturedElement_YoutubeElement_Fragment
    )> }
  ) }
);

export type EditFeaturedElementsMutationVariables = Exact<{
  input: EditFeaturedElementsInput;
}>;


export type EditFeaturedElementsMutation = (
  { __typename?: 'Mutation' }
  & { element?: Maybe<(
    { __typename?: 'ElementMutationGroup' }
    & { editFeatured?: Maybe<(
      { __typename?: 'ElementList' }
      & { items: Array<(
        { __typename?: 'ArticleElement' }
        & FeaturedElement_ArticleElement_Fragment
      ) | (
        { __typename?: 'Element' }
        & FeaturedElement_Element_Fragment
      ) | (
        { __typename?: 'InstagramElement' }
        & FeaturedElement_InstagramElement_Fragment
      ) | (
        { __typename?: 'MovieElement' }
        & FeaturedElement_MovieElement_Fragment
      ) | (
        { __typename?: 'PinterestElement' }
        & FeaturedElement_PinterestElement_Fragment
      ) | (
        { __typename?: 'ProductElement' }
        & FeaturedElement_ProductElement_Fragment
      ) | (
        { __typename?: 'SpotifyElement' }
        & FeaturedElement_SpotifyElement_Fragment
      ) | (
        { __typename?: 'TikTokElement' }
        & FeaturedElement_TikTokElement_Fragment
      ) | (
        { __typename?: 'TwitterElement' }
        & FeaturedElement_TwitterElement_Fragment
      ) | (
        { __typename?: 'VideoElement' }
        & FeaturedElement_VideoElement_Fragment
      ) | (
        { __typename?: 'YoutubeElement' }
        & FeaturedElement_YoutubeElement_Fragment
      )> }
    )> }
  )> }
);

export type GetElementIfExistsQueryVariables = Exact<{
  id: Scalars['ElementId'];
}>;


export type GetElementIfExistsQuery = (
  { __typename?: 'Query' }
  & { element: (
    { __typename?: 'ArticleElement' }
    & FeaturedElement_ArticleElement_Fragment
  ) | (
    { __typename?: 'Element' }
    & FeaturedElement_Element_Fragment
  ) | (
    { __typename?: 'InstagramElement' }
    & FeaturedElement_InstagramElement_Fragment
  ) | (
    { __typename?: 'MovieElement' }
    & FeaturedElement_MovieElement_Fragment
  ) | (
    { __typename?: 'PinterestElement' }
    & FeaturedElement_PinterestElement_Fragment
  ) | (
    { __typename?: 'ProductElement' }
    & FeaturedElement_ProductElement_Fragment
  ) | (
    { __typename?: 'SpotifyElement' }
    & FeaturedElement_SpotifyElement_Fragment
  ) | (
    { __typename?: 'TikTokElement' }
    & FeaturedElement_TikTokElement_Fragment
  ) | (
    { __typename?: 'TwitterElement' }
    & FeaturedElement_TwitterElement_Fragment
  ) | (
    { __typename?: 'VideoElement' }
    & FeaturedElement_VideoElement_Fragment
  ) | (
    { __typename?: 'YoutubeElement' }
    & FeaturedElement_YoutubeElement_Fragment
  ) }
);

export type FeaturedClusterFragment = (
  { __typename?: 'Cluster' }
  & Pick<Cluster, 'id' | 'coverImageUrl'>
);

export type FeaturedClustersQueryVariables = Exact<{
  meta?: Maybe<ListMetadataInput>;
}>;


export type FeaturedClustersQuery = (
  { __typename?: 'Query' }
  & { clusters: (
    { __typename?: 'ClusterList' }
    & { meta: (
      { __typename?: 'ListMetadata' }
      & Pick<ListMetadata, 'nextPageCursor'>
    ), items: Array<(
      { __typename?: 'Cluster' }
      & FeaturedClusterFragment
    )> }
  ) }
);

export type EditFeaturedClustersMutationVariables = Exact<{
  input: EditFeaturedClustersInput;
}>;


export type EditFeaturedClustersMutation = (
  { __typename?: 'Mutation' }
  & { cluster?: Maybe<(
    { __typename?: 'ClusterMutationGroup' }
    & { editFeatured?: Maybe<(
      { __typename?: 'ClusterList' }
      & { meta: (
        { __typename?: 'ListMetadata' }
        & Pick<ListMetadata, 'nextPageCursor'>
      ), items: Array<(
        { __typename?: 'Cluster' }
        & FeaturedClusterFragment
      )> }
    )> }
  )> }
);

export type GetClusterIfExistsQueryVariables = Exact<{
  id: Scalars['ClusterId'];
}>;


export type GetClusterIfExistsQuery = (
  { __typename?: 'Query' }
  & { cluster: (
    { __typename?: 'Cluster' }
    & FeaturedClusterFragment
  ) }
);

type OnboardingElement_ArticleElement_Fragment = (
  { __typename?: 'ArticleElement' }
  & Pick<ArticleElement, 'id'>
  & ElementPreview_ArticleElement_Fragment
);

type OnboardingElement_Element_Fragment = (
  { __typename?: 'Element' }
  & Pick<Element, 'id'>
  & ElementPreview_Element_Fragment
);

type OnboardingElement_InstagramElement_Fragment = (
  { __typename?: 'InstagramElement' }
  & Pick<InstagramElement, 'id'>
  & ElementPreview_InstagramElement_Fragment
);

type OnboardingElement_MovieElement_Fragment = (
  { __typename?: 'MovieElement' }
  & Pick<MovieElement, 'id'>
  & ElementPreview_MovieElement_Fragment
);

type OnboardingElement_PinterestElement_Fragment = (
  { __typename?: 'PinterestElement' }
  & Pick<PinterestElement, 'id'>
  & ElementPreview_PinterestElement_Fragment
);

type OnboardingElement_ProductElement_Fragment = (
  { __typename?: 'ProductElement' }
  & Pick<ProductElement, 'id'>
  & ElementPreview_ProductElement_Fragment
);

type OnboardingElement_SpotifyElement_Fragment = (
  { __typename?: 'SpotifyElement' }
  & Pick<SpotifyElement, 'id'>
  & ElementPreview_SpotifyElement_Fragment
);

type OnboardingElement_TikTokElement_Fragment = (
  { __typename?: 'TikTokElement' }
  & Pick<TikTokElement, 'id'>
  & ElementPreview_TikTokElement_Fragment
);

type OnboardingElement_TwitterElement_Fragment = (
  { __typename?: 'TwitterElement' }
  & Pick<TwitterElement, 'id'>
  & ElementPreview_TwitterElement_Fragment
);

type OnboardingElement_VideoElement_Fragment = (
  { __typename?: 'VideoElement' }
  & Pick<VideoElement, 'id'>
  & ElementPreview_VideoElement_Fragment
);

type OnboardingElement_YoutubeElement_Fragment = (
  { __typename?: 'YoutubeElement' }
  & Pick<YoutubeElement, 'id'>
  & ElementPreview_YoutubeElement_Fragment
);

export type OnboardingElementFragment = OnboardingElement_ArticleElement_Fragment | OnboardingElement_Element_Fragment | OnboardingElement_InstagramElement_Fragment | OnboardingElement_MovieElement_Fragment | OnboardingElement_PinterestElement_Fragment | OnboardingElement_ProductElement_Fragment | OnboardingElement_SpotifyElement_Fragment | OnboardingElement_TikTokElement_Fragment | OnboardingElement_TwitterElement_Fragment | OnboardingElement_VideoElement_Fragment | OnboardingElement_YoutubeElement_Fragment;

export type OnboardingElementsQueryVariables = Exact<{
  meta?: Maybe<ListMetadataInput>;
}>;


export type OnboardingElementsQuery = (
  { __typename?: 'Query' }
  & { elements: (
    { __typename?: 'ElementList' }
    & { meta: (
      { __typename?: 'ListMetadata' }
      & Pick<ListMetadata, 'nextPageCursor'>
    ), items: Array<(
      { __typename?: 'ArticleElement' }
      & OnboardingElement_ArticleElement_Fragment
    ) | (
      { __typename?: 'Element' }
      & OnboardingElement_Element_Fragment
    ) | (
      { __typename?: 'InstagramElement' }
      & OnboardingElement_InstagramElement_Fragment
    ) | (
      { __typename?: 'MovieElement' }
      & OnboardingElement_MovieElement_Fragment
    ) | (
      { __typename?: 'PinterestElement' }
      & OnboardingElement_PinterestElement_Fragment
    ) | (
      { __typename?: 'ProductElement' }
      & OnboardingElement_ProductElement_Fragment
    ) | (
      { __typename?: 'SpotifyElement' }
      & OnboardingElement_SpotifyElement_Fragment
    ) | (
      { __typename?: 'TikTokElement' }
      & OnboardingElement_TikTokElement_Fragment
    ) | (
      { __typename?: 'TwitterElement' }
      & OnboardingElement_TwitterElement_Fragment
    ) | (
      { __typename?: 'VideoElement' }
      & OnboardingElement_VideoElement_Fragment
    ) | (
      { __typename?: 'YoutubeElement' }
      & OnboardingElement_YoutubeElement_Fragment
    )> }
  ) }
);

export type EditOnboardingElementsMutationVariables = Exact<{
  input: EditOnboardingElementsInput;
}>;


export type EditOnboardingElementsMutation = (
  { __typename?: 'Mutation' }
  & { element?: Maybe<(
    { __typename?: 'ElementMutationGroup' }
    & { editOnboarding?: Maybe<(
      { __typename?: 'ElementList' }
      & { items: Array<(
        { __typename?: 'ArticleElement' }
        & OnboardingElement_ArticleElement_Fragment
      ) | (
        { __typename?: 'Element' }
        & OnboardingElement_Element_Fragment
      ) | (
        { __typename?: 'InstagramElement' }
        & OnboardingElement_InstagramElement_Fragment
      ) | (
        { __typename?: 'MovieElement' }
        & OnboardingElement_MovieElement_Fragment
      ) | (
        { __typename?: 'PinterestElement' }
        & OnboardingElement_PinterestElement_Fragment
      ) | (
        { __typename?: 'ProductElement' }
        & OnboardingElement_ProductElement_Fragment
      ) | (
        { __typename?: 'SpotifyElement' }
        & OnboardingElement_SpotifyElement_Fragment
      ) | (
        { __typename?: 'TikTokElement' }
        & OnboardingElement_TikTokElement_Fragment
      ) | (
        { __typename?: 'TwitterElement' }
        & OnboardingElement_TwitterElement_Fragment
      ) | (
        { __typename?: 'VideoElement' }
        & OnboardingElement_VideoElement_Fragment
      ) | (
        { __typename?: 'YoutubeElement' }
        & OnboardingElement_YoutubeElement_Fragment
      )> }
    )> }
  )> }
);

export type GetOnboardingElementIfExistsQueryVariables = Exact<{
  id: Scalars['ElementId'];
}>;


export type GetOnboardingElementIfExistsQuery = (
  { __typename?: 'Query' }
  & { element: (
    { __typename?: 'ArticleElement' }
    & OnboardingElement_ArticleElement_Fragment
  ) | (
    { __typename?: 'Element' }
    & OnboardingElement_Element_Fragment
  ) | (
    { __typename?: 'InstagramElement' }
    & OnboardingElement_InstagramElement_Fragment
  ) | (
    { __typename?: 'MovieElement' }
    & OnboardingElement_MovieElement_Fragment
  ) | (
    { __typename?: 'PinterestElement' }
    & OnboardingElement_PinterestElement_Fragment
  ) | (
    { __typename?: 'ProductElement' }
    & OnboardingElement_ProductElement_Fragment
  ) | (
    { __typename?: 'SpotifyElement' }
    & OnboardingElement_SpotifyElement_Fragment
  ) | (
    { __typename?: 'TikTokElement' }
    & OnboardingElement_TikTokElement_Fragment
  ) | (
    { __typename?: 'TwitterElement' }
    & OnboardingElement_TwitterElement_Fragment
  ) | (
    { __typename?: 'VideoElement' }
    & OnboardingElement_VideoElement_Fragment
  ) | (
    { __typename?: 'YoutubeElement' }
    & OnboardingElement_YoutubeElement_Fragment
  ) }
);

export type BannedUsernameFragment = (
  { __typename?: 'BannedUsername' }
  & Pick<BannedUsername, 'username' | 'id'>
);

export type AddBannedUsernamesMutationVariables = Exact<{
  input: AddBannedUsernamesInput;
}>;


export type AddBannedUsernamesMutation = (
  { __typename?: 'Mutation' }
  & { username?: Maybe<(
    { __typename?: 'UsernameMutationGroup' }
    & { addBannedUsernames?: Maybe<(
      { __typename?: 'MutationResponse' }
      & Pick<MutationResponse, 'success'>
    )> }
  )> }
);

export type GetBannedUsernamesQueryVariables = Exact<{
  meta?: Maybe<ListMetadataInput>;
  filter?: Maybe<BannedUsernamesListFiltersInput>;
}>;


export type GetBannedUsernamesQuery = (
  { __typename?: 'Query' }
  & { listBannedUsernames: (
    { __typename?: 'BannedUsernameList' }
    & { meta: (
      { __typename?: 'ListMetadata' }
      & Pick<ListMetadata, 'count' | 'nextPageCursor' | 'pageCursor'>
    ), items: Array<(
      { __typename?: 'BannedUsername' }
      & BannedUsernameFragment
    )> }
  ) }
);

export type DeleteBannedUsernamesMutationVariables = Exact<{
  input: DeletePremiumUsernamesInput;
}>;


export type DeleteBannedUsernamesMutation = (
  { __typename?: 'Mutation' }
  & { username?: Maybe<(
    { __typename?: 'UsernameMutationGroup' }
    & { deleteBannedUsernames?: Maybe<(
      { __typename?: 'MutationResponse' }
      & Pick<MutationResponse, 'success'>
    )> }
  )> }
);

export type ClusterFragment = (
  { __typename?: 'Cluster' }
  & Pick<Cluster, 'id' | 'name' | 'isPrivate' | 'followersCount' | 'coverImageUrl' | 'coverImageHash' | 'coverImageElementId' | 'updatedAt' | 'numberOfElements' | 'isFeatured'>
  & { owner: (
    { __typename?: 'UserPublicProfile' }
    & Pick<UserPublicProfile, 'username' | 'name'>
  ), elements: (
    { __typename?: 'ElementList' }
    & { items: Array<(
      { __typename?: 'ArticleElement' }
      & Pick<ArticleElement, 'id'>
    ) | (
      { __typename?: 'Element' }
      & Pick<Element, 'id'>
    ) | (
      { __typename?: 'InstagramElement' }
      & Pick<InstagramElement, 'id'>
    ) | (
      { __typename?: 'MovieElement' }
      & Pick<MovieElement, 'id'>
    ) | (
      { __typename?: 'PinterestElement' }
      & Pick<PinterestElement, 'id'>
    ) | (
      { __typename?: 'ProductElement' }
      & Pick<ProductElement, 'id'>
    ) | (
      { __typename?: 'SpotifyElement' }
      & Pick<SpotifyElement, 'id'>
    ) | (
      { __typename?: 'TikTokElement' }
      & Pick<TikTokElement, 'id'>
    ) | (
      { __typename?: 'TwitterElement' }
      & Pick<TwitterElement, 'id'>
    ) | (
      { __typename?: 'VideoElement' }
      & Pick<VideoElement, 'id'>
    ) | (
      { __typename?: 'YoutubeElement' }
      & Pick<YoutubeElement, 'id'>
    )>, meta: (
      { __typename?: 'ListMetadata' }
      & Pick<ListMetadata, 'count'>
    ) }
  ) }
);

export type ClustersQueryVariables = Exact<{
  meta: ListMetadataInput;
  filters?: Maybe<ClusterListFilters>;
  sort?: Maybe<Array<SortDefinitionInput> | SortDefinitionInput>;
}>;


export type ClustersQuery = (
  { __typename?: 'Query' }
  & { clusters: (
    { __typename?: 'ClusterList' }
    & { items: Array<(
      { __typename?: 'Cluster' }
      & ClusterFragment
    )>, meta: (
      { __typename?: 'ListMetadata' }
      & Pick<ListMetadata, 'nextPageCursor' | 'count'>
    ) }
  ) }
);

export type ClusterFieldsFragment = (
  { __typename?: 'Cluster' }
  & Pick<Cluster, 'id' | 'name' | 'ownerId' | 'isPrivate' | 'followersCount' | 'coverImageUrl'>
);

export type ClusterDetailsQueryVariables = Exact<{
  id: Scalars['ClusterId'];
}>;


export type ClusterDetailsQuery = (
  { __typename?: 'Query' }
  & { cluster: (
    { __typename?: 'Cluster' }
    & ClusterFieldsFragment
  ) }
);

export type DeleteClusterMutationVariables = Exact<{
  ids: Array<Scalars['ClusterId']> | Scalars['ClusterId'];
}>;


export type DeleteClusterMutation = (
  { __typename?: 'Mutation' }
  & { admin?: Maybe<(
    { __typename?: 'AdminMutationGroup' }
    & { deleteClusters?: Maybe<(
      { __typename?: 'MutationResponse' }
      & Pick<MutationResponse, 'success'>
    )> }
  )> }
);

export type ClusterCollaboratorFragment = (
  { __typename?: 'Collaborator' }
  & Pick<Collaborator, 'userId' | 'isOwner' | 'status'>
);

export type ClusterCollaboratorsQueryVariables = Exact<{
  id: Scalars['ClusterId'];
  meta: ListMetadataInput;
}>;


export type ClusterCollaboratorsQuery = (
  { __typename?: 'Query' }
  & { cluster: (
    { __typename?: 'Cluster' }
    & Pick<Cluster, 'id'>
    & { collaborators: (
      { __typename?: 'CollaboratorList' }
      & { items: Array<(
        { __typename?: 'Collaborator' }
        & ClusterCollaboratorFragment
      )>, meta: (
        { __typename?: 'ListMetadata' }
        & Pick<ListMetadata, 'nextPageCursor'>
      ) }
    ) }
  ) }
);

export type ClusterRevokeIviteMutationVariables = Exact<{
  clusterId: Scalars['ClusterId'];
  userId: Scalars['UserId'];
}>;


export type ClusterRevokeIviteMutation = (
  { __typename?: 'Mutation' }
  & { cluster?: Maybe<(
    { __typename?: 'ClusterMutationGroup' }
    & { revokeCollaboratorInvite?: Maybe<(
      { __typename?: 'MutationResponse' }
      & Pick<MutationResponse, 'success'>
    )> }
  )> }
);

export type ClusterDeleteCollaboratorMutationVariables = Exact<{
  clusterId: Scalars['ClusterId'];
  userId: Scalars['UserId'];
}>;


export type ClusterDeleteCollaboratorMutation = (
  { __typename?: 'Mutation' }
  & { cluster?: Maybe<(
    { __typename?: 'ClusterMutationGroup' }
    & { deleteCollaborator?: Maybe<(
      { __typename?: 'MutationResponse' }
      & Pick<MutationResponse, 'success'>
    )> }
  )> }
);

export type InviteCollaboratorMutationVariables = Exact<{
  clusterId: Scalars['ClusterId'];
  userId: Scalars['UserId'];
}>;


export type InviteCollaboratorMutation = (
  { __typename?: 'Mutation' }
  & { cluster?: Maybe<(
    { __typename?: 'ClusterMutationGroup' }
    & { inviteCollaborator?: Maybe<(
      { __typename?: 'MutationResponse' }
      & Pick<MutationResponse, 'success'>
    )> }
  )> }
);

type ClusterElement_ArticleElement_Fragment = (
  { __typename?: 'ArticleElement' }
  & Pick<ArticleElement, 'id' | 'ownerId' | 'type' | 'text'>
  & { owner?: Maybe<(
    { __typename?: 'UserPublicProfile' }
    & Pick<UserPublicProfile, 'username'>
  )> }
);

type ClusterElement_Element_Fragment = (
  { __typename?: 'Element' }
  & Pick<Element, 'id' | 'ownerId' | 'type' | 'text'>
  & { owner?: Maybe<(
    { __typename?: 'UserPublicProfile' }
    & Pick<UserPublicProfile, 'username'>
  )> }
);

type ClusterElement_InstagramElement_Fragment = (
  { __typename?: 'InstagramElement' }
  & Pick<InstagramElement, 'id' | 'ownerId' | 'type' | 'text'>
  & { owner?: Maybe<(
    { __typename?: 'UserPublicProfile' }
    & Pick<UserPublicProfile, 'username'>
  )> }
);

type ClusterElement_MovieElement_Fragment = (
  { __typename?: 'MovieElement' }
  & Pick<MovieElement, 'id' | 'ownerId' | 'type' | 'text'>
  & { owner?: Maybe<(
    { __typename?: 'UserPublicProfile' }
    & Pick<UserPublicProfile, 'username'>
  )> }
);

type ClusterElement_PinterestElement_Fragment = (
  { __typename?: 'PinterestElement' }
  & Pick<PinterestElement, 'id' | 'ownerId' | 'type' | 'text'>
  & { owner?: Maybe<(
    { __typename?: 'UserPublicProfile' }
    & Pick<UserPublicProfile, 'username'>
  )> }
);

type ClusterElement_ProductElement_Fragment = (
  { __typename?: 'ProductElement' }
  & Pick<ProductElement, 'id' | 'ownerId' | 'type' | 'text'>
  & { owner?: Maybe<(
    { __typename?: 'UserPublicProfile' }
    & Pick<UserPublicProfile, 'username'>
  )> }
);

type ClusterElement_SpotifyElement_Fragment = (
  { __typename?: 'SpotifyElement' }
  & Pick<SpotifyElement, 'id' | 'ownerId' | 'type' | 'text'>
  & { owner?: Maybe<(
    { __typename?: 'UserPublicProfile' }
    & Pick<UserPublicProfile, 'username'>
  )> }
);

type ClusterElement_TikTokElement_Fragment = (
  { __typename?: 'TikTokElement' }
  & Pick<TikTokElement, 'id' | 'ownerId' | 'type' | 'text'>
  & { owner?: Maybe<(
    { __typename?: 'UserPublicProfile' }
    & Pick<UserPublicProfile, 'username'>
  )> }
);

type ClusterElement_TwitterElement_Fragment = (
  { __typename?: 'TwitterElement' }
  & Pick<TwitterElement, 'id' | 'ownerId' | 'type' | 'text'>
  & { owner?: Maybe<(
    { __typename?: 'UserPublicProfile' }
    & Pick<UserPublicProfile, 'username'>
  )> }
);

type ClusterElement_VideoElement_Fragment = (
  { __typename?: 'VideoElement' }
  & Pick<VideoElement, 'id' | 'ownerId' | 'type' | 'text'>
  & { owner?: Maybe<(
    { __typename?: 'UserPublicProfile' }
    & Pick<UserPublicProfile, 'username'>
  )> }
);

type ClusterElement_YoutubeElement_Fragment = (
  { __typename?: 'YoutubeElement' }
  & Pick<YoutubeElement, 'id' | 'ownerId' | 'type' | 'text'>
  & { owner?: Maybe<(
    { __typename?: 'UserPublicProfile' }
    & Pick<UserPublicProfile, 'username'>
  )> }
);

export type ClusterElementFragment = ClusterElement_ArticleElement_Fragment | ClusterElement_Element_Fragment | ClusterElement_InstagramElement_Fragment | ClusterElement_MovieElement_Fragment | ClusterElement_PinterestElement_Fragment | ClusterElement_ProductElement_Fragment | ClusterElement_SpotifyElement_Fragment | ClusterElement_TikTokElement_Fragment | ClusterElement_TwitterElement_Fragment | ClusterElement_VideoElement_Fragment | ClusterElement_YoutubeElement_Fragment;

export type ClusterElementsQueryVariables = Exact<{
  id: Scalars['ClusterId'];
  meta: ListMetadataInput;
}>;


export type ClusterElementsQuery = (
  { __typename?: 'Query' }
  & { cluster: (
    { __typename?: 'Cluster' }
    & Pick<Cluster, 'id'>
    & { elements: (
      { __typename?: 'ElementList' }
      & { items: Array<(
        { __typename?: 'ArticleElement' }
        & ClusterElement_ArticleElement_Fragment
      ) | (
        { __typename?: 'Element' }
        & ClusterElement_Element_Fragment
      ) | (
        { __typename?: 'InstagramElement' }
        & ClusterElement_InstagramElement_Fragment
      ) | (
        { __typename?: 'MovieElement' }
        & ClusterElement_MovieElement_Fragment
      ) | (
        { __typename?: 'PinterestElement' }
        & ClusterElement_PinterestElement_Fragment
      ) | (
        { __typename?: 'ProductElement' }
        & ClusterElement_ProductElement_Fragment
      ) | (
        { __typename?: 'SpotifyElement' }
        & ClusterElement_SpotifyElement_Fragment
      ) | (
        { __typename?: 'TikTokElement' }
        & ClusterElement_TikTokElement_Fragment
      ) | (
        { __typename?: 'TwitterElement' }
        & ClusterElement_TwitterElement_Fragment
      ) | (
        { __typename?: 'VideoElement' }
        & ClusterElement_VideoElement_Fragment
      ) | (
        { __typename?: 'YoutubeElement' }
        & ClusterElement_YoutubeElement_Fragment
      )>, meta: (
        { __typename?: 'ListMetadata' }
        & Pick<ListMetadata, 'nextPageCursor'>
      ) }
    ) }
  ) }
);

export type ClusterInviteFragment = (
  { __typename?: 'CollaborationInvite' }
  & Pick<CollaborationInvite, 'email'>
);

export type ClusterInvitesQueryVariables = Exact<{
  id: Scalars['ClusterId'];
  meta: ListMetadataInput;
}>;


export type ClusterInvitesQuery = (
  { __typename?: 'Query' }
  & { cluster: (
    { __typename?: 'Cluster' }
    & Pick<Cluster, 'id'>
    & { collaborationInvites: (
      { __typename?: 'CollaborationInviteList' }
      & { items: Array<(
        { __typename?: 'CollaborationInvite' }
        & ClusterInviteFragment
      )>, meta: (
        { __typename?: 'ListMetadata' }
        & Pick<ListMetadata, 'nextPageCursor'>
      ) }
    ) }
  ) }
);

export type ClusterRevokeInvitationMutationVariables = Exact<{
  clusterId: Scalars['ClusterId'];
  email: Scalars['String'];
}>;


export type ClusterRevokeInvitationMutation = (
  { __typename?: 'Mutation' }
  & { cluster?: Maybe<(
    { __typename?: 'ClusterMutationGroup' }
    & { revokeCollaboratorInvite?: Maybe<(
      { __typename?: 'MutationResponse' }
      & Pick<MutationResponse, 'success'>
    )> }
  )> }
);

export type SendEmailInviteMutationVariables = Exact<{
  clusterId: Scalars['ClusterId'];
  email: Scalars['String'];
}>;


export type SendEmailInviteMutation = (
  { __typename?: 'Mutation' }
  & { cluster?: Maybe<(
    { __typename?: 'ClusterMutationGroup' }
    & { inviteCollaborator?: Maybe<(
      { __typename?: 'MutationResponse' }
      & Pick<MutationResponse, 'success'>
    )> }
  )> }
);

type ElementDetails_ArticleElement_Fragment = (
  { __typename?: 'ArticleElement' }
  & Pick<ArticleElement, 'id' | 'isProcessed' | 'ownerId' | 'type' | 'numberOfConnections' | 'url' | 'shareUrl'>
  & { tags?: Maybe<(
    { __typename?: 'ElementTagList' }
    & { items: Array<(
      { __typename?: 'ElementTag' }
      & Pick<ElementTag, 'assignerId' | 'isSystemAssigned'>
      & { tag?: Maybe<(
        { __typename?: 'Tag' }
        & Pick<Tag, 'name' | 'id'>
      )> }
    )> }
  )> }
  & ElementPreview_ArticleElement_Fragment
);

type ElementDetails_Element_Fragment = (
  { __typename?: 'Element' }
  & Pick<Element, 'id' | 'isProcessed' | 'ownerId' | 'type' | 'numberOfConnections' | 'url' | 'shareUrl'>
  & { tags?: Maybe<(
    { __typename?: 'ElementTagList' }
    & { items: Array<(
      { __typename?: 'ElementTag' }
      & Pick<ElementTag, 'assignerId' | 'isSystemAssigned'>
      & { tag?: Maybe<(
        { __typename?: 'Tag' }
        & Pick<Tag, 'name' | 'id'>
      )> }
    )> }
  )> }
  & ElementPreview_Element_Fragment
);

type ElementDetails_InstagramElement_Fragment = (
  { __typename?: 'InstagramElement' }
  & Pick<InstagramElement, 'id' | 'isProcessed' | 'ownerId' | 'type' | 'numberOfConnections' | 'url' | 'shareUrl'>
  & { tags?: Maybe<(
    { __typename?: 'ElementTagList' }
    & { items: Array<(
      { __typename?: 'ElementTag' }
      & Pick<ElementTag, 'assignerId' | 'isSystemAssigned'>
      & { tag?: Maybe<(
        { __typename?: 'Tag' }
        & Pick<Tag, 'name' | 'id'>
      )> }
    )> }
  )> }
  & ElementPreview_InstagramElement_Fragment
);

type ElementDetails_MovieElement_Fragment = (
  { __typename?: 'MovieElement' }
  & Pick<MovieElement, 'id' | 'isProcessed' | 'ownerId' | 'type' | 'numberOfConnections' | 'url' | 'shareUrl'>
  & { tags?: Maybe<(
    { __typename?: 'ElementTagList' }
    & { items: Array<(
      { __typename?: 'ElementTag' }
      & Pick<ElementTag, 'assignerId' | 'isSystemAssigned'>
      & { tag?: Maybe<(
        { __typename?: 'Tag' }
        & Pick<Tag, 'name' | 'id'>
      )> }
    )> }
  )> }
  & ElementPreview_MovieElement_Fragment
);

type ElementDetails_PinterestElement_Fragment = (
  { __typename?: 'PinterestElement' }
  & Pick<PinterestElement, 'id' | 'isProcessed' | 'ownerId' | 'type' | 'numberOfConnections' | 'url' | 'shareUrl'>
  & { tags?: Maybe<(
    { __typename?: 'ElementTagList' }
    & { items: Array<(
      { __typename?: 'ElementTag' }
      & Pick<ElementTag, 'assignerId' | 'isSystemAssigned'>
      & { tag?: Maybe<(
        { __typename?: 'Tag' }
        & Pick<Tag, 'name' | 'id'>
      )> }
    )> }
  )> }
  & ElementPreview_PinterestElement_Fragment
);

type ElementDetails_ProductElement_Fragment = (
  { __typename?: 'ProductElement' }
  & Pick<ProductElement, 'id' | 'isProcessed' | 'ownerId' | 'type' | 'numberOfConnections' | 'url' | 'shareUrl'>
  & { tags?: Maybe<(
    { __typename?: 'ElementTagList' }
    & { items: Array<(
      { __typename?: 'ElementTag' }
      & Pick<ElementTag, 'assignerId' | 'isSystemAssigned'>
      & { tag?: Maybe<(
        { __typename?: 'Tag' }
        & Pick<Tag, 'name' | 'id'>
      )> }
    )> }
  )> }
  & ElementPreview_ProductElement_Fragment
);

type ElementDetails_SpotifyElement_Fragment = (
  { __typename?: 'SpotifyElement' }
  & Pick<SpotifyElement, 'id' | 'isProcessed' | 'ownerId' | 'type' | 'numberOfConnections' | 'url' | 'shareUrl'>
  & { tags?: Maybe<(
    { __typename?: 'ElementTagList' }
    & { items: Array<(
      { __typename?: 'ElementTag' }
      & Pick<ElementTag, 'assignerId' | 'isSystemAssigned'>
      & { tag?: Maybe<(
        { __typename?: 'Tag' }
        & Pick<Tag, 'name' | 'id'>
      )> }
    )> }
  )> }
  & ElementPreview_SpotifyElement_Fragment
);

type ElementDetails_TikTokElement_Fragment = (
  { __typename?: 'TikTokElement' }
  & Pick<TikTokElement, 'id' | 'isProcessed' | 'ownerId' | 'type' | 'numberOfConnections' | 'url' | 'shareUrl'>
  & { tags?: Maybe<(
    { __typename?: 'ElementTagList' }
    & { items: Array<(
      { __typename?: 'ElementTag' }
      & Pick<ElementTag, 'assignerId' | 'isSystemAssigned'>
      & { tag?: Maybe<(
        { __typename?: 'Tag' }
        & Pick<Tag, 'name' | 'id'>
      )> }
    )> }
  )> }
  & ElementPreview_TikTokElement_Fragment
);

type ElementDetails_TwitterElement_Fragment = (
  { __typename?: 'TwitterElement' }
  & Pick<TwitterElement, 'id' | 'isProcessed' | 'ownerId' | 'type' | 'numberOfConnections' | 'url' | 'shareUrl'>
  & { tags?: Maybe<(
    { __typename?: 'ElementTagList' }
    & { items: Array<(
      { __typename?: 'ElementTag' }
      & Pick<ElementTag, 'assignerId' | 'isSystemAssigned'>
      & { tag?: Maybe<(
        { __typename?: 'Tag' }
        & Pick<Tag, 'name' | 'id'>
      )> }
    )> }
  )> }
  & ElementPreview_TwitterElement_Fragment
);

type ElementDetails_VideoElement_Fragment = (
  { __typename?: 'VideoElement' }
  & Pick<VideoElement, 'id' | 'isProcessed' | 'ownerId' | 'type' | 'numberOfConnections' | 'url' | 'shareUrl'>
  & { tags?: Maybe<(
    { __typename?: 'ElementTagList' }
    & { items: Array<(
      { __typename?: 'ElementTag' }
      & Pick<ElementTag, 'assignerId' | 'isSystemAssigned'>
      & { tag?: Maybe<(
        { __typename?: 'Tag' }
        & Pick<Tag, 'name' | 'id'>
      )> }
    )> }
  )> }
  & ElementPreview_VideoElement_Fragment
);

type ElementDetails_YoutubeElement_Fragment = (
  { __typename?: 'YoutubeElement' }
  & Pick<YoutubeElement, 'id' | 'isProcessed' | 'ownerId' | 'type' | 'numberOfConnections' | 'url' | 'shareUrl'>
  & { tags?: Maybe<(
    { __typename?: 'ElementTagList' }
    & { items: Array<(
      { __typename?: 'ElementTag' }
      & Pick<ElementTag, 'assignerId' | 'isSystemAssigned'>
      & { tag?: Maybe<(
        { __typename?: 'Tag' }
        & Pick<Tag, 'name' | 'id'>
      )> }
    )> }
  )> }
  & ElementPreview_YoutubeElement_Fragment
);

export type ElementDetailsFragment = ElementDetails_ArticleElement_Fragment | ElementDetails_Element_Fragment | ElementDetails_InstagramElement_Fragment | ElementDetails_MovieElement_Fragment | ElementDetails_PinterestElement_Fragment | ElementDetails_ProductElement_Fragment | ElementDetails_SpotifyElement_Fragment | ElementDetails_TikTokElement_Fragment | ElementDetails_TwitterElement_Fragment | ElementDetails_VideoElement_Fragment | ElementDetails_YoutubeElement_Fragment;

export type ElementDetailsQueryVariables = Exact<{
  id: Scalars['ElementId'];
}>;


export type ElementDetailsQuery = (
  { __typename?: 'Query' }
  & { element: (
    { __typename?: 'ArticleElement' }
    & ElementDetails_ArticleElement_Fragment
  ) | (
    { __typename?: 'Element' }
    & ElementDetails_Element_Fragment
  ) | (
    { __typename?: 'InstagramElement' }
    & ElementDetails_InstagramElement_Fragment
  ) | (
    { __typename?: 'MovieElement' }
    & ElementDetails_MovieElement_Fragment
  ) | (
    { __typename?: 'PinterestElement' }
    & ElementDetails_PinterestElement_Fragment
  ) | (
    { __typename?: 'ProductElement' }
    & ElementDetails_ProductElement_Fragment
  ) | (
    { __typename?: 'SpotifyElement' }
    & ElementDetails_SpotifyElement_Fragment
  ) | (
    { __typename?: 'TikTokElement' }
    & ElementDetails_TikTokElement_Fragment
  ) | (
    { __typename?: 'TwitterElement' }
    & ElementDetails_TwitterElement_Fragment
  ) | (
    { __typename?: 'VideoElement' }
    & ElementDetails_VideoElement_Fragment
  ) | (
    { __typename?: 'YoutubeElement' }
    & ElementDetails_YoutubeElement_Fragment
  ) }
);

export type DeleteElementMutationVariables = Exact<{
  ids: Array<Scalars['ElementId']> | Scalars['ElementId'];
}>;


export type DeleteElementMutation = (
  { __typename?: 'Mutation' }
  & { admin?: Maybe<(
    { __typename?: 'AdminMutationGroup' }
    & { deleteElements?: Maybe<(
      { __typename?: 'MutationResponse' }
      & Pick<MutationResponse, 'success'>
    )> }
  )> }
);

type Element_ArticleElement_Fragment = (
  { __typename?: 'ArticleElement' }
  & Pick<ArticleElement, 'id' | 'ownerId' | 'type' | 'isFeatured' | 'isOnboarding' | 'createdAt'>
  & { owner?: Maybe<(
    { __typename?: 'UserPublicProfile' }
    & Pick<UserPublicProfile, 'username'>
  )>, image?: Maybe<(
    { __typename?: 'Image' }
    & { scaledImages: Array<Maybe<(
      { __typename?: 'Image' }
      & Pick<Image, 'url'>
    )>> }
  )> }
  & ElementPreview_ArticleElement_Fragment
);

type Element_Element_Fragment = (
  { __typename?: 'Element' }
  & Pick<Element, 'id' | 'ownerId' | 'type' | 'isFeatured' | 'isOnboarding' | 'createdAt'>
  & { owner?: Maybe<(
    { __typename?: 'UserPublicProfile' }
    & Pick<UserPublicProfile, 'username'>
  )>, image?: Maybe<(
    { __typename?: 'Image' }
    & { scaledImages: Array<Maybe<(
      { __typename?: 'Image' }
      & Pick<Image, 'url'>
    )>> }
  )> }
  & ElementPreview_Element_Fragment
);

type Element_InstagramElement_Fragment = (
  { __typename?: 'InstagramElement' }
  & Pick<InstagramElement, 'id' | 'ownerId' | 'type' | 'isFeatured' | 'isOnboarding' | 'createdAt'>
  & { owner?: Maybe<(
    { __typename?: 'UserPublicProfile' }
    & Pick<UserPublicProfile, 'username'>
  )>, image?: Maybe<(
    { __typename?: 'Image' }
    & { scaledImages: Array<Maybe<(
      { __typename?: 'Image' }
      & Pick<Image, 'url'>
    )>> }
  )> }
  & ElementPreview_InstagramElement_Fragment
);

type Element_MovieElement_Fragment = (
  { __typename?: 'MovieElement' }
  & Pick<MovieElement, 'id' | 'ownerId' | 'type' | 'isFeatured' | 'isOnboarding' | 'createdAt'>
  & { owner?: Maybe<(
    { __typename?: 'UserPublicProfile' }
    & Pick<UserPublicProfile, 'username'>
  )>, image?: Maybe<(
    { __typename?: 'Image' }
    & { scaledImages: Array<Maybe<(
      { __typename?: 'Image' }
      & Pick<Image, 'url'>
    )>> }
  )> }
  & ElementPreview_MovieElement_Fragment
);

type Element_PinterestElement_Fragment = (
  { __typename?: 'PinterestElement' }
  & Pick<PinterestElement, 'id' | 'ownerId' | 'type' | 'isFeatured' | 'isOnboarding' | 'createdAt'>
  & { owner?: Maybe<(
    { __typename?: 'UserPublicProfile' }
    & Pick<UserPublicProfile, 'username'>
  )>, image?: Maybe<(
    { __typename?: 'Image' }
    & { scaledImages: Array<Maybe<(
      { __typename?: 'Image' }
      & Pick<Image, 'url'>
    )>> }
  )> }
  & ElementPreview_PinterestElement_Fragment
);

type Element_ProductElement_Fragment = (
  { __typename?: 'ProductElement' }
  & Pick<ProductElement, 'id' | 'ownerId' | 'type' | 'isFeatured' | 'isOnboarding' | 'createdAt'>
  & { owner?: Maybe<(
    { __typename?: 'UserPublicProfile' }
    & Pick<UserPublicProfile, 'username'>
  )>, image?: Maybe<(
    { __typename?: 'Image' }
    & { scaledImages: Array<Maybe<(
      { __typename?: 'Image' }
      & Pick<Image, 'url'>
    )>> }
  )> }
  & ElementPreview_ProductElement_Fragment
);

type Element_SpotifyElement_Fragment = (
  { __typename?: 'SpotifyElement' }
  & Pick<SpotifyElement, 'id' | 'ownerId' | 'type' | 'isFeatured' | 'isOnboarding' | 'createdAt'>
  & { owner?: Maybe<(
    { __typename?: 'UserPublicProfile' }
    & Pick<UserPublicProfile, 'username'>
  )>, image?: Maybe<(
    { __typename?: 'Image' }
    & { scaledImages: Array<Maybe<(
      { __typename?: 'Image' }
      & Pick<Image, 'url'>
    )>> }
  )> }
  & ElementPreview_SpotifyElement_Fragment
);

type Element_TikTokElement_Fragment = (
  { __typename?: 'TikTokElement' }
  & Pick<TikTokElement, 'id' | 'ownerId' | 'type' | 'isFeatured' | 'isOnboarding' | 'createdAt'>
  & { owner?: Maybe<(
    { __typename?: 'UserPublicProfile' }
    & Pick<UserPublicProfile, 'username'>
  )>, image?: Maybe<(
    { __typename?: 'Image' }
    & { scaledImages: Array<Maybe<(
      { __typename?: 'Image' }
      & Pick<Image, 'url'>
    )>> }
  )> }
  & ElementPreview_TikTokElement_Fragment
);

type Element_TwitterElement_Fragment = (
  { __typename?: 'TwitterElement' }
  & Pick<TwitterElement, 'id' | 'ownerId' | 'type' | 'isFeatured' | 'isOnboarding' | 'createdAt'>
  & { owner?: Maybe<(
    { __typename?: 'UserPublicProfile' }
    & Pick<UserPublicProfile, 'username'>
  )>, image?: Maybe<(
    { __typename?: 'Image' }
    & { scaledImages: Array<Maybe<(
      { __typename?: 'Image' }
      & Pick<Image, 'url'>
    )>> }
  )> }
  & ElementPreview_TwitterElement_Fragment
);

type Element_VideoElement_Fragment = (
  { __typename?: 'VideoElement' }
  & Pick<VideoElement, 'id' | 'ownerId' | 'type' | 'isFeatured' | 'isOnboarding' | 'createdAt'>
  & { owner?: Maybe<(
    { __typename?: 'UserPublicProfile' }
    & Pick<UserPublicProfile, 'username'>
  )>, image?: Maybe<(
    { __typename?: 'Image' }
    & { scaledImages: Array<Maybe<(
      { __typename?: 'Image' }
      & Pick<Image, 'url'>
    )>> }
  )> }
  & ElementPreview_VideoElement_Fragment
);

type Element_YoutubeElement_Fragment = (
  { __typename?: 'YoutubeElement' }
  & Pick<YoutubeElement, 'id' | 'ownerId' | 'type' | 'isFeatured' | 'isOnboarding' | 'createdAt'>
  & { owner?: Maybe<(
    { __typename?: 'UserPublicProfile' }
    & Pick<UserPublicProfile, 'username'>
  )>, image?: Maybe<(
    { __typename?: 'Image' }
    & { scaledImages: Array<Maybe<(
      { __typename?: 'Image' }
      & Pick<Image, 'url'>
    )>> }
  )> }
  & ElementPreview_YoutubeElement_Fragment
);

export type ElementFragment = Element_ArticleElement_Fragment | Element_Element_Fragment | Element_InstagramElement_Fragment | Element_MovieElement_Fragment | Element_PinterestElement_Fragment | Element_ProductElement_Fragment | Element_SpotifyElement_Fragment | Element_TikTokElement_Fragment | Element_TwitterElement_Fragment | Element_VideoElement_Fragment | Element_YoutubeElement_Fragment;

export type ElementsQueryVariables = Exact<{
  meta: ListMetadataInput;
  filters?: Maybe<ElementListFilters>;
  sort?: Maybe<Array<ElementSortDefinitionInput> | ElementSortDefinitionInput>;
}>;


export type ElementsQuery = (
  { __typename?: 'Query' }
  & { elements: (
    { __typename?: 'ElementList' }
    & { meta: (
      { __typename?: 'ListMetadata' }
      & Pick<ListMetadata, 'count' | 'nextPageCursor' | 'pageCursor'>
    ), items: Array<(
      { __typename?: 'ArticleElement' }
      & Element_ArticleElement_Fragment
    ) | (
      { __typename?: 'Element' }
      & Element_Element_Fragment
    ) | (
      { __typename?: 'InstagramElement' }
      & Element_InstagramElement_Fragment
    ) | (
      { __typename?: 'MovieElement' }
      & Element_MovieElement_Fragment
    ) | (
      { __typename?: 'PinterestElement' }
      & Element_PinterestElement_Fragment
    ) | (
      { __typename?: 'ProductElement' }
      & Element_ProductElement_Fragment
    ) | (
      { __typename?: 'SpotifyElement' }
      & Element_SpotifyElement_Fragment
    ) | (
      { __typename?: 'TikTokElement' }
      & Element_TikTokElement_Fragment
    ) | (
      { __typename?: 'TwitterElement' }
      & Element_TwitterElement_Fragment
    ) | (
      { __typename?: 'VideoElement' }
      & Element_VideoElement_Fragment
    ) | (
      { __typename?: 'YoutubeElement' }
      & Element_YoutubeElement_Fragment
    )> }
  ) }
);

export type InvitesQueryVariables = Exact<{
  sortDefinitions?: Maybe<Array<PersonalInviteCodeSortDefinitionInput> | PersonalInviteCodeSortDefinitionInput>;
  filters?: Maybe<PersonalInviteCodeListFilters>;
  meta?: Maybe<ListMetadataInput>;
}>;


export type InvitesQuery = (
  { __typename?: 'Query' }
  & { personalInviteCodeList: (
    { __typename?: 'PersonalInviteCodeList' }
    & { items: Array<(
      { __typename?: 'PersonalInviteCode' }
      & Pick<PersonalInviteCode, 'userId' | 'inviteCode' | 'createdAt' | 'updatedAt' | 'username' | 'invitesLeft' | 'invitesUsed'>
    )>, meta: (
      { __typename?: 'ListMetadata' }
      & Pick<ListMetadata, 'pageSize' | 'pageCursor' | 'nextPageCursor' | 'count'>
    ) }
  ) }
);

export type PlatformSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type PlatformSettingsQuery = (
  { __typename?: 'Query' }
  & { platformSettings?: Maybe<(
    { __typename?: 'PlatformSettings' }
    & Pick<PlatformSettings, 'defaultInviteCodeMaxUsageCount' | 'privacyPolicy' | 'privacyTerms' | 'signUpElementId' | 'loginElementId' | 'adminEmail' | 'maxNumberOfElementsForFreeUser'>
  )> }
);

export type EditPlatformSettingsMutationVariables = Exact<{
  input: EditPlatformSettingsInput;
}>;


export type EditPlatformSettingsMutation = (
  { __typename?: 'Mutation' }
  & { platformSettings?: Maybe<(
    { __typename?: 'PlatformSettingsMutationGroup' }
    & { edit?: Maybe<(
      { __typename?: 'PlatformSettings' }
      & Pick<PlatformSettings, 'maxNumberOfElementsForFreeUser'>
    )> }
  )> }
);

export type IncreaseMaxUsageCountForUsersMutationVariables = Exact<{
  input: IncreaseMaxUsageCountForUsersInput;
}>;


export type IncreaseMaxUsageCountForUsersMutation = (
  { __typename?: 'Mutation' }
  & { inviteCode?: Maybe<(
    { __typename?: 'InviteCodeMutationGroup' }
    & { increaseMaxUsageCountForUsers?: Maybe<(
      { __typename?: 'MutationResponse' }
      & Pick<MutationResponse, 'success'>
    )> }
  )> }
);

export type IncreaseMaxUsageCountForUsersWithZeroInvitesLeftMutationVariables = Exact<{
  input: IncreaseMaxUsageCountForUsersWithZeroInvitesLeftInput;
}>;


export type IncreaseMaxUsageCountForUsersWithZeroInvitesLeftMutation = (
  { __typename?: 'Mutation' }
  & { inviteCode?: Maybe<(
    { __typename?: 'InviteCodeMutationGroup' }
    & { increaseMaxUsageCountForUsersWithZeroInvitesLeft?: Maybe<(
      { __typename?: 'MutationResponse' }
      & Pick<MutationResponse, 'success'>
    )> }
  )> }
);

export type BannedIpAddressFragment = (
  { __typename?: 'IpAddress' }
  & Pick<IpAddress, 'address' | 'id'>
);

export type BannedIpAddressesQueryVariables = Exact<{
  meta: ListMetadataInput;
}>;


export type BannedIpAddressesQuery = (
  { __typename?: 'Query' }
  & { listDisallowedIpAddresses?: Maybe<(
    { __typename?: 'IpAddressList' }
    & { items: Array<(
      { __typename?: 'IpAddress' }
      & BannedIpAddressFragment
    )>, meta: (
      { __typename?: 'ListMetadata' }
      & Pick<ListMetadata, 'pageSize' | 'pageCursor' | 'nextPageCursor' | 'count'>
    ) }
  )> }
);

export type DisallowIpAddressMutationVariables = Exact<{
  input: DisallowIpAddressInput;
}>;


export type DisallowIpAddressMutation = (
  { __typename?: 'Mutation' }
  & { admin?: Maybe<(
    { __typename?: 'AdminMutationGroup' }
    & { disallowIpAddress?: Maybe<(
      { __typename?: 'IpAddress' }
      & BannedIpAddressFragment
    )> }
  )> }
);

export type AllowIpAddressMutationVariables = Exact<{
  input: AllowIpAddressInput;
}>;


export type AllowIpAddressMutation = (
  { __typename?: 'Mutation' }
  & { admin?: Maybe<(
    { __typename?: 'AdminMutationGroup' }
    & { allowIpAddress?: Maybe<(
      { __typename?: 'MutationResponse' }
      & Pick<MutationResponse, 'success'>
    )> }
  )> }
);

export type LoginMutationVariables = Exact<{
  input: LoginAsAdminInput;
}>;


export type LoginMutation = (
  { __typename?: 'Mutation' }
  & { admin?: Maybe<(
    { __typename?: 'AdminMutationGroup' }
    & { loginAsAdmin?: Maybe<(
      { __typename?: 'AuthMutationResponse' }
      & Pick<AuthMutationResponse, 'accessToken' | 'refreshToken'>
      & { user: (
        { __typename?: 'User' }
        & Pick<User, 'id'>
      ) }
    )> }
  )> }
);

export type SetUserPremiumMutationVariables = Exact<{
  userId: Scalars['UserId'];
  expirationDate: Scalars['DateTime'];
}>;


export type SetUserPremiumMutation = (
  { __typename?: 'Mutation' }
  & { admin?: Maybe<(
    { __typename?: 'AdminMutationGroup' }
    & { setPremiumSubscription?: Maybe<(
      { __typename?: 'User' }
      & UserDetailsFragment
    )> }
  )> }
);

export type EditUsernameMutationVariables = Exact<{
  userId: Scalars['UserId'];
  username: Scalars['String'];
}>;


export type EditUsernameMutation = (
  { __typename?: 'Mutation' }
  & { auth?: Maybe<(
    { __typename?: 'AuthMutationGroup' }
    & { editUsername?: Maybe<(
      { __typename?: 'User' }
      & UserDetailsFragment
    )> }
  )> }
);

export type EditUserEmailMutationVariables = Exact<{
  userId: Scalars['UserId'];
  name: Scalars['String'];
  email: Scalars['String'];
}>;


export type EditUserEmailMutation = (
  { __typename?: 'Mutation' }
  & { auth?: Maybe<(
    { __typename?: 'AuthMutationGroup' }
    & { editProfile?: Maybe<(
      { __typename?: 'User' }
      & UserDetailsFragment
    )> }
  )> }
);

export type UserClustersFragment = (
  { __typename?: 'Cluster' }
  & Pick<Cluster, 'id' | 'name' | 'ownerId' | 'isPrivate' | 'followersCount' | 'coverImageUrl' | 'coverImageHash' | 'coverImageElementId'>
);

export type UserClustersQueryVariables = Exact<{
  meta: ListMetadataInput;
  filters?: Maybe<ClusterListFilters>;
}>;


export type UserClustersQuery = (
  { __typename?: 'Query' }
  & { clusters: (
    { __typename?: 'ClusterList' }
    & { items: Array<(
      { __typename?: 'Cluster' }
      & UserClustersFragment
    )>, meta: (
      { __typename?: 'ListMetadata' }
      & Pick<ListMetadata, 'nextPageCursor' | 'count'>
    ) }
  ) }
);

type UserElements_ArticleElement_Fragment = (
  { __typename?: 'ArticleElement' }
  & Pick<ArticleElement, 'id' | 'type'>
  & ElementPreview_ArticleElement_Fragment
);

type UserElements_Element_Fragment = (
  { __typename?: 'Element' }
  & Pick<Element, 'id' | 'type'>
  & ElementPreview_Element_Fragment
);

type UserElements_InstagramElement_Fragment = (
  { __typename?: 'InstagramElement' }
  & Pick<InstagramElement, 'id' | 'type'>
  & ElementPreview_InstagramElement_Fragment
);

type UserElements_MovieElement_Fragment = (
  { __typename?: 'MovieElement' }
  & Pick<MovieElement, 'id' | 'type'>
  & ElementPreview_MovieElement_Fragment
);

type UserElements_PinterestElement_Fragment = (
  { __typename?: 'PinterestElement' }
  & Pick<PinterestElement, 'id' | 'type'>
  & ElementPreview_PinterestElement_Fragment
);

type UserElements_ProductElement_Fragment = (
  { __typename?: 'ProductElement' }
  & Pick<ProductElement, 'id' | 'type'>
  & ElementPreview_ProductElement_Fragment
);

type UserElements_SpotifyElement_Fragment = (
  { __typename?: 'SpotifyElement' }
  & Pick<SpotifyElement, 'id' | 'type'>
  & ElementPreview_SpotifyElement_Fragment
);

type UserElements_TikTokElement_Fragment = (
  { __typename?: 'TikTokElement' }
  & Pick<TikTokElement, 'id' | 'type'>
  & ElementPreview_TikTokElement_Fragment
);

type UserElements_TwitterElement_Fragment = (
  { __typename?: 'TwitterElement' }
  & Pick<TwitterElement, 'id' | 'type'>
  & ElementPreview_TwitterElement_Fragment
);

type UserElements_VideoElement_Fragment = (
  { __typename?: 'VideoElement' }
  & Pick<VideoElement, 'id' | 'type'>
  & ElementPreview_VideoElement_Fragment
);

type UserElements_YoutubeElement_Fragment = (
  { __typename?: 'YoutubeElement' }
  & Pick<YoutubeElement, 'id' | 'type'>
  & ElementPreview_YoutubeElement_Fragment
);

export type UserElementsFragment = UserElements_ArticleElement_Fragment | UserElements_Element_Fragment | UserElements_InstagramElement_Fragment | UserElements_MovieElement_Fragment | UserElements_PinterestElement_Fragment | UserElements_ProductElement_Fragment | UserElements_SpotifyElement_Fragment | UserElements_TikTokElement_Fragment | UserElements_TwitterElement_Fragment | UserElements_VideoElement_Fragment | UserElements_YoutubeElement_Fragment;

export type UserElementsQueryVariables = Exact<{
  meta: ListMetadataInput;
  filters: ElementListFilters;
}>;


export type UserElementsQuery = (
  { __typename?: 'Query' }
  & { elements: (
    { __typename?: 'ElementList' }
    & { meta: (
      { __typename?: 'ListMetadata' }
      & Pick<ListMetadata, 'nextPageCursor' | 'count'>
    ), items: Array<(
      { __typename?: 'ArticleElement' }
      & UserElements_ArticleElement_Fragment
    ) | (
      { __typename?: 'Element' }
      & UserElements_Element_Fragment
    ) | (
      { __typename?: 'InstagramElement' }
      & UserElements_InstagramElement_Fragment
    ) | (
      { __typename?: 'MovieElement' }
      & UserElements_MovieElement_Fragment
    ) | (
      { __typename?: 'PinterestElement' }
      & UserElements_PinterestElement_Fragment
    ) | (
      { __typename?: 'ProductElement' }
      & UserElements_ProductElement_Fragment
    ) | (
      { __typename?: 'SpotifyElement' }
      & UserElements_SpotifyElement_Fragment
    ) | (
      { __typename?: 'TikTokElement' }
      & UserElements_TikTokElement_Fragment
    ) | (
      { __typename?: 'TwitterElement' }
      & UserElements_TwitterElement_Fragment
    ) | (
      { __typename?: 'VideoElement' }
      & UserElements_VideoElement_Fragment
    ) | (
      { __typename?: 'YoutubeElement' }
      & UserElements_YoutubeElement_Fragment
    )> }
  ) }
);

export type UserDetailsFragment = (
  { __typename?: 'User' }
  & Pick<User, 'avatarUrl' | 'id' | 'name' | 'username' | 'email' | 'emailConfirmed' | 'isPremium'>
  & { recentlyEditedCluster?: Maybe<(
    { __typename?: 'Cluster' }
    & Pick<Cluster, 'id'>
  )>, subscription?: Maybe<(
    { __typename?: 'Subscription' }
    & Pick<Subscription, 'id' | 'source' | 'subscriptionValidTo'>
    & { plan?: Maybe<(
      { __typename?: 'SubscriptionPlan' }
      & Pick<SubscriptionPlan, 'interval' | 'intervalCount' | 'priceId'>
      & { price?: Maybe<(
        { __typename?: 'Money' }
        & Pick<Money, 'currency' | 'value'>
      )> }
    )> }
  )> }
);

export type UserDetailsQueryVariables = Exact<{
  id: Scalars['UserId'];
}>;


export type UserDetailsQuery = (
  { __typename?: 'Query' }
  & { fullUser: (
    { __typename?: 'User' }
    & UserDetailsFragment
  ) }
);

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['UserId'];
}>;


export type DeleteUserMutation = (
  { __typename?: 'Mutation' }
  & { admin?: Maybe<(
    { __typename?: 'AdminMutationGroup' }
    & { deleteUser?: Maybe<(
      { __typename?: 'MutationResponse' }
      & Pick<MutationResponse, 'success'>
    )> }
  )> }
);

export type UsersFragment = (
  { __typename?: 'User' }
  & Pick<User, 'avatarHash' | 'avatarUrl' | 'id' | 'isPremium' | 'name' | 'username' | 'email' | 'createdAt'>
  & { statistics: (
    { __typename?: 'UserStatistics' }
    & Pick<UserStatistics, 'numberOfClusters' | 'numberOfElements' | 'numberOfConnections' | 'numberOfFollowers' | 'numberOfFollowing'>
  ) }
);

export type UsersQueryVariables = Exact<{
  meta: ListMetadataInput;
  filters?: Maybe<UserListFiltersInput>;
  sort?: Maybe<Array<UserSortDefinitionInput> | UserSortDefinitionInput>;
}>;


export type UsersQuery = (
  { __typename?: 'Query' }
  & { users: (
    { __typename?: 'UserList' }
    & { meta: (
      { __typename?: 'ListMetadata' }
      & Pick<ListMetadata, 'nextPageCursor' | 'count'>
    ), items: Array<(
      { __typename?: 'User' }
      & UsersFragment
    )> }
  ) }
);

export type InviteCodeFragment = (
  { __typename?: 'InviteCode' }
  & Pick<InviteCode, 'email' | 'value' | 'status' | 'createdAt' | 'name' | 'id'>
);

export type CreateCodeForNameEmailMutationVariables = Exact<{
  input: CreateInviteCodesInput;
}>;


export type CreateCodeForNameEmailMutation = (
  { __typename?: 'Mutation' }
  & { inviteCode?: Maybe<(
    { __typename?: 'InviteCodeMutationGroup' }
    & { create?: Maybe<(
      { __typename?: 'MutationResponse' }
      & Pick<MutationResponse, 'success'>
    )> }
  )> }
);

export type ResendInviteCodesEmailMutationVariables = Exact<{
  input: ResendInviteCodesEmailInput;
}>;


export type ResendInviteCodesEmailMutation = (
  { __typename?: 'Mutation' }
  & { inviteCode?: Maybe<(
    { __typename?: 'InviteCodeMutationGroup' }
    & { resend?: Maybe<(
      { __typename?: 'MutationResponse' }
      & Pick<MutationResponse, 'success'>
    )> }
  )> }
);

export type ResendAllPendingMutationVariables = Exact<{ [key: string]: never; }>;


export type ResendAllPendingMutation = (
  { __typename?: 'Mutation' }
  & { inviteCode?: Maybe<(
    { __typename?: 'InviteCodeMutationGroup' }
    & { resendAll?: Maybe<(
      { __typename?: 'MutationResponse' }
      & Pick<MutationResponse, 'success'>
    )> }
  )> }
);

export type GetInviteCodeListQueryVariables = Exact<{
  meta: ListMetadataInput;
  sort?: Maybe<Array<InviteCodeSortDefinitionInput> | InviteCodeSortDefinitionInput>;
  filter?: Maybe<InviteCodeListFilters>;
}>;


export type GetInviteCodeListQuery = (
  { __typename?: 'Query' }
  & { inviteCodeList: (
    { __typename?: 'InviteCodeList' }
    & { meta: (
      { __typename?: 'ListMetadata' }
      & Pick<ListMetadata, 'count' | 'nextPageCursor' | 'pageCursor'>
    ), items: Array<(
      { __typename?: 'InviteCode' }
      & InviteCodeFragment
    )> }
  ) }
);

export type GetEmailListQueryVariables = Exact<{
  sort?: Maybe<Array<InviteCodeSortDefinitionInput> | InviteCodeSortDefinitionInput>;
}>;


export type GetEmailListQuery = (
  { __typename?: 'Query' }
  & { inviteCodeList: (
    { __typename?: 'InviteCodeList' }
    & { items: Array<(
      { __typename?: 'InviteCode' }
      & InviteCodeFragment
    )> }
  ) }
);

export type DeleteInviteCodesMutationVariables = Exact<{
  input: DeleteInviteCodesInput;
}>;


export type DeleteInviteCodesMutation = (
  { __typename?: 'Mutation' }
  & { inviteCode?: Maybe<(
    { __typename?: 'InviteCodeMutationGroup' }
    & { delete?: Maybe<(
      { __typename?: 'MutationResponse' }
      & Pick<MutationResponse, 'success'>
    )> }
  )> }
);

export type CreateCodesWithoutEmailMutationVariables = Exact<{
  input: GenerateInviteCodesWithoutEmailInput;
}>;


export type CreateCodesWithoutEmailMutation = (
  { __typename?: 'Mutation' }
  & { inviteCode?: Maybe<(
    { __typename?: 'InviteCodeMutationGroup' }
    & { generateWithoutEmail?: Maybe<(
      { __typename?: 'InviteCodeGenerateWithoutEmailResponse' }
      & Pick<InviteCodeGenerateWithoutEmailResponse, 'inviteCodes'>
    )> }
  )> }
);

export type WaitlistQueryVariables = Exact<{
  sortDefinitions?: Maybe<Array<WaitlistSortDefinitionInput> | WaitlistSortDefinitionInput>;
  filters?: Maybe<WaitlistFilters>;
  meta?: Maybe<ListMetadataInput>;
}>;


export type WaitlistQuery = (
  { __typename?: 'Query' }
  & { waitlist: (
    { __typename?: 'Waitlist' }
    & { items: Array<(
      { __typename?: 'WaitlistItem' }
      & Pick<WaitlistItem, 'email' | 'howHeardAboutUsAnswer' | 'waitlistItemStatus' | 'createdAt'>
      & { inviteCode?: Maybe<(
        { __typename?: 'InviteCode' }
        & Pick<InviteCode, 'id' | 'email' | 'value' | 'name' | 'status' | 'grantsPremium' | 'createdAt'>
      )> }
    )>, meta: (
      { __typename?: 'ListMetadata' }
      & Pick<ListMetadata, 'pageSize' | 'pageCursor' | 'nextPageCursor' | 'count'>
    ) }
  ) }
);

export type JoinManyMutationVariables = Exact<{
  input: JoinManyWaitlistInput;
}>;


export type JoinManyMutation = (
  { __typename?: 'Mutation' }
  & { waitlist?: Maybe<(
    { __typename?: 'WaitlistMutationGroup' }
    & { joinMany: (
      { __typename?: 'MutationResponse' }
      & Pick<MutationResponse, 'success'>
    ) }
  )> }
);

export type WaitlistStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type WaitlistStatsQuery = (
  { __typename?: 'Query' }
  & { total: (
    { __typename?: 'Waitlist' }
    & { meta: (
      { __typename?: 'ListMetadata' }
      & Pick<ListMetadata, 'count'>
    ) }
  ), pending: (
    { __typename?: 'Waitlist' }
    & { meta: (
      { __typename?: 'ListMetadata' }
      & Pick<ListMetadata, 'count'>
    ) }
  ), accepted: (
    { __typename?: 'Waitlist' }
    & { meta: (
      { __typename?: 'ListMetadata' }
      & Pick<ListMetadata, 'count'>
    ) }
  ), notInvited: (
    { __typename?: 'Waitlist' }
    & { meta: (
      { __typename?: 'ListMetadata' }
      & Pick<ListMetadata, 'count'>
    ) }
  ) }
);

type ElementPreview_ArticleElement_Fragment = (
  { __typename?: 'ArticleElement' }
  & Pick<ArticleElement, 'type'>
  & WebsiteElementPreview_ArticleElement_Fragment
  & DefaultElementPreview_ArticleElement_Fragment
);

type ElementPreview_Element_Fragment = (
  { __typename?: 'Element' }
  & Pick<Element, 'type'>
  & WebsiteElementPreview_Element_Fragment
  & DefaultElementPreview_Element_Fragment
);

type ElementPreview_InstagramElement_Fragment = (
  { __typename?: 'InstagramElement' }
  & Pick<InstagramElement, 'type'>
  & InstagramElementPreviewFragment
  & WebsiteElementPreview_InstagramElement_Fragment
  & DefaultElementPreview_InstagramElement_Fragment
);

type ElementPreview_MovieElement_Fragment = (
  { __typename?: 'MovieElement' }
  & Pick<MovieElement, 'type'>
  & WebsiteElementPreview_MovieElement_Fragment
  & MovieElementPreviewFragment
  & DefaultElementPreview_MovieElement_Fragment
);

type ElementPreview_PinterestElement_Fragment = (
  { __typename?: 'PinterestElement' }
  & Pick<PinterestElement, 'type'>
  & WebsiteElementPreview_PinterestElement_Fragment
  & PinterestElementPreviewFragment
  & DefaultElementPreview_PinterestElement_Fragment
);

type ElementPreview_ProductElement_Fragment = (
  { __typename?: 'ProductElement' }
  & Pick<ProductElement, 'type'>
  & WebsiteElementPreview_ProductElement_Fragment
  & DefaultElementPreview_ProductElement_Fragment
);

type ElementPreview_SpotifyElement_Fragment = (
  { __typename?: 'SpotifyElement' }
  & Pick<SpotifyElement, 'type'>
  & WebsiteElementPreview_SpotifyElement_Fragment
  & SpotifyElementPreviewFragment
  & DefaultElementPreview_SpotifyElement_Fragment
);

type ElementPreview_TikTokElement_Fragment = (
  { __typename?: 'TikTokElement' }
  & Pick<TikTokElement, 'type'>
  & WebsiteElementPreview_TikTokElement_Fragment
  & DefaultElementPreview_TikTokElement_Fragment
);

type ElementPreview_TwitterElement_Fragment = (
  { __typename?: 'TwitterElement' }
  & Pick<TwitterElement, 'type'>
  & TwitterElementPreviewFragment
  & WebsiteElementPreview_TwitterElement_Fragment
  & DefaultElementPreview_TwitterElement_Fragment
);

type ElementPreview_VideoElement_Fragment = (
  { __typename?: 'VideoElement' }
  & Pick<VideoElement, 'type'>
  & WebsiteElementPreview_VideoElement_Fragment
  & VideoElementPreviewFragment
  & DefaultElementPreview_VideoElement_Fragment
);

type ElementPreview_YoutubeElement_Fragment = (
  { __typename?: 'YoutubeElement' }
  & Pick<YoutubeElement, 'type'>
  & WebsiteElementPreview_YoutubeElement_Fragment
  & YoutubeElementPreviewFragment
  & DefaultElementPreview_YoutubeElement_Fragment
);

export type ElementPreviewFragment = ElementPreview_ArticleElement_Fragment | ElementPreview_Element_Fragment | ElementPreview_InstagramElement_Fragment | ElementPreview_MovieElement_Fragment | ElementPreview_PinterestElement_Fragment | ElementPreview_ProductElement_Fragment | ElementPreview_SpotifyElement_Fragment | ElementPreview_TikTokElement_Fragment | ElementPreview_TwitterElement_Fragment | ElementPreview_VideoElement_Fragment | ElementPreview_YoutubeElement_Fragment;

export type VideoElementPreviewFragment = (
  { __typename?: 'VideoElement' }
  & Pick<VideoElement, 'id' | 'url'>
  & { image?: Maybe<(
    { __typename?: 'Image' }
    & Pick<Image, 'url'>
  )> }
);

type DefaultElementPreview_ArticleElement_Fragment = (
  { __typename?: 'ArticleElement' }
  & Pick<ArticleElement, 'text'>
  & { image?: Maybe<(
    { __typename?: 'Image' }
    & Pick<Image, 'url'>
  )> }
);

type DefaultElementPreview_Element_Fragment = (
  { __typename?: 'Element' }
  & Pick<Element, 'text'>
  & { image?: Maybe<(
    { __typename?: 'Image' }
    & Pick<Image, 'url'>
  )> }
);

type DefaultElementPreview_InstagramElement_Fragment = (
  { __typename?: 'InstagramElement' }
  & Pick<InstagramElement, 'text'>
  & { image?: Maybe<(
    { __typename?: 'Image' }
    & Pick<Image, 'url'>
  )> }
);

type DefaultElementPreview_MovieElement_Fragment = (
  { __typename?: 'MovieElement' }
  & Pick<MovieElement, 'text'>
  & { image?: Maybe<(
    { __typename?: 'Image' }
    & Pick<Image, 'url'>
  )> }
);

type DefaultElementPreview_PinterestElement_Fragment = (
  { __typename?: 'PinterestElement' }
  & Pick<PinterestElement, 'text'>
  & { image?: Maybe<(
    { __typename?: 'Image' }
    & Pick<Image, 'url'>
  )> }
);

type DefaultElementPreview_ProductElement_Fragment = (
  { __typename?: 'ProductElement' }
  & Pick<ProductElement, 'text'>
  & { image?: Maybe<(
    { __typename?: 'Image' }
    & Pick<Image, 'url'>
  )> }
);

type DefaultElementPreview_SpotifyElement_Fragment = (
  { __typename?: 'SpotifyElement' }
  & Pick<SpotifyElement, 'text'>
  & { image?: Maybe<(
    { __typename?: 'Image' }
    & Pick<Image, 'url'>
  )> }
);

type DefaultElementPreview_TikTokElement_Fragment = (
  { __typename?: 'TikTokElement' }
  & Pick<TikTokElement, 'text'>
  & { image?: Maybe<(
    { __typename?: 'Image' }
    & Pick<Image, 'url'>
  )> }
);

type DefaultElementPreview_TwitterElement_Fragment = (
  { __typename?: 'TwitterElement' }
  & Pick<TwitterElement, 'text'>
  & { image?: Maybe<(
    { __typename?: 'Image' }
    & Pick<Image, 'url'>
  )> }
);

type DefaultElementPreview_VideoElement_Fragment = (
  { __typename?: 'VideoElement' }
  & Pick<VideoElement, 'text'>
  & { image?: Maybe<(
    { __typename?: 'Image' }
    & Pick<Image, 'url'>
  )> }
);

type DefaultElementPreview_YoutubeElement_Fragment = (
  { __typename?: 'YoutubeElement' }
  & Pick<YoutubeElement, 'text'>
  & { image?: Maybe<(
    { __typename?: 'Image' }
    & Pick<Image, 'url'>
  )> }
);

export type DefaultElementPreviewFragment = DefaultElementPreview_ArticleElement_Fragment | DefaultElementPreview_Element_Fragment | DefaultElementPreview_InstagramElement_Fragment | DefaultElementPreview_MovieElement_Fragment | DefaultElementPreview_PinterestElement_Fragment | DefaultElementPreview_ProductElement_Fragment | DefaultElementPreview_SpotifyElement_Fragment | DefaultElementPreview_TikTokElement_Fragment | DefaultElementPreview_TwitterElement_Fragment | DefaultElementPreview_VideoElement_Fragment | DefaultElementPreview_YoutubeElement_Fragment;

export type InstagramElementPreviewFragment = (
  { __typename?: 'InstagramElement' }
  & Pick<InstagramElement, 'authorName'>
  & { image?: Maybe<(
    { __typename?: 'Image' }
    & Pick<Image, 'url'>
  )> }
);

export type MovieElementPreviewFragment = (
  { __typename?: 'MovieElement' }
  & Pick<MovieElement, 'movieTitle' | 'movieYear' | 'movieRating'>
  & { image?: Maybe<(
    { __typename?: 'Image' }
    & Pick<Image, 'url'>
  )> }
);

export type PinterestElementPreviewFragment = (
  { __typename?: 'PinterestElement' }
  & Pick<PinterestElement, 'authorProfileImageUrl'>
  & { pinterestAuthorName: PinterestElement['authorName'] }
  & { image?: Maybe<(
    { __typename?: 'Image' }
    & Pick<Image, 'url'>
  )> }
);

export type SpotifyElementPreviewFragment = (
  { __typename?: 'SpotifyElement' }
  & { spotifyHtml: SpotifyElement['html'] }
);

export type TwitterElementPreviewFragment = (
  { __typename?: 'TwitterElement' }
  & Pick<TwitterElement, 'authorProfileImageUrl'>
  & { twitterHtml: TwitterElement['html'] }
);

type WebsiteElementPreview_ArticleElement_Fragment = (
  { __typename?: 'ArticleElement' }
  & Pick<ArticleElement, 'url'>
);

type WebsiteElementPreview_Element_Fragment = (
  { __typename?: 'Element' }
  & Pick<Element, 'url'>
);

type WebsiteElementPreview_InstagramElement_Fragment = (
  { __typename?: 'InstagramElement' }
  & Pick<InstagramElement, 'url'>
);

type WebsiteElementPreview_MovieElement_Fragment = (
  { __typename?: 'MovieElement' }
  & Pick<MovieElement, 'url'>
);

type WebsiteElementPreview_PinterestElement_Fragment = (
  { __typename?: 'PinterestElement' }
  & Pick<PinterestElement, 'url'>
);

type WebsiteElementPreview_ProductElement_Fragment = (
  { __typename?: 'ProductElement' }
  & Pick<ProductElement, 'url'>
);

type WebsiteElementPreview_SpotifyElement_Fragment = (
  { __typename?: 'SpotifyElement' }
  & Pick<SpotifyElement, 'url'>
);

type WebsiteElementPreview_TikTokElement_Fragment = (
  { __typename?: 'TikTokElement' }
  & Pick<TikTokElement, 'url'>
);

type WebsiteElementPreview_TwitterElement_Fragment = (
  { __typename?: 'TwitterElement' }
  & Pick<TwitterElement, 'url'>
);

type WebsiteElementPreview_VideoElement_Fragment = (
  { __typename?: 'VideoElement' }
  & Pick<VideoElement, 'url'>
);

type WebsiteElementPreview_YoutubeElement_Fragment = (
  { __typename?: 'YoutubeElement' }
  & Pick<YoutubeElement, 'url'>
);

export type WebsiteElementPreviewFragment = WebsiteElementPreview_ArticleElement_Fragment | WebsiteElementPreview_Element_Fragment | WebsiteElementPreview_InstagramElement_Fragment | WebsiteElementPreview_MovieElement_Fragment | WebsiteElementPreview_PinterestElement_Fragment | WebsiteElementPreview_ProductElement_Fragment | WebsiteElementPreview_SpotifyElement_Fragment | WebsiteElementPreview_TikTokElement_Fragment | WebsiteElementPreview_TwitterElement_Fragment | WebsiteElementPreview_VideoElement_Fragment | WebsiteElementPreview_YoutubeElement_Fragment;

export type YoutubeElementPreviewFragment = (
  { __typename?: 'YoutubeElement' }
  & { youtubeHtml: YoutubeElement['html'] }
  & { image?: Maybe<(
    { __typename?: 'Image' }
    & Pick<Image, 'url'>
  )> }
);

export const InstagramElementPreviewFragmentDoc = gql`
    fragment InstagramElementPreview on InstagramElement {
  authorName
  image {
    url
  }
}
    `;
export const TwitterElementPreviewFragmentDoc = gql`
    fragment TwitterElementPreview on TwitterElement {
  authorProfileImageUrl
  twitterHtml: html
}
    `;
export const WebsiteElementPreviewFragmentDoc = gql`
    fragment WebsiteElementPreview on ElementInterface {
  url
}
    `;
export const SpotifyElementPreviewFragmentDoc = gql`
    fragment SpotifyElementPreview on SpotifyElement {
  spotifyHtml: html
}
    `;
export const YoutubeElementPreviewFragmentDoc = gql`
    fragment YoutubeElementPreview on YoutubeElement {
  youtubeHtml: html
  image {
    url
  }
}
    `;
export const MovieElementPreviewFragmentDoc = gql`
    fragment MovieElementPreview on MovieElement {
  movieTitle
  movieYear
  movieRating
  image {
    url
  }
}
    `;
export const PinterestElementPreviewFragmentDoc = gql`
    fragment PinterestElementPreview on PinterestElement {
  pinterestAuthorName: authorName
  authorProfileImageUrl
  image {
    url
  }
}
    `;
export const VideoElementPreviewFragmentDoc = gql`
    fragment VideoElementPreview on VideoElement {
  id
  url
  image {
    url
  }
}
    `;
export const DefaultElementPreviewFragmentDoc = gql`
    fragment DefaultElementPreview on ElementInterface {
  image {
    url
  }
  text
}
    `;
export const ElementPreviewFragmentDoc = gql`
    fragment ElementPreview on ElementInterface {
  type
  ...InstagramElementPreview
  ...TwitterElementPreview
  ...WebsiteElementPreview
  ...SpotifyElementPreview
  ...YoutubeElementPreview
  ...MovieElementPreview
  ...PinterestElementPreview
  ...VideoElementPreview
  ...DefaultElementPreview
}
    ${InstagramElementPreviewFragmentDoc}
${TwitterElementPreviewFragmentDoc}
${WebsiteElementPreviewFragmentDoc}
${SpotifyElementPreviewFragmentDoc}
${YoutubeElementPreviewFragmentDoc}
${MovieElementPreviewFragmentDoc}
${PinterestElementPreviewFragmentDoc}
${VideoElementPreviewFragmentDoc}
${DefaultElementPreviewFragmentDoc}`;
export const FeaturedElementFragmentDoc = gql`
    fragment FeaturedElement on ElementInterface {
  id
  ...ElementPreview
}
    ${ElementPreviewFragmentDoc}`;
export const FeaturedClusterFragmentDoc = gql`
    fragment FeaturedCluster on Cluster {
  id
  coverImageUrl
}
    `;
export const OnboardingElementFragmentDoc = gql`
    fragment OnboardingElement on ElementInterface {
  id
  ...ElementPreview
}
    ${ElementPreviewFragmentDoc}`;
export const BannedUsernameFragmentDoc = gql`
    fragment BannedUsername on BannedUsername {
  username
  id
}
    `;
export const ClusterFragmentDoc = gql`
    fragment Cluster on Cluster {
  id
  name
  owner {
    username
    name
  }
  elements(meta: {pageSize: 1}) {
    items {
      id
    }
    meta {
      count
    }
  }
  isPrivate
  followersCount
  coverImageUrl
  coverImageHash
  coverImageElementId
  updatedAt
  numberOfElements
  isFeatured
}
    `;
export const ClusterFieldsFragmentDoc = gql`
    fragment ClusterFields on Cluster {
  id
  name
  ownerId
  isPrivate
  followersCount
  coverImageUrl
}
    `;
export const ClusterCollaboratorFragmentDoc = gql`
    fragment ClusterCollaborator on Collaborator {
  userId
  isOwner
  status
}
    `;
export const ClusterElementFragmentDoc = gql`
    fragment ClusterElement on ElementInterface {
  id
  ownerId
  owner {
    username
  }
  type
  text
}
    `;
export const ClusterInviteFragmentDoc = gql`
    fragment ClusterInvite on CollaborationInvite {
  email
}
    `;
export const ElementDetailsFragmentDoc = gql`
    fragment ElementDetails on ElementInterface {
  id
  isProcessed
  ownerId
  type
  numberOfConnections
  url
  shareUrl
  tags {
    items {
      assignerId
      tag {
        name
        id
      }
      isSystemAssigned
    }
  }
  ...ElementPreview
}
    ${ElementPreviewFragmentDoc}`;
export const ElementFragmentDoc = gql`
    fragment Element on ElementInterface {
  id
  ownerId
  owner {
    username
  }
  type
  ...ElementPreview
  image {
    scaledImages(widths: [160]) {
      url
    }
  }
  isFeatured
  isOnboarding
  createdAt
}
    ${ElementPreviewFragmentDoc}`;
export const BannedIpAddressFragmentDoc = gql`
    fragment BannedIpAddress on IpAddress {
  address
  id
}
    `;
export const UserClustersFragmentDoc = gql`
    fragment UserClusters on Cluster {
  id
  name
  ownerId
  isPrivate
  followersCount
  coverImageUrl
  coverImageHash
  coverImageElementId
}
    `;
export const UserElementsFragmentDoc = gql`
    fragment UserElements on ElementInterface {
  id
  type
  ...ElementPreview
}
    ${ElementPreviewFragmentDoc}`;
export const UserDetailsFragmentDoc = gql`
    fragment UserDetails on User {
  avatarUrl
  id
  name
  username
  email
  emailConfirmed
  isPremium
  recentlyEditedCluster {
    id
  }
  subscription {
    id
    plan {
      interval
      intervalCount
      price {
        currency
        value
      }
      priceId
    }
    source
    subscriptionValidTo
  }
}
    `;
export const UsersFragmentDoc = gql`
    fragment Users on User {
  avatarHash
  avatarUrl
  id
  isPremium
  name
  username
  email
  statistics {
    numberOfClusters
    numberOfElements
    numberOfConnections
    numberOfFollowers
    numberOfFollowing
  }
  createdAt
}
    `;
export const InviteCodeFragmentDoc = gql`
    fragment InviteCode on InviteCode {
  email
  value
  status
  createdAt
  name
  id
}
    `;
export const RefreshTokenDocument = gql`
    mutation RefreshToken($input: RefreshAccessTokenInput!) {
  auth {
    refreshAccessToken(input: $input) {
      accessToken
      refreshToken
      user {
        id
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RefreshTokenGQL extends Apollo.Mutation<RefreshTokenMutation, RefreshTokenMutationVariables> {
    document = RefreshTokenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetStatisticsDocument = gql`
    query getStatistics {
  elementsTotal: elements {
    meta {
      count
    }
  }
  elementsPublic: elements(filters: {isPublic: true}) {
    meta {
      count
    }
  }
  elementsPrivate: elements(filters: {isPublic: false}) {
    meta {
      count
    }
  }
  clusters {
    meta {
      count
    }
  }
  users {
    meta {
      count
    }
  }
  elementConnections {
    meta {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetStatisticsGQL extends Apollo.Query<GetStatisticsQuery, GetStatisticsQueryVariables> {
    document = GetStatisticsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FeaturedElementsDocument = gql`
    query FeaturedElements($meta: ListMetadataInput) {
  elements(meta: $meta, filters: {isFeatured: true}) {
    meta {
      nextPageCursor
    }
    items {
      ...FeaturedElement
    }
  }
}
    ${FeaturedElementFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FeaturedElementsGQL extends Apollo.Query<FeaturedElementsQuery, FeaturedElementsQueryVariables> {
    document = FeaturedElementsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EditFeaturedElementsDocument = gql`
    mutation EditFeaturedElements($input: EditFeaturedElementsInput!) {
  element {
    editFeatured(input: $input) {
      items {
        ...FeaturedElement
      }
    }
  }
}
    ${FeaturedElementFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class EditFeaturedElementsGQL extends Apollo.Mutation<EditFeaturedElementsMutation, EditFeaturedElementsMutationVariables> {
    document = EditFeaturedElementsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetElementIfExistsDocument = gql`
    query GetElementIfExists($id: ElementId!) {
  element(id: $id) {
    ...FeaturedElement
  }
}
    ${FeaturedElementFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetElementIfExistsGQL extends Apollo.Query<GetElementIfExistsQuery, GetElementIfExistsQueryVariables> {
    document = GetElementIfExistsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FeaturedClustersDocument = gql`
    query FeaturedClusters($meta: ListMetadataInput) {
  clusters(meta: $meta, filters: {isFeatured: true}) {
    meta {
      nextPageCursor
    }
    items {
      ...FeaturedCluster
    }
  }
}
    ${FeaturedClusterFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FeaturedClustersGQL extends Apollo.Query<FeaturedClustersQuery, FeaturedClustersQueryVariables> {
    document = FeaturedClustersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EditFeaturedClustersDocument = gql`
    mutation EditFeaturedClusters($input: EditFeaturedClustersInput!) {
  cluster {
    editFeatured(input: $input) {
      meta {
        nextPageCursor
      }
      items {
        ...FeaturedCluster
      }
    }
  }
}
    ${FeaturedClusterFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class EditFeaturedClustersGQL extends Apollo.Mutation<EditFeaturedClustersMutation, EditFeaturedClustersMutationVariables> {
    document = EditFeaturedClustersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetClusterIfExistsDocument = gql`
    query GetClusterIfExists($id: ClusterId!) {
  cluster(id: $id) {
    ...FeaturedCluster
  }
}
    ${FeaturedClusterFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetClusterIfExistsGQL extends Apollo.Query<GetClusterIfExistsQuery, GetClusterIfExistsQueryVariables> {
    document = GetClusterIfExistsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnboardingElementsDocument = gql`
    query OnboardingElements($meta: ListMetadataInput) {
  elements(meta: $meta, filters: {isOnboarding: true}) {
    meta {
      nextPageCursor
    }
    items {
      ...OnboardingElement
    }
  }
}
    ${OnboardingElementFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OnboardingElementsGQL extends Apollo.Query<OnboardingElementsQuery, OnboardingElementsQueryVariables> {
    document = OnboardingElementsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EditOnboardingElementsDocument = gql`
    mutation EditOnboardingElements($input: EditOnboardingElementsInput!) {
  element {
    editOnboarding(input: $input) {
      items {
        ...OnboardingElement
      }
    }
  }
}
    ${OnboardingElementFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class EditOnboardingElementsGQL extends Apollo.Mutation<EditOnboardingElementsMutation, EditOnboardingElementsMutationVariables> {
    document = EditOnboardingElementsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOnboardingElementIfExistsDocument = gql`
    query GetOnboardingElementIfExists($id: ElementId!) {
  element(id: $id) {
    ...OnboardingElement
  }
}
    ${OnboardingElementFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOnboardingElementIfExistsGQL extends Apollo.Query<GetOnboardingElementIfExistsQuery, GetOnboardingElementIfExistsQueryVariables> {
    document = GetOnboardingElementIfExistsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddBannedUsernamesDocument = gql`
    mutation AddBannedUsernames($input: AddBannedUsernamesInput!) {
  username {
    addBannedUsernames(input: $input) {
      success
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddBannedUsernamesGQL extends Apollo.Mutation<AddBannedUsernamesMutation, AddBannedUsernamesMutationVariables> {
    document = AddBannedUsernamesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBannedUsernamesDocument = gql`
    query GetBannedUsernames($meta: ListMetadataInput, $filter: BannedUsernamesListFiltersInput) {
  listBannedUsernames(meta: $meta, filters: $filter) {
    meta {
      count
      nextPageCursor
      pageCursor
    }
    items {
      ...BannedUsername
    }
  }
}
    ${BannedUsernameFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBannedUsernamesGQL extends Apollo.Query<GetBannedUsernamesQuery, GetBannedUsernamesQueryVariables> {
    document = GetBannedUsernamesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteBannedUsernamesDocument = gql`
    mutation DeleteBannedUsernames($input: DeletePremiumUsernamesInput!) {
  username {
    deleteBannedUsernames(input: $input) {
      success
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteBannedUsernamesGQL extends Apollo.Mutation<DeleteBannedUsernamesMutation, DeleteBannedUsernamesMutationVariables> {
    document = DeleteBannedUsernamesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ClustersDocument = gql`
    query Clusters($meta: ListMetadataInput!, $filters: ClusterListFilters, $sort: [SortDefinitionInput!]) {
  clusters(meta: $meta, filters: $filters, sortDefinitions: $sort) {
    items {
      ...Cluster
    }
    meta {
      nextPageCursor
      count
    }
  }
}
    ${ClusterFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ClustersGQL extends Apollo.Query<ClustersQuery, ClustersQueryVariables> {
    document = ClustersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ClusterDetailsDocument = gql`
    query clusterDetails($id: ClusterId!) {
  cluster(id: $id) {
    ...ClusterFields
  }
}
    ${ClusterFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ClusterDetailsGQL extends Apollo.Query<ClusterDetailsQuery, ClusterDetailsQueryVariables> {
    document = ClusterDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteClusterDocument = gql`
    mutation deleteCluster($ids: [ClusterId!]!) {
  admin {
    deleteClusters(input: {clusterIds: $ids}) {
      success
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteClusterGQL extends Apollo.Mutation<DeleteClusterMutation, DeleteClusterMutationVariables> {
    document = DeleteClusterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ClusterCollaboratorsDocument = gql`
    query ClusterCollaborators($id: ClusterId!, $meta: ListMetadataInput!) {
  cluster(id: $id) {
    id
    collaborators(meta: $meta) {
      items {
        ...ClusterCollaborator
      }
      meta {
        nextPageCursor
      }
    }
  }
}
    ${ClusterCollaboratorFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ClusterCollaboratorsGQL extends Apollo.Query<ClusterCollaboratorsQuery, ClusterCollaboratorsQueryVariables> {
    document = ClusterCollaboratorsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ClusterRevokeIviteDocument = gql`
    mutation ClusterRevokeIvite($clusterId: ClusterId!, $userId: UserId!) {
  cluster {
    revokeCollaboratorInvite(input: {clusterId: $clusterId, userId: $userId}) {
      success
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ClusterRevokeIviteGQL extends Apollo.Mutation<ClusterRevokeIviteMutation, ClusterRevokeIviteMutationVariables> {
    document = ClusterRevokeIviteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ClusterDeleteCollaboratorDocument = gql`
    mutation ClusterDeleteCollaborator($clusterId: ClusterId!, $userId: UserId!) {
  cluster {
    deleteCollaborator(input: {clusterId: $clusterId, userId: $userId}) {
      success
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ClusterDeleteCollaboratorGQL extends Apollo.Mutation<ClusterDeleteCollaboratorMutation, ClusterDeleteCollaboratorMutationVariables> {
    document = ClusterDeleteCollaboratorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InviteCollaboratorDocument = gql`
    mutation inviteCollaborator($clusterId: ClusterId!, $userId: UserId!) {
  cluster {
    inviteCollaborator(input: {clusterId: $clusterId, userId: $userId}) {
      success
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InviteCollaboratorGQL extends Apollo.Mutation<InviteCollaboratorMutation, InviteCollaboratorMutationVariables> {
    document = InviteCollaboratorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ClusterElementsDocument = gql`
    query ClusterElements($id: ClusterId!, $meta: ListMetadataInput!) {
  cluster(id: $id) {
    id
    elements(meta: $meta) {
      items {
        ...ClusterElement
      }
      meta {
        nextPageCursor
      }
    }
  }
}
    ${ClusterElementFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ClusterElementsGQL extends Apollo.Query<ClusterElementsQuery, ClusterElementsQueryVariables> {
    document = ClusterElementsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ClusterInvitesDocument = gql`
    query ClusterInvites($id: ClusterId!, $meta: ListMetadataInput!) {
  cluster(id: $id) {
    id
    collaborationInvites(meta: $meta) {
      items {
        ...ClusterInvite
      }
      meta {
        nextPageCursor
      }
    }
  }
}
    ${ClusterInviteFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ClusterInvitesGQL extends Apollo.Query<ClusterInvitesQuery, ClusterInvitesQueryVariables> {
    document = ClusterInvitesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ClusterRevokeInvitationDocument = gql`
    mutation ClusterRevokeInvitation($clusterId: ClusterId!, $email: String!) {
  cluster {
    revokeCollaboratorInvite(input: {clusterId: $clusterId, email: $email}) {
      success
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ClusterRevokeInvitationGQL extends Apollo.Mutation<ClusterRevokeInvitationMutation, ClusterRevokeInvitationMutationVariables> {
    document = ClusterRevokeInvitationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendEmailInviteDocument = gql`
    mutation sendEmailInvite($clusterId: ClusterId!, $email: String!) {
  cluster {
    inviteCollaborator(input: {clusterId: $clusterId, email: $email}) {
      success
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendEmailInviteGQL extends Apollo.Mutation<SendEmailInviteMutation, SendEmailInviteMutationVariables> {
    document = SendEmailInviteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ElementDetailsDocument = gql`
    query elementDetails($id: ElementId!) {
  element(id: $id) {
    ...ElementDetails
  }
}
    ${ElementDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ElementDetailsGQL extends Apollo.Query<ElementDetailsQuery, ElementDetailsQueryVariables> {
    document = ElementDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteElementDocument = gql`
    mutation deleteElement($ids: [ElementId!]!) {
  admin {
    deleteElements(input: {elementIds: $ids}) {
      success
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteElementGQL extends Apollo.Mutation<DeleteElementMutation, DeleteElementMutationVariables> {
    document = DeleteElementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ElementsDocument = gql`
    query Elements($meta: ListMetadataInput!, $filters: ElementListFilters, $sort: [ElementSortDefinitionInput!]) {
  elements(meta: $meta, filters: $filters, sortDefinitions: $sort) {
    meta {
      count
      nextPageCursor
      pageCursor
    }
    items {
      ...Element
    }
  }
}
    ${ElementFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ElementsGQL extends Apollo.Query<ElementsQuery, ElementsQueryVariables> {
    document = ElementsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvitesDocument = gql`
    query Invites($sortDefinitions: [PersonalInviteCodeSortDefinitionInput!], $filters: PersonalInviteCodeListFilters, $meta: ListMetadataInput) {
  personalInviteCodeList(
    sortDefinitions: $sortDefinitions
    filters: $filters
    meta: $meta
  ) {
    items {
      userId
      inviteCode
      createdAt
      updatedAt
      username
      invitesLeft
      invitesUsed
    }
    meta {
      pageSize
      pageCursor
      nextPageCursor
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvitesGQL extends Apollo.Query<InvitesQuery, InvitesQueryVariables> {
    document = InvitesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PlatformSettingsDocument = gql`
    query platformSettings {
  platformSettings {
    defaultInviteCodeMaxUsageCount
    privacyPolicy
    privacyTerms
    signUpElementId
    loginElementId
    adminEmail
    maxNumberOfElementsForFreeUser
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PlatformSettingsGQL extends Apollo.Query<PlatformSettingsQuery, PlatformSettingsQueryVariables> {
    document = PlatformSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EditPlatformSettingsDocument = gql`
    mutation editPlatformSettings($input: EditPlatformSettingsInput!) {
  platformSettings {
    edit(input: $input) {
      maxNumberOfElementsForFreeUser
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditPlatformSettingsGQL extends Apollo.Mutation<EditPlatformSettingsMutation, EditPlatformSettingsMutationVariables> {
    document = EditPlatformSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IncreaseMaxUsageCountForUsersDocument = gql`
    mutation increaseMaxUsageCountForUsers($input: IncreaseMaxUsageCountForUsersInput!) {
  inviteCode {
    increaseMaxUsageCountForUsers(input: $input) {
      success
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IncreaseMaxUsageCountForUsersGQL extends Apollo.Mutation<IncreaseMaxUsageCountForUsersMutation, IncreaseMaxUsageCountForUsersMutationVariables> {
    document = IncreaseMaxUsageCountForUsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IncreaseMaxUsageCountForUsersWithZeroInvitesLeftDocument = gql`
    mutation increaseMaxUsageCountForUsersWithZeroInvitesLeft($input: IncreaseMaxUsageCountForUsersWithZeroInvitesLeftInput!) {
  inviteCode {
    increaseMaxUsageCountForUsersWithZeroInvitesLeft(input: $input) {
      success
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IncreaseMaxUsageCountForUsersWithZeroInvitesLeftGQL extends Apollo.Mutation<IncreaseMaxUsageCountForUsersWithZeroInvitesLeftMutation, IncreaseMaxUsageCountForUsersWithZeroInvitesLeftMutationVariables> {
    document = IncreaseMaxUsageCountForUsersWithZeroInvitesLeftDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BannedIpAddressesDocument = gql`
    query BannedIpAddresses($meta: ListMetadataInput!) {
  listDisallowedIpAddresses(meta: $meta) {
    items {
      ...BannedIpAddress
    }
    meta {
      pageSize
      pageCursor
      nextPageCursor
      count
    }
  }
}
    ${BannedIpAddressFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class BannedIpAddressesGQL extends Apollo.Query<BannedIpAddressesQuery, BannedIpAddressesQueryVariables> {
    document = BannedIpAddressesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DisallowIpAddressDocument = gql`
    mutation DisallowIpAddress($input: DisallowIpAddressInput!) {
  admin {
    disallowIpAddress(input: $input) {
      ...BannedIpAddress
    }
  }
}
    ${BannedIpAddressFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DisallowIpAddressGQL extends Apollo.Mutation<DisallowIpAddressMutation, DisallowIpAddressMutationVariables> {
    document = DisallowIpAddressDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllowIpAddressDocument = gql`
    mutation AllowIpAddress($input: AllowIpAddressInput!) {
  admin {
    allowIpAddress(input: $input) {
      success
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllowIpAddressGQL extends Apollo.Mutation<AllowIpAddressMutation, AllowIpAddressMutationVariables> {
    document = AllowIpAddressDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoginDocument = gql`
    mutation Login($input: LoginAsAdminInput!) {
  admin {
    loginAsAdmin(input: $input) {
      accessToken
      refreshToken
      user {
        id
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoginGQL extends Apollo.Mutation<LoginMutation, LoginMutationVariables> {
    document = LoginDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetUserPremiumDocument = gql`
    mutation SetUserPremium($userId: UserId!, $expirationDate: DateTime!) {
  admin {
    setPremiumSubscription(
      input: {userId: $userId, subscriptionExpirationDate: $expirationDate}
    ) {
      ...UserDetails
    }
  }
}
    ${UserDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SetUserPremiumGQL extends Apollo.Mutation<SetUserPremiumMutation, SetUserPremiumMutationVariables> {
    document = SetUserPremiumDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EditUsernameDocument = gql`
    mutation EditUsername($userId: UserId!, $username: String!) {
  auth {
    editUsername(input: {userId: $userId, username: $username}) {
      ...UserDetails
    }
  }
}
    ${UserDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class EditUsernameGQL extends Apollo.Mutation<EditUsernameMutation, EditUsernameMutationVariables> {
    document = EditUsernameDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EditUserEmailDocument = gql`
    mutation EditUserEmail($userId: UserId!, $name: String!, $email: String!) {
  auth {
    editProfile(input: {userId: $userId, name: $name, email: $email}) {
      ...UserDetails
    }
  }
}
    ${UserDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class EditUserEmailGQL extends Apollo.Mutation<EditUserEmailMutation, EditUserEmailMutationVariables> {
    document = EditUserEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserClustersDocument = gql`
    query UserClusters($meta: ListMetadataInput!, $filters: ClusterListFilters) {
  clusters(filters: $filters, meta: $meta) {
    items {
      ...UserClusters
    }
    meta {
      nextPageCursor
      count
    }
  }
}
    ${UserClustersFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UserClustersGQL extends Apollo.Query<UserClustersQuery, UserClustersQueryVariables> {
    document = UserClustersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserElementsDocument = gql`
    query UserElements($meta: ListMetadataInput!, $filters: ElementListFilters!) {
  elements(meta: $meta, filters: $filters) {
    meta {
      nextPageCursor
      count
    }
    items {
      ...UserElements
    }
  }
}
    ${UserElementsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UserElementsGQL extends Apollo.Query<UserElementsQuery, UserElementsQueryVariables> {
    document = UserElementsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserDetailsDocument = gql`
    query UserDetails($id: UserId!) {
  fullUser(id: $id) {
    ...UserDetails
  }
}
    ${UserDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UserDetailsGQL extends Apollo.Query<UserDetailsQuery, UserDetailsQueryVariables> {
    document = UserDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteUserDocument = gql`
    mutation DeleteUser($id: UserId!) {
  admin {
    deleteUser(input: {userId: $id}) {
      success
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteUserGQL extends Apollo.Mutation<DeleteUserMutation, DeleteUserMutationVariables> {
    document = DeleteUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UsersDocument = gql`
    query Users($meta: ListMetadataInput!, $filters: UserListFiltersInput, $sort: [UserSortDefinitionInput!]) {
  users(meta: $meta, filters: $filters, sortDefinitions: $sort) {
    meta {
      nextPageCursor
      count
    }
    items {
      ...Users
    }
  }
}
    ${UsersFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UsersGQL extends Apollo.Query<UsersQuery, UsersQueryVariables> {
    document = UsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCodeForNameEmailDocument = gql`
    mutation CreateCodeForNameEmail($input: CreateInviteCodesInput!) {
  inviteCode {
    create(input: $input) {
      success
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCodeForNameEmailGQL extends Apollo.Mutation<CreateCodeForNameEmailMutation, CreateCodeForNameEmailMutationVariables> {
    document = CreateCodeForNameEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResendInviteCodesEmailDocument = gql`
    mutation ResendInviteCodesEmail($input: ResendInviteCodesEmailInput!) {
  inviteCode {
    resend(input: $input) {
      success
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResendInviteCodesEmailGQL extends Apollo.Mutation<ResendInviteCodesEmailMutation, ResendInviteCodesEmailMutationVariables> {
    document = ResendInviteCodesEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResendAllPendingDocument = gql`
    mutation ResendAllPending {
  inviteCode {
    resendAll {
      success
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResendAllPendingGQL extends Apollo.Mutation<ResendAllPendingMutation, ResendAllPendingMutationVariables> {
    document = ResendAllPendingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetInviteCodeListDocument = gql`
    query GetInviteCodeList($meta: ListMetadataInput!, $sort: [InviteCodeSortDefinitionInput!], $filter: InviteCodeListFilters) {
  inviteCodeList(meta: $meta, sortDefinitions: $sort, filters: $filter) {
    meta {
      count
      nextPageCursor
      pageCursor
    }
    items {
      ...InviteCode
    }
  }
}
    ${InviteCodeFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetInviteCodeListGQL extends Apollo.Query<GetInviteCodeListQuery, GetInviteCodeListQueryVariables> {
    document = GetInviteCodeListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEmailListDocument = gql`
    query GetEmailList($sort: [InviteCodeSortDefinitionInput!]) {
  inviteCodeList(sortDefinitions: $sort) {
    items {
      ...InviteCode
    }
  }
}
    ${InviteCodeFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEmailListGQL extends Apollo.Query<GetEmailListQuery, GetEmailListQueryVariables> {
    document = GetEmailListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteInviteCodesDocument = gql`
    mutation DeleteInviteCodes($input: DeleteInviteCodesInput!) {
  inviteCode {
    delete(input: $input) {
      success
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteInviteCodesGQL extends Apollo.Mutation<DeleteInviteCodesMutation, DeleteInviteCodesMutationVariables> {
    document = DeleteInviteCodesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCodesWithoutEmailDocument = gql`
    mutation CreateCodesWithoutEmail($input: GenerateInviteCodesWithoutEmailInput!) {
  inviteCode {
    generateWithoutEmail(input: $input) {
      inviteCodes
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCodesWithoutEmailGQL extends Apollo.Mutation<CreateCodesWithoutEmailMutation, CreateCodesWithoutEmailMutationVariables> {
    document = CreateCodesWithoutEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WaitlistDocument = gql`
    query Waitlist($sortDefinitions: [WaitlistSortDefinitionInput!], $filters: WaitlistFilters, $meta: ListMetadataInput) {
  waitlist(sortDefinitions: $sortDefinitions, filters: $filters, meta: $meta) {
    items {
      email
      howHeardAboutUsAnswer
      waitlistItemStatus
      createdAt
      inviteCode {
        id
        email
        value
        name
        status
        grantsPremium
        createdAt
      }
    }
    meta {
      pageSize
      pageCursor
      nextPageCursor
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WaitlistGQL extends Apollo.Query<WaitlistQuery, WaitlistQueryVariables> {
    document = WaitlistDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const JoinManyDocument = gql`
    mutation JoinMany($input: JoinManyWaitlistInput!) {
  waitlist {
    joinMany(input: $input) {
      success
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class JoinManyGQL extends Apollo.Mutation<JoinManyMutation, JoinManyMutationVariables> {
    document = JoinManyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WaitlistStatsDocument = gql`
    query WaitlistStats {
  total: waitlist {
    meta {
      count
    }
  }
  pending: waitlist(filters: {status: PENDING}) {
    meta {
      count
    }
  }
  accepted: waitlist(filters: {status: ACCEPTED}) {
    meta {
      count
    }
  }
  notInvited: waitlist(filters: {status: NOT_INVITED}) {
    meta {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WaitlistStatsGQL extends Apollo.Query<WaitlistStatsQuery, WaitlistStatsQueryVariables> {
    document = WaitlistStatsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }